import type { TranslationKey } from './en'

export const es: Partial<Record<TranslationKey, string>> = {
  // Roles
  'role.viewer': 'visor',
  'role.contributor': 'colaborador',
  'role.editor': 'editor',
  'role.admin': 'admin',

  // Common nouns
  'common.taskSingular': 'tarea',
  'common.taskPlural': 'tareas',
    // Common nouns / actions
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.edit': 'Editar',
    'common.delete': 'Eliminar',
    'common.unknown': 'Desconocido',
    'common.unassigned': 'Sin asignar',
    'common.close': 'Cerrar',

    // Eliminación de fila de producción (confirmación de dos pasos compartida — registros de Biomasa + tabla de Base de datos)
    'productionRow.delete.confirm': 'Confirmar eliminación',
    'productionRow.delete.confirmWithEvents': 'Confirmar eliminación ({count} eventos vinculados)',
    'productionRow.delete.reasonPlaceholder': 'Motivo (obligatorio)',
    'productionRow.delete.reasonRequired': 'Escribe por qué se eliminan los registros vinculados.',
    'productionRow.delete.auditReason': 'Eliminado junto con su fila de producción: {reason}',
    'productionRow.delete.noLinkedReason': 'sin motivo',
    'datatable.duplicateMerge.auditReason': 'Filas duplicadas fusionadas en Base de datos',

  // App shell
  'app.loading': 'Cargando Sunday App...',
  'app.team': 'Equipo',
  'app.user': 'Usuario',
  'app.settings': 'Configuración',
  'app.teamName': 'Nombre del equipo',
  'app.save': 'Guardar',
  'app.signOut': 'Cerrar sesión',
  'app.newTask': 'Nueva tarea',

  // Sidebar
  'sidebar.ariaMainNav': 'Navegación principal',
  'sidebar.openNav': 'Abrir menú de navegación',
  'sidebar.closeNav': 'Cerrar menú de navegación',
  'sidebar.menu': 'Menú',
  'sidebar.close': 'Cerrar',

  // Nav items
  'nav.home': 'Inicio',
  'nav.database': 'Base de datos',
  'nav.water': 'Agua',
  'nav.feed': 'Alimento',
  'nav.warehouse': 'Inventario',
  'nav.sampling': 'Biomasa',
  'nav.lots': 'Lotes',
  'nav.tasks': 'Tareas',
  'nav.reports': 'Reportes',
  'nav.costs': 'Costos',
  'nav.collaboration': 'Colaboración',
  'nav.dashboard': 'Panel',
  'nav.mortalityMatrix': 'Matriz de mortalidad',
  'nav.sfrMatrix': 'Matriz SFR',
  'nav.crewMode': 'Crew Mode',

  // Quick actions
  'qa.signIn': 'Iniciar sesión',
  'qa.imports': 'Importaciones',
  'qa.collaboration': 'Colaboración',
  'qa.communityProfile': 'Perfil comunitario',
  'qa.communityDeliveries': 'Historias de lote entregadas',
  'qa.ownerConsole': 'Consola del dueño',
  'qa.newFarm': 'Nueva granja',
  'qa.editFarm': 'Editar instalación',
  'qa.mortalityMatrix': 'Matriz de mortalidad',
  'qa.sfrMatrix': 'Matriz SFR',

  'communityProfile.title': 'Perfil comunitario',
  'communityProfile.subtitle': 'Define la identidad de presentación que la futura colaboración confiable con socios podrá mostrar sin cambiar tu membresía del tenant ni tus permisos.',
  'communityProfile.loading': 'Cargando perfil…',
  'communityProfile.error.loadFailed': 'Falló la carga del perfil comunitario',
  'communityProfile.error.saveFailed': 'Falló el guardado del perfil comunitario',
  'communityProfile.status.saved': 'Perfil guardado.',
  'communityProfile.identity.title': 'Identidad actual',
  'communityProfile.identity.accountName': 'Nombre de la cuenta:',
  'communityProfile.identity.actor': 'Actor:',
  'communityProfile.identity.role': 'Rol de membresía:',
  'communityProfile.identity.membership': 'ID de membresía:',
  'communityProfile.editor.title': 'Perfil de presentación',
  'communityProfile.editor.subtitle': 'Esta es la capa de presentación para la colaboración comunitaria. Los permisos siguen viniendo de la membresía del tenant y de las reglas de membresía de grupo.',
  'communityProfile.editor.displayNameLabel': 'Nombre público para mostrar',
  'communityProfile.editor.displayNamePlaceholder': 'Cómo deberían ver tu nombre los socios',
  'communityProfile.editor.displayNameHint': 'Déjalo vacío para seguir usando el nombre actual de la cuenta.',
  'communityProfile.editor.publicBioLabel': 'Bio pública',
  'communityProfile.editor.publicBioPlaceholder': 'Contexto breve sobre tu rol, especialidad o alcance de colaboración confiable',
  'communityProfile.editor.publicBioHint': 'Mantenlo breve y factual. Es identidad de presentación, no una regla de aprobación o permisos.',
  'communityProfile.editor.note': 'Los datos del perfil comunitario siguen siendo online-first y por sí solos no cambian la visibilidad de los artefactos.',
  'communityProfile.action.save': 'Guardar perfil',
  'communityProfile.action.saving': 'Guardando…',
  'communityProfile.access.title': 'Contexto actual de acceso',
  'communityProfile.access.subtitle': 'Este es el contexto explícito de membresía que futuras reglas de compartición pueden consumir sin adivinar a partir del token solamente.',
  'communityProfile.access.privateContext': 'Contexto privado',
  'communityProfile.access.membershipRole': 'Rol del tenant',
  'communityProfile.access.activeGroups': 'Grupos activos',
  'communityProfile.access.invitedGroups': 'Grupos invitados',
  'communityProfile.access.revokedGroups': 'Grupos revocados',
  'communityProfile.access.empty': 'Todavía no hay contextos de grupo. El acceso actual es solo del tenant.',
  'communityProfile.access.groupId': 'ID del grupo',
  'communityProfile.access.groupRole': 'Rol del grupo',
  'communityProfile.access.membershipStatus': 'Estado de la membresía',
  'communityProfile.access.groupMembershipId': 'ID de la membresía del grupo',
  'communityProfile.access.partnerOrganization': 'Organización asociada',
  'communityProfile.access.none': 'Ninguna',
  'communityDeliveries.title': 'Historias de lote entregadas',
  'communityDeliveries.subtitle': 'Revisa los snapshots que tus membresías activas en grupos socios pueden recibir actualmente a través del límite estrecho de entrega GROUP.',
  'communityDeliveries.error.loadFailed': 'Falló la carga de las historias de lote entregadas',
  'communityProfile.groupDeliveries.title': 'Historias de lote entregadas',
  'communityProfile.groupDeliveries.subtitle': 'Usa un contexto activo de grupo para descubrir los snapshots de lot story actualmente promovidos que están disponibles a través del límite de entrega para receptores.',
  'communityProfile.groupDeliveries.noActiveGroups': 'Todavía no hay un contexto activo de grupo para entrega.',
  'communityProfile.groupDeliveries.groupSelect': 'Grupo activo para entrega',
  'communityProfile.groupDeliveries.loading': 'Cargando historias de lote entregadas…',
  'communityProfile.groupDeliveries.empty': 'No hay historias de lote entregadas disponibles actualmente para este grupo activo.',
  'communityProfile.groupDeliveries.count': '{count} historias de lote entregadas disponibles',
  'communityProfile.groupDeliveries.publishedAt': 'Publicado el',
  'communityProfile.groupDeliveries.open': 'Abrir snapshot de entrega',
  'communityProfile.groupDeliveries.opening': 'Abriendo…',
  'communityProfile.groupDeliveries.opened': 'Snapshot abierto',
  'communityProfile.groupDeliveries.placeholder': 'Selecciona una historia de lote entregada para abrir su snapshot actual.',
  'communityProfile.groupDeliveries.context.title': 'Contexto actual de acceso a la entrega',
  'communityProfile.groupDeliveries.context.subtitle': 'Esto muestra la identidad viva del receptor y el contexto del grupo seleccionado antes de abrir cualquier snapshot entregado.',
  'communityProfile.groupDeliveries.context.selectedGroup': 'Grupo seleccionado actual',
  'communityProfile.groupDeliveries.context.selectedGroupRole': 'Rol actual en el grupo seleccionado',
  'communityProfile.groupDeliveries.list.selectedGroup': 'Grupo seleccionado vivo',
  'communityProfile.groupDeliveries.list.selectedGroupRole': 'Rol vivo en el grupo seleccionado',
  'communityProfile.groupDeliveries.list.grantedGroup': 'Grupo guardado para la entrega',
  'communityProfile.groupDeliveries.list.grantedGroupRole': 'Rol guardado del grupo concedido',
  'communityProfile.groupDeliveries.list.partner': 'Organización socia viva',
  'communityProfile.groupDeliveries.list.publishedBy': 'Publicado guardado por',
  'communityProfile.groupDeliveries.list.selectedMatch': 'El grupo seleccionado coincide con la entrega',
  'communityProfile.groupDeliveries.snapshot.title': 'Resumen del snapshot',
  'communityProfile.groupDeliveries.snapshot.readiness': 'Readiness del snapshot',
  'communityProfile.groupDeliveries.error.listFailed': 'Falló la carga de las historias de lote entregadas',
  'communityProfile.groupDeliveries.error.detailFailed': 'Falló la carga del snapshot de la historia de lote entregada',
  'collaborationLibrary.title': 'Colaboración',
  'collaborationLibrary.subtitle': 'Biblioteca de artefactos para Colaboración. Esta fase lista snapshots de reportes publicados y lot stories promovidos a grupo.',
  'collaborationLibrary.loading': 'Cargando artefactos de colaboración…',
  'collaborationLibrary.error.loadFailed': 'No se pudo cargar la biblioteca de artefactos de colaboración en este momento.',
  'collaborationLibrary.searchLabel': 'Buscar artefactos',
  'collaborationLibrary.searchPlaceholder': 'Busca por título, contexto o resumen',
  'collaborationLibrary.statusFilterLabel': 'Filtrar por estado',
  'collaborationLibrary.statusFilter.all': 'Todos los estados',
  'collaborationLibrary.visibilityFilterLabel': 'Filtrar por visibilidad',
  'collaborationLibrary.visibilityFilter.all': 'Todas las visibilidades',
  'collaborationLibrary.refresh': 'Actualizar biblioteca',
  'collaborationLibrary.count': '{visible} visibles · {total} total',
  'collaborationLibrary.type.reportSnapshot': 'Snapshot de reporte',
  'collaborationLibrary.type.lotStory': 'Lot story',
  'collaborationLibrary.status.draft': 'Borrador',
  'collaborationLibrary.status.published': 'Publicado',
  'collaborationLibrary.status.archived': 'Archivado',
  'collaborationLibrary.status.revoked': 'Revocado',
  'collaborationLibrary.visibility.private': 'Privado',
  'collaborationLibrary.visibility.group': 'Grupo',
  'collaborationLibrary.visibility.agora': 'Agora',
  'collaborationLibrary.meta.version': 'Versión actual:',
  'collaborationLibrary.meta.visibility': 'Visibilidad:',
  'collaborationLibrary.meta.ownerTenant': 'Tenant dueño:',
  'collaborationLibrary.meta.publishedAt': 'Publicado el:',
  'collaborationLibrary.meta.updatedAt': 'Actualizado el:',
  'collaborationLibrary.meta.notPublishedYet': 'Todavía no publicado',
  'collaborationLibrary.meta.unknown': 'Desconocido',
  'collaborationLibrary.action.openDetail': 'Abrir detalle del artefacto',
  'collaborationLibrary.action.openSource': 'Abrir pantalla fuente',
  'collaborationLibrary.action.detailComingSoon': 'El detalle del artefacto viene después.',
  'collaborationLibrary.empty.title': 'Todavía no hay artefactos',
  'collaborationLibrary.empty.subtitle': 'Publica desde Reportes o promueve un lot story desde Lotes y luego vuelve aquí para organizar y encontrar artefactos de Colaboración.',
  'collaborationLibrary.empty.openReports': 'Abrir Reportes',
  'collaborationLibrary.empty.openLots': 'Abrir Lotes',
  'collaborationLibrary.empty.noResultsTitle': 'No hay artefactos que coincidan',
  'collaborationLibrary.empty.noResultsSubtitle': 'Prueba otro término de búsqueda, otro filtro de estado, otro filtro de visibilidad o actualiza la biblioteca.',
  'collaborationDetail.action.backToLibrary': 'Volver a la biblioteca de artefactos',
  'collaborationDetail.loading': 'Cargando detalle del artefacto…',
  'collaborationDetail.notFound.title': 'Artefacto no encontrado',
  'collaborationDetail.notFound.subtitle': 'Este detalle de artefacto no está disponible en la biblioteca del tenant actual.',
  'collaborationDetail.section.overview': 'Resumen',
  'collaborationDetail.section.provenance': 'Proveniencia',
  'collaborationDetail.section.preview': 'Preview del snapshot',
  'collaborationDetail.section.versions': 'Versiones',
  'collaborationDetail.section.actions': 'Acciones del lifecycle',
  'collaborationDetail.meta.dataset': 'Dataset:',
  'collaborationDetail.meta.generatedAt': 'Generado el:',
  'collaborationDetail.meta.rows': 'Filas:',
  'collaborationDetail.meta.columns': 'Columnas:',
  'collaborationDetail.preview.scopeTitle': 'Scope guardado',
  'collaborationDetail.preview.sampleTitle': 'Filas de muestra',
  'collaborationDetail.preview.sampleEmpty': 'No se capturaron filas de preview para este snapshot.',
  'collaborationDetail.preview.sampleTruncatedNote': 'Mostrando {shown} de {total} filas.',
  'collaborationDetail.preview.sampleTruncatedLink': 'Ver el reporte completo en Reportes',
  'collaborationDetail.preview.scopeNone': 'Sin scope guardado',
  'collaborationDetail.preview.scopeFrom': 'Desde {date}',
  'collaborationDetail.preview.scopeTo': 'Hasta {date}',
  'collaborationDetail.preview.scopeFacilities': '{count} instalaciones',
  'collaborationDetail.preview.scopeProductionUnits': '{count} unidades de producción',
  'collaborationDetail.preview.scopeLots': '{count} lotes',
  'collaborationDetail.provenance.source': 'Pantalla fuente:',
  'collaborationDetail.provenance.sourceEntity': 'Entidad fuente:',
  'collaborationDetail.provenance.publishedBy': 'Publicado por:',
  'collaborationDetail.provenance.notAvailable': 'No disponible',
  'collaborationDetail.provenance.lifecycle': 'Historial del lifecycle',
  'collaborationDetail.versions.publishedAt': 'Publicado el',
  'collaborationDetail.versions.notPublished': 'No publicado',
  'collaborationDetail.versionStatus.published': 'Publicado',
  'collaborationDetail.versionStatus.superseded': 'Reemplazado',
  'collaborationDetail.versionStatus.revoked': 'Revocado',
  'collaborationDetail.actions.none': 'No hay acciones de lifecycle disponibles actualmente para este artefacto.',
  'collaborationDetail.actions.note': 'Archivar y revocar ya están conectados en esta fase del detalle. Los demás controles del lifecycle siguen pendientes.',
  'collaborationDetail.actions.ownerManagedInSource': 'El lifecycle del lot story y las acciones del owner se mantienen en Lotes.',
  'collaborationDetail.actions.createDraft': 'Crear borrador',
  'collaborationDetail.actions.refreshDraft': 'Actualizar snapshot del borrador',
  'collaborationDetail.actions.publish': 'Publicar',
  'collaborationDetail.actions.revoke': 'Revocar',
  'collaborationDetail.actions.archive': 'Archivar',
  'collaborationDetail.actions.revokeSuccess': 'Artefacto revocado. El snapshot publicado sigue disponible para historial y revisión.',
  'collaborationDetail.actions.revokeError': 'No se pudo revocar este artefacto ahora mismo.',
  'collaborationDetail.actions.archiveSuccess': 'Artefacto archivado. Sigue disponible en la librería con estado archivado.',
  'collaborationDetail.actions.archiveError': 'No se pudo archivar este artefacto ahora mismo.',

  // Start
  'start.title': 'Comenzar',
  'start.welcomeNamed': 'Bienvenido, {name}',
  'start.welcomeAnon': 'Bienvenido — ¿listo para configurar tu instalación?',
  'start.createFacility': 'Crear nueva instalación',

  // New farm
  'newFarm.title': 'Configuración de nueva instalación',
  'newFarm.subtitle': 'Crea el perfil de tu instalación acuícola para comenzar a registrar producción, monitorear la calidad del agua y gestionar el stock.',
  'newFarm.progress.step': 'Paso {current} de {total}: {label}',
  'newFarm.progress.step1Label': 'Información de la instalación',

  'newFarm.alert.readOnlyCreate': 'Acceso de solo lectura: este token no puede crear instalaciones.',
  'newFarm.alert.enterName': 'Ingresa el nombre de la instalación',
  'newFarm.alert.enterTimeZone': 'Ingresa la zona horaria de la instalación',
  'newFarm.alert.invalidTimeZone': 'Ingresa una zona horaria IANA válida (p. ej., America/Chicago)',
  'newFarm.alert.saveFailed': 'No se pudo guardar esta instalación localmente. Inténtalo de nuevo.',

  'newFarm.field.name.label': 'Nombre de la instalación',
  'newFarm.field.name.placeholder': 'p. ej., Instalación Acuícola Riverside',
  'newFarm.field.name.hint': 'Elige un nombre descriptivo para tu operación acuícola',

  'newFarm.field.facilityType.label': 'Tipo de instalación',
  'newFarm.field.facilityType.hint': 'Elige si esta instalación opera como granja o como planta de procesamiento.',
  'newFarm.facilityType.farm': 'Granja',
  'newFarm.facilityType.processingPlant': 'Planta de procesamiento',

  'newFarm.field.classification.label': 'Clasificación de la instalación',
  'newFarm.field.classification.hint': 'Selecciona el nivel de intensidad de tu operación acuícola',
  'newFarm.field.classification.other.label': 'Clasificación personalizada',
  'newFarm.field.classification.other.placeholder': 'Ingresa tu clasificación personalizada',
  'newFarm.field.classification.other.hint': 'Describe la clasificación particular de tu instalación',

  'newFarm.classification.extensive': 'Extensiva - Baja densidad, alimentación natural',
  'newFarm.classification.semiIntensive': 'Semi-intensiva - Densidad moderada, alimentación suplementaria',
  'newFarm.classification.intensive': 'Intensiva - Alta densidad, alimentación totalmente artificial',
  'newFarm.classification.other': 'Otro - Clasificación personalizada',

  'newFarm.field.geography.label': 'Entorno geográfico',
  'newFarm.field.geography.hint': 'Selecciona el entorno de agua donde opera tu instalación',
  'newFarm.field.geography.other.label': 'Geografía personalizada',
  'newFarm.field.geography.other.placeholder': 'Ingresa tu geografía personalizada',
  'newFarm.field.geography.other.hint': 'Describe el entorno geográfico particular de tu instalación',

  'newFarm.geography.lake': 'Lago - Entorno de lago de agua dulce',
  'newFarm.geography.river': 'Río - Sistema de agua dulce con flujo',
  'newFarm.geography.ocean': 'Océano - Entorno marino de agua salada',
  'newFarm.geography.estuary': 'Estuario - Entorno de agua salobre',
  'newFarm.geography.inlandSeawater': 'Agua de mar interior - Agua salada en tierra',
  'newFarm.geography.inlandFreshwater': 'Agua dulce interior - Agua dulce en tierra',
  'newFarm.geography.other': 'Otro - Geografía personalizada',

  'newFarm.field.altitude.label': 'Altitud de la instalación',
  'newFarm.field.altitude.hint': 'Elevación en metros sobre el nivel del mar (afecta los cálculos de oxígeno disuelto)',

  'newFarm.field.timeZone.label': 'Zona horaria',
  'newFarm.field.timeZone.placeholder': 'p. ej., America/Chicago',
  'newFarm.field.timeZone.errorInvalid': 'Zona horaria IANA inválida (p. ej., America/Chicago)',
  'newFarm.field.timeZone.hint': 'Se usa para agrupar por día/semana entre dispositivos; por defecto toma la zona horaria del navegador',

  'newFarm.button.creating': 'Creando instalación...',
  'newFarm.button.createContinue': 'Crear instalación y continuar',
  'newFarm.button.backHome': '← Volver al inicio',
  'newFarm.help.alert': 'Ayuda: Este formulario crea el perfil de tu instalación para gestión acuícola.',
  'newFarm.status.createdLocal': 'La instalación quedó guardada localmente. La sincronización con el servidor sigue pendiente.',
  'newFarm.status.createdOffline': 'La instalación quedó guardada localmente sin conexión. Se sincronizará cuando vuelvas a conectarte.',
  'newFarm.status.createdSynced': 'La instalación quedó creada y sincronizada.',

  'newFarm.card.nextSteps.title': 'Próximos pasos',
  'newFarm.card.nextSteps.bodyFarm': 'Después de crear tu instalación, configurarás tipos de cultivo, seleccionarás especies y definirás unidades de producción.',
  'newFarm.card.nextSteps.bodyProcessingPlant': 'Después de crear tu planta de procesamiento, podrás registrar sitios de procesamiento y comenzar a recibir transferencias de lotes sin pasar por la configuración exclusiva de granja.',
  'newFarm.card.security.title': 'Seguridad de datos',
  'newFarm.card.security.body': 'Los datos de tu instalación se almacenan localmente y de forma segura. Mantienes el control total de tu información.',

  // Edit farm
  'editFarm.title': 'Editar instalación',
  'editFarm.subtitle': 'Gestiona instalaciones, unidades de producción y datos sin conexión.',

  'editFarm.action.export': 'Exportar',
  'editFarm.action.import': 'Importar',

  'editFarm.alert.readOnlyExport': 'Acceso de solo lectura: este token no puede exportar datos de instalaciones.',
  'editFarm.alert.readOnlyImport': 'Acceso de solo lectura: este token no puede importar datos de instalaciones.',

  'editFarm.alert.exportSuccess': '✅ Datos exportados correctamente. Guarda este archivo para importarlo en otros navegadores.',
  'editFarm.alert.exportFailed': '❌ Falló la exportación. Revisa la consola para más detalles.',
  'editFarm.confirm.tenantMismatch':
    '⚠️ Esta exportación fue creada para el tenant "{importTenantKey}".\nActualmente estás en el tenant "{tenantKey}".\n\n¿Importar de todos modos en el tenant actual?',
  'editFarm.confirm.importSummary':
    '📥 Importar datos con:\n• {facilities} instalaciones\n• {tasks} tareas\n• {water} conjuntos de datos de agua\n• {other} otros elementos de datos\n\nEsto reemplazará todos los datos actuales.',
  'editFarm.alert.importSuccess': '✅ Datos importados correctamente. Se restauraron datos de instalación, base de datos y agua.',
  'editFarm.alert.invalidDataFormat': '❌ Formato de datos inválido. Selecciona un archivo de exportación válido de Sunday App.',
  'editFarm.alert.importFailed': '❌ Falló la importación. Revisa el formato del archivo.',
  'editFarm.status.changeOffline': 'Los cambios se guardaron localmente sin conexión. Se sincronizarán cuando te reconectes.',
  'editFarm.status.changePending': 'Los cambios se guardaron localmente. La sincronización con el servidor está pendiente.',
  'editFarm.status.changeSynced': 'Los cambios se guardaron y sincronizaron.',
  'editFarm.status.deleteOffline': 'La eliminación se guardó localmente sin conexión. Se sincronizará cuando te reconectes.',
  'editFarm.status.deletePending': 'La eliminación se guardó localmente. La sincronización con el servidor está pendiente.',
  'editFarm.status.deleteSynced': 'La eliminación se sincronizó.',
  'editFarm.status.refreshing': 'Sincronizando cambios pendientes con el servidor...',
  'editFarm.status.refreshComplete': 'Los cambios pendientes se sincronizaron.',
  'editFarm.status.saveFailed': 'No se pudieron guardar los cambios de la instalación. Inténtalo de nuevo.',
  'editFarm.status.deleteFailed': 'No se pudieron eliminar los datos de la instalación. Inténtalo de nuevo.',
  'editFarm.sync.blocked': '{count} cambio(s) de instalaciones están bloqueados por errores de sincronización.',
  'editFarm.sync.blockedWithReason': '{count} cambio(s) de instalaciones están bloqueados: {reason}',
  'editFarm.sync.offline': 'Los cambios de instalaciones están en cola local porque este dispositivo está sin conexión.',
  'editFarm.sync.pending': 'Los cambios de instalaciones están en cola y pendientes de sincronización.',
  'editFarm.sync.retryAction': 'Reintentar sincronización',
  'editFarm.sync.retrying': 'Reintentando sincronización...',
  'editFarm.sync.retrySynced': 'La sincronización de instalaciones se completó.',
  'editFarm.sync.retryOffline': 'Aún sin conexión. Los cambios de instalaciones siguen en cola local.',
  'editFarm.sync.retryPending': 'Los cambios de instalaciones siguen pendientes de sincronización.',
  'editFarm.sync.retryResolvedMissing': 'Se omitieron {count} cambio(s) faltantes obsoletos durante el reintento.',
  'editFarm.sync.retryFailed': 'No se puede reintentar la sincronización de instalaciones ahora.',
  'editFarm.sync.refreshAction': 'Actualizar instalaciones',
  'editFarm.sync.refreshing': 'Actualizando instalaciones...',
  'editFarm.sync.refreshComplete': 'Instalaciones actualizadas.',
  'editFarm.sync.refreshFailed': 'No se pueden actualizar las instalaciones ahora.',
  'editFarm.sync.lastResult': 'Último resultado de sincronización: {result}',
  'editFarm.sync.lastAttempted': 'Último intento: {time}',

  'editFarm.confirm.sensitiveChange': '⚠️ Este cambio puede impactar cálculos y sincronización. ¿Guardar cambios en "{field}"?',
  'editFarm.confirm.confirmCta': 'Confirmar',
  'editFarm.confirm.importCta': 'Importar',
  'editFarm.sensitiveField.facilityType': 'Tipo de instalación',
  'editFarm.sensitiveField.altitude': 'Altitud',
  'editFarm.sensitiveField.timeZone': 'Zona horaria',
  'editFarm.sensitiveField.speciesPreset': 'Preset de especie',
  'editFarm.alert.demoCreated': '✅ Instalación demo creada correctamente.',

  'editFarm.chip.facilitySpecies': 'Instalación: {facility} • Especie: {species}',
  'editFarm.chip.processingPlant': 'Instalación: {facility} • Planta de procesamiento',
  'editFarm.panel.facilitiesCount': 'Instalaciones ({count})',
  'editFarm.block.identity': 'Identidad de instalación',
  'editFarm.block.sensitiveConfig': 'Configuración sensible',
  'editFarm.block.productionUnits': 'Unidades productivas',
  'editFarm.block.maintenance': 'Acciones de mantenimiento',
  'editFarm.tabs.ariaLabel': 'Secciones de la instalación',
  'editFarm.tab.general': 'General',
  'editFarm.tab.units': 'Unidades',
  'editFarm.tab.culture': 'Cultivo',
  'editFarm.tab.advanced': 'Avanzado',
  'editFarm.general.discard': 'Descartar cambios',
  'editFarm.general.unsaved': 'Hay cambios sin guardar.',
  'editFarm.units.openHint': 'Haz clic en una unidad para editarla, ver sus planes de Crew Mode o eliminarla.',
  'editFarm.units.col.name': 'Nombre',
  'editFarm.units.col.type': 'Tipo',
  'editFarm.units.col.status': 'Estado',
  'editFarm.units.col.crewOrder': 'Orden en Crew Mode',
  'editFarm.units.status.active': 'Activa',
  'editFarm.units.panelTitle': 'Unidad: {unit}',
  'editFarm.units.delete': 'Eliminar unidad',
  'editFarm.culture.defaultsTitle': 'Valores por defecto del cultivo',
  'editFarm.culture.defaultsHelp': 'Valores con los que parten los lotes de esta instalación: proyección de lotes e incubación de ovas. Abajo, qué flujos de Crew Mode están activos.',
  'editFarm.advanced.syncTitle': 'Sincronización y estado',
  'editFarm.advanced.dangerTitle': 'Zona de peligro',
  'editFarm.advanced.dangerHelp': 'Eliminar una instalación no se puede deshacer. Una instalación con registros no se puede eliminar: márcala Inactiva.',
  'editFarm.search.placeholder': 'Buscar instalaciones por nombre',
  'editFarm.search.clear': 'Limpiar',
  'editFarm.empty.noFacilities': 'No se encontraron instalaciones',
  'editFarm.fallback.firstFarmShown': 'No se encontró selección de instalación en la URL ni en el contexto activo. Mostrando la primera instalación de la lista — elige otra a la izquierda si no era la que querías.',

  'editFarm.item.pusCount': 'PUs: {count}',
  'editFarm.item.created': 'Creado: {date}',
  'editFarm.common.na': 'N/D',

  'editFarm.details.title': 'Detalles de la instalación',
  'editFarm.details.deleteFacility': 'Eliminar instalación',
  'editFarm.delete.needsConnection': 'Eliminar necesita conexión: el servidor revisa primero si aún tiene registros.',
  'editFarm.delete.checkFailed': 'No se pudo revisar si tiene registros. No se eliminó nada — inténtalo de nuevo.',
  'editFarm.delete.blockedTitle': 'Aún tiene registros',
  'editFarm.delete.blockedFarmBody': 'Esta instalación aún tiene {count} registros (alimento, mortalidad, muestreos, agua, stock, costos, lotes…). No se puede eliminar.',
  'editFarm.delete.blockedUnitBody': 'Esta unidad aún tiene {count} registros (alimento, mortalidad, muestreos, agua, stock, costos, lotes…). No se puede eliminar.',
  'editFarm.delete.blockedWhy': 'Los registros se conservan al menos 5 años. Márcala como Inactiva: su historial sigue en los reportes y ya no se le pueden agregar registros nuevos.',
  'editFarm.delete.markInactive': 'Marcar como inactiva',
  'editFarm.status.inactiveFacility': 'Instalación inactiva',
  'editFarm.status.inactiveFacilityHelp': 'Conserva todos sus registros e historial; ya no aparece en Crew Mode.',
  'editFarm.status.inactiveUnit': 'Inactiva',
  'editFarm.status.inactiveUnitHelp': 'Conserva todos sus registros e historial; ya no aparece en Crew Mode.',
  'editFarm.status.unitHasActiveLot': 'Tiene un lote activo ({lots}): cosecha o mueve el lote antes de dejar la unidad inactiva.',
  'editFarm.crew.hidden': 'Oculta en Crew Mode',
  'editFarm.crew.order': 'Orden en Crew Mode: {position}',
  'editFarm.crew.moveUp': 'Subir en Crew Mode',
  'editFarm.crew.moveDown': 'Bajar en Crew Mode',
  'editFarm.plans.title': 'Planes para Crew Mode',
  'editFarm.plans.edit': 'Editar planes',
  'editFarm.plans.feedLabel': 'Plan de alimento',
  'editFarm.plans.samplingLabel': 'Muestreo planificado',
  'editFarm.plans.waterLabel': 'Parámetros de agua',
  'editFarm.plans.feedNone': 'sin plan (el equipo elige; se sugiere el último alimento usado)',
  'editFarm.plans.feedSummary': '{kg} kg/día de {feed} en {feedings} tomas ({ration} kg por toma)',
  'editFarm.plans.feedSummaryPerFeeding': '{feeds} por día en {feedings} tomas',
  'editFarm.plans.feedSummaryMode': '{feeds} por día · {mode}',
  'editFarm.plans.secondFeed': 'Segundo alimento (opcional)',
  'editFarm.plans.noSecondFeed': 'Ninguno',
  'editFarm.plans.error.secondFeed': 'El segundo alimento debe ser otro alimento, con kg por día mayor que 0 (o déjalo en Ninguno).',
  'editFarm.plans.mode': 'Cómo registra el equipo',
  'editFarm.plans.mode.perFeeding': 'Por toma',
  'editFarm.plans.mode.dayTotal': 'Total del día',
  'editFarm.plans.mode.weighed': 'Pesada del día',
  'editFarm.plans.mode.help': 'Por toma: el equipo registra cada toma (como hasta ahora). Total del día: una sola entrada con lo del día. Pesada del día: en la mañana anota lo que pesó y al final del día lo que sobró; Sunflow calcula lo dado.',
  'editFarm.plans.missingFeed': '(alimento no disponible)',
  'editFarm.plans.staleFeed': 'este alimento ya no está disponible, Crew Mode ignora el plan',
  'editFarm.plans.samplingNone': 'sin plan',
  'editFarm.plans.samplingSummary': '{count} peces, solo peso',
  'editFarm.plans.samplingSummaryLength': '{count} peces, peso y longitud',
  'editFarm.plans.waterAll': 'los cuatro',
  'editFarm.plans.feed': 'Alimento o mezcla',
  'editFarm.plans.noPlan': 'Sin plan',
  'editFarm.plans.kgPerDay': 'kg por día',
  'editFarm.plans.feedingsPerDay': 'Tomas por día',
  'editFarm.plans.fishCount': 'Número de peces',
  'editFarm.plans.measureLength': 'Medir longitud',
  'editFarm.plans.samplingLot': 'Lote',
  'editFarm.plans.anyLot': 'Lote actual',
  'editFarm.plans.waterHelp': 'Ninguno marcado = el equipo ve temperatura, pH, oxígeno y salinidad; el caudal solo si lo marcas.',
  'editFarm.plans.error.feed': 'Elige el alimento del plan, o borra kg por día y tomas.',
  'editFarm.plans.error.kgPerDay': 'Ingresa kg por día mayor que 0.',
  'editFarm.plans.error.feedings': 'Las tomas por día deben ser un número entero de 1 a 24.',
  'editFarm.plans.error.fishCount': 'El número de peces debe ser un entero de 1 a 1000.',
  'editFarm.details.facilityName': 'Nombre de la instalación',
  'editFarm.details.facilityType.label': 'Tipo de instalación',
  'editFarm.details.facilityType.meta': 'Controla qué superficies de configuración se muestran aquí',
  'editFarm.details.facilityType.farm': 'Instalación de cultivo',
  'editFarm.details.facilityType.processingPlant': 'Planta de procesamiento',
  'editFarm.details.facilityType.helpFarm': 'Las instalaciones de cultivo usan unidades de producción y presets de especie para operaciones de cultivo y engorde.',
  'editFarm.details.facilityType.helpProcessingPlant': 'Las plantas de procesamiento omiten la configuración exclusiva de instalaciones de cultivo para especies y unidades de producción. Usa los sitios de procesamiento de abajo para definir áreas de recepción, staging o despacho.',

  'editFarm.details.altitude.label': 'Altitud',
  'editFarm.details.altitude.unit': 'metros sobre el nivel del mar',
  'editFarm.details.altitude.help': 'Se usa para cálculos de oxígeno disuelto en el monitoreo de calidad del agua.',

  'editFarm.details.timeZone.label': 'Zona horaria',
  'editFarm.details.timeZone.meta': 'IANA (p. ej., America/Chicago)',
  'editFarm.details.timeZone.invalid': 'Zona horaria inválida. Usa un nombre IANA (p. ej., America/Chicago).',
  'editFarm.details.timeZone.help': 'Se usa para agrupar por día/semana; si falta o es inválida, la app usa la zona horaria del navegador.',

  // Server-Side Flag Enforcement v0 follow-up — admin-surface Crew Mode toggle (Charter O-4)
  'editFarm.crewMode.title': 'Crew Mode',
  'editFarm.crewMode.subtitle': 'Activa los flujos de captura de campo que los operarios pueden usar en esta granja.',
  'editFarm.crewMode.loading': 'Cargando ajustes de Crew Mode…',
  'editFarm.crewMode.loadError': 'No se pudieron cargar los ajustes de Crew Mode. Intenta de nuevo.',
  'editFarm.crewMode.saveError': 'No se pudo guardar ese cambio. Intenta de nuevo.',

  'editFarm.details.processingSites.label': 'Sitios de procesamiento',
  'editFarm.details.processingSites.meta': 'Una entrada por línea: site-id o site-id | Nombre visible',
  'editFarm.details.processingSites.placeholder': 'processing-site-a | Procesadora principal\nprocessing-site-b',
  'editFarm.details.processingSites.invalid': 'Corrige las {count} línea(s) inválidas de sitios de procesamiento antes de salir de este campo.',
  'editFarm.details.processingSites.help': 'Los sitios de procesamiento registrados alimentan los destinos de transferencia y los bloqueos de readiness de lot story para esta instalación.',

  'editFarm.details.speciesPreset.label': 'Preset de especie',
  'editFarm.details.speciesPreset.meta': 'Etiquetas y KPI por defecto',
  'editFarm.details.speciesPreset.helpFallback': 'Elige un preset que coincida con esta instalación.',

  'editFarm.productionUnits.title': 'Unidades de producción ({count})',
  'editFarm.productionUnits.addPu': 'Agregar PU',
  'editFarm.productionUnits.duplicateName': 'Ya existe una unidad «{name}» en esta instalación. Usa otro nombre.',
  'editFarm.productionUnits.empty': 'No se encontraron unidades de producción',
  'editFarm.productionUnits.puName': 'Nombre de PU',
  'editFarm.productionUnits.volume': 'Volumen',
  'editFarm.productionUnits.capacityPlaceholder': 'Capacidad',
  'editFarm.productionUnits.notSet': 'Sin definir',
  'editFarm.productionUnits.editVolume': 'Editar volumen',
  'editFarm.productionUnits.typePrefix': 'Tipo: {type}',

  'editFarm.empty.selectFacilityTitle': 'Selecciona una instalación para editar',
  'editFarm.empty.selectFacilityBody': 'Elige una instalación de la lista de la izquierda.',

  'editFarm.modal.confirmDeletionTitle': 'Confirmar eliminación',
  'editFarm.modal.confirmDeleteFarmBody':
    '¿Seguro que quieres eliminar esta instalación? Esto también eliminará todas sus unidades de producción y los datos asociados (registros de base de datos, datos de agua, etc.).',
  'editFarm.modal.confirmDeletePuBody':
    '¿Seguro que quieres eliminar esta unidad de producción? Esto también eliminará todos los datos asociados (registros de base de datos, datos de agua, etc.).',
  'editFarm.modal.cannotBeUndone': 'Esta acción no se puede deshacer.',

  // SFR management
  'sfrManagement.title': 'Matriz SFR',
  'sfrManagement.subtitle': 'Gestiona la matriz de Tasa de Alimentación Específica para cálculos acuícolas.',

  // Mortality management
  'mortalityManagement.title': 'Matriz de mortalidad',
  'mortalityManagement.subtitle': 'Gestiona la matriz de mortalidad esperada usada para la planificación de mortalidad vs condición.',
  'mortalityManagement.note.placeholderDefaults': 'Configura las tasas de mortalidad esperada para cada rango de temperatura y peso antes de usarlas en proyecciones. La trucha viene con una curva inicial; las demás especies comienzan en 0 hasta configurarlas.',
  'mortalityManagement.matrixTitle': 'Matriz de mortalidad esperada',
  'mortalityManagement.rowLabel': 'Peso',
  'mortalityManagement.columnLabel': 'Temperatura',
  'mortalityManagement.valueLabel': 'Mortalidad esperada (%)',
  'mortalityManagement.action.refreshMatrix': 'Actualizar matriz',
  'mortalityManagement.action.retry': 'Reintentar',
  'mortalityManagement.action.resetDefaults': 'Restablecer a valores por defecto',
  'mortalityManagement.action.resetting': 'Restableciendo...',
  'mortalityManagement.empty.title': 'Esta matriz aún no tiene valores',
  'mortalityManagement.empty.body': 'Todas las celdas siguen en 0. Esos ceros son marcadores de posición, no mortalidad medida: ingresa la tasa esperada para cada peso y temperatura antes de usar esta matriz en proyecciones.',
  'mortalityManagement.empty.bodyServer': 'El servidor todavía no tiene una matriz guardada para esta especie. Los ceros de abajo son marcadores de posición, no mortalidad medida: ingresa la tasa esperada para cada peso y temperatura para configurarla.',
  'mortalityManagement.confirm.resetDefaults': '¿Restablecer esta matriz de mortalidad a sus valores por defecto? Esto no se puede deshacer.',
  'mortalityManagement.confirm.resetCta': 'Confirmar restablecer',
  'mortalityManagement.status.loading': 'Cargando matriz de mortalidad...',
  'mortalityManagement.status.saving': 'Guardando cambios localmente...',
  'mortalityManagement.status.refreshing': 'Actualizando la matriz de mortalidad desde el servidor...',
  'mortalityManagement.status.offline': 'Cambios guardados localmente sin conexión. Se sincronizarán cuando vuelvas a conectarte.',
  'mortalityManagement.status.pending': 'Cambios guardados localmente. La sincronización con el servidor está pendiente.',
  'mortalityManagement.status.synced': 'Cambios sincronizados.',
  'mortalityManagement.status.refreshFailed': 'Se muestra la matriz de mortalidad local porque falló la actualización desde el servidor.',
  'mortalityManagement.status.refreshFailedBlank': 'No se pudo cargar la matriz de mortalidad guardada desde el servidor. No hay nada en caché local, así que todavía no hay nada que mostrar: reintenta cuando vuelvas a tener conexión.',
  'mortalityManagement.status.saveFailed': 'No se pudo guardar la matriz de mortalidad localmente. Inténtalo de nuevo.',

  'mortalityManagement.action.exportCsv': 'Exportar CSV',

  'mortalityManagement.profile.label': 'Perfil de instalación',
  'mortalityManagement.profile.option.speciesDefault': 'Matriz por defecto de la especie',
  'mortalityManagement.profile.help.noFacility': 'Selecciona una instalación para crear perfiles de mortalidad reutilizables y aplicarlos a unidades de producción o lotes.',
  'mortalityManagement.profile.help.facility': 'Los perfiles se guardan en la instalación seleccionada. Elige uno aquí para editarlo o mantente en la matriz por defecto de la especie.',
  'mortalityManagement.profile.summary.editingProfile': 'Editando perfil de instalación: {name}.',
  'mortalityManagement.profile.summary.editingSpeciesDefault': 'Editando la matriz compartida por defecto de la especie para {species}.',
  'mortalityManagement.profile.summary.appliedLot': 'El contexto actual se resuelve desde el lote {lot}: {profile}.',
  'mortalityManagement.profile.summary.appliedProductionUnit': 'El contexto actual se resuelve desde la unidad de producción {productionUnit}: {profile}.',
  'mortalityManagement.profile.summary.appliedFacilityDefault': 'El contexto actual se resuelve desde el perfil por defecto de la instalación {facility}: {profile}.',
  'mortalityManagement.profile.summary.appliedSpeciesDefault': 'El contexto actual sigue usando la matriz por defecto de la especie para {species}.',
  'mortalityManagement.profile.summary.facilityDefaultHint': 'Perfil por defecto de la instalación: {profile}.',
  'mortalityManagement.profile.summary.productionUnitHint': 'Override de la unidad de producción {productionUnit}: {profile}.',
  'mortalityManagement.profile.summary.lotHint': 'Override del lote {lot}: {profile}.',
  'mortalityManagement.profile.action.saveAsFacilityProfile': 'Guardar como perfil de instalación',
  'mortalityManagement.profile.action.setFacilityDefault': 'Usar como perfil por defecto',
  'mortalityManagement.profile.action.clearFacilityDefault': 'Limpiar perfil por defecto',
  'mortalityManagement.profile.action.applyToProductionUnit': 'Aplicar a la unidad de producción',
  'mortalityManagement.profile.action.clearProductionUnit': 'Limpiar override de unidad',
  'mortalityManagement.profile.action.applyToLot': 'Aplicar al lote',
  'mortalityManagement.profile.action.clearLot': 'Limpiar override de lote',
  'mortalityManagement.profile.prompt.name': 'Nombre para este perfil de mortalidad de la instalación',
  'mortalityManagement.profile.alert.selectFacility': 'Selecciona una instalación antes de gestionar perfiles de mortalidad.',
  'mortalityManagement.profile.alert.selectProductionUnit': 'Selecciona una unidad de producción antes de aplicar un override de perfil.',
  'mortalityManagement.profile.alert.selectLot': 'Selecciona un lote antes de aplicar un override específico del lote.',
  'mortalityManagement.profile.alert.activeLotRequired': 'Selecciona un lote activo antes de aplicar un override específico del lote.',
  'mortalityManagement.profile.confirm.resetProfile': '¿Restablecer el perfil de instalación {profile} a la matriz por defecto de la especie {species}? Esto sobrescribirá los valores del perfil.',

  'mortalityManagement.alert.invalidWeightTemp': 'Ingresa números válidos para peso y temperatura',
  'mortalityManagement.alert.invalidNewWeight': 'Ingresa un peso válido en gramos (número positivo)',
  'mortalityManagement.alert.weightExists': 'Ese peso ya existe en la matriz',
  'mortalityManagement.alert.minWeightRows': 'Se requiere al menos una fila de peso',
  'mortalityManagement.alert.invalidNewTemperature': 'Ingresa una temperatura válida en °C',
  'mortalityManagement.alert.temperatureExists': 'Esa temperatura ya existe en la matriz',
  'mortalityManagement.alert.minTemperatureColumns': 'Se requiere al menos una columna de temperatura',

  'mortalityManagement.calculator.title': 'Calculadora de mortalidad',
  'mortalityManagement.calculator.weightLabel': 'Peso:',
  'mortalityManagement.calculator.weightPlaceholder': 'gramos',
  'mortalityManagement.calculator.temperatureLabel': 'Temperatura:',
  'mortalityManagement.calculator.temperaturePlaceholder': 'celsius',
  'mortalityManagement.calculator.calculate': 'Calcular',
  'mortalityManagement.calculator.result': 'Mortalidad esperada: {value}%',
  'mortalityManagement.calculator.help': 'Esta calculadora usa interpolación para encontrar valores de mortalidad esperada entre puntos de la matriz.',

  'mortalityManagement.tools.title': 'Herramientas de estructura de matriz',
  'mortalityManagement.tools.weightRows': 'Filas de peso',
  'mortalityManagement.tools.addWeightPlaceholder': 'Agregar nuevo peso (g)',
  'mortalityManagement.tools.addRow': 'Agregar fila',
  'mortalityManagement.tools.temperatureColumns': 'Columnas de temperatura',
  'mortalityManagement.tools.addTemperaturePlaceholder': 'Agregar nueva temp (°C)',
  'mortalityManagement.tools.addColumn': 'Agregar columna',
  'mortalityManagement.tools.remove': 'Quitar',

  'mortalityManagement.usage.title': 'Uso',
  'mortalityManagement.usage.item1': 'Haz clic en cualquier celda de la matriz para editar los valores de mortalidad esperada.',
  'mortalityManagement.usage.item2': 'Los perfiles de instalación se pueden aplicar a toda una instalación, una unidad de producción o un solo lote.',
  'mortalityManagement.usage.item3': 'Los valores de mortalidad esperada se interpolan automáticamente para cálculos precisos.',
  'mortalityManagement.usage.item4': 'Exporta a CSV para respaldo o análisis externo.',

  'sfrManagement.speciesPreset.label': 'Preset de especie',
  'sfrManagement.species.descriptionFallback': 'Descripción del preset próximamente.',

  'sfrManagement.species.trout.label': 'Trucha',
  'sfrManagement.species.trout.description': 'Usa el preset SFR de trucha arcoíris.',
  'sfrManagement.species.salmon.label': 'Salmón',
  'sfrManagement.species.salmon.description': 'Usa el preset SFR de salmón del Atlántico.',
  'sfrManagement.species.tilapia.label': 'Tilapia',
  'sfrManagement.species.tilapia.description': 'Preset de agua cálida optimizado para el rango de 16–22°C.',
  'sfrManagement.species.shrimp.label': 'Camarón blanco del Pacífico (PWS)',
  'sfrManagement.species.shrimp.description': 'Preset de camarón de agua cálida (por defecto: columnas de 27°C y 32°C).',

  'sfrManagement.action.refreshMatrix': 'Actualizar matriz',
  'sfrManagement.action.exportCsv': 'Exportar CSV',
  'sfrManagement.action.resetDefaults': 'Restablecer a valores por defecto',

  'sfrManagement.profile.label': 'Perfil de instalación',
  'sfrManagement.profile.option.speciesDefault': 'Matriz por defecto de la especie',
  'sfrManagement.profile.help.noFacility': 'Selecciona una instalación para crear perfiles SFR reutilizables y aplicarlos a unidades de producción o lotes.',
  'sfrManagement.profile.help.facility': 'Los perfiles se guardan en la instalación seleccionada. Elige uno aquí para editarlo o mantente en la matriz por defecto de la especie.',
  'sfrManagement.profile.summary.editingProfile': 'Editando perfil de instalación: {name}.',
  'sfrManagement.profile.summary.editingSpeciesDefault': 'Editando la matriz compartida por defecto de la especie para {species}.',
  'sfrManagement.profile.summary.appliedLot': 'El contexto actual se resuelve desde el lote {lot}: {profile}.',
  'sfrManagement.profile.summary.appliedProductionUnit': 'El contexto actual se resuelve desde la unidad de producción {productionUnit}: {profile}.',
  'sfrManagement.profile.summary.appliedFacilityDefault': 'El contexto actual se resuelve desde el perfil por defecto de la instalación {facility}: {profile}.',
  'sfrManagement.profile.summary.appliedSpeciesDefault': 'El contexto actual sigue usando la matriz por defecto de la especie para {species}.',
  'sfrManagement.profile.summary.facilityDefaultHint': 'Perfil por defecto de la instalación: {profile}.',
  'sfrManagement.profile.summary.productionUnitHint': 'Override de la unidad de producción {productionUnit}: {profile}.',
  'sfrManagement.profile.summary.lotHint': 'Override del lote {lot}: {profile}.',
  'sfrManagement.profile.action.saveAsFacilityProfile': 'Guardar como perfil de instalación',
  'sfrManagement.profile.action.setFacilityDefault': 'Usar como perfil por defecto',
  'sfrManagement.profile.action.clearFacilityDefault': 'Limpiar perfil por defecto',
  'sfrManagement.profile.action.applyToProductionUnit': 'Aplicar a la unidad de producción',
  'sfrManagement.profile.action.clearProductionUnit': 'Limpiar override de unidad',
  'sfrManagement.profile.action.applyToLot': 'Aplicar al lote',
  'sfrManagement.profile.action.clearLot': 'Limpiar override de lote',
  'sfrManagement.profile.prompt.name': 'Nombre para este perfil SFR de la instalación',
  'sfrManagement.profile.alert.selectFacility': 'Selecciona una instalación antes de gestionar perfiles SFR.',
  'sfrManagement.profile.alert.selectProductionUnit': 'Selecciona una unidad de producción antes de aplicar un override de perfil.',
  'sfrManagement.profile.alert.selectLot': 'Selecciona un lote antes de aplicar un override específico del lote.',
  'sfrManagement.profile.alert.activeLotRequired': 'Selecciona un lote activo antes de aplicar un override específico del lote.',
  'sfrManagement.profile.confirm.resetProfile': '¿Restablecer el perfil de instalación {profile} a la matriz por defecto de la especie {species}? Esto sobrescribirá los valores del perfil.',

  'sfrManagement.status.loading': 'Cargando matriz SFR...',
  'sfrManagement.status.saving': 'Guardando cambios localmente...',
  'sfrManagement.status.refreshing': 'Actualizando la matriz SFR desde el servidor...',
  'sfrManagement.status.offline': 'Cambios guardados localmente sin conexión. Se sincronizarán cuando vuelvas a conectarte.',
  'sfrManagement.status.pending': 'Cambios guardados localmente. La sincronización con el servidor está pendiente.',
  'sfrManagement.status.synced': 'Cambios sincronizados.',
  'sfrManagement.status.refreshFailed': 'Se muestra la matriz SFR local porque falló la actualización desde el servidor.',
  'sfrManagement.status.saveFailed': 'No se pudo guardar la matriz SFR localmente. Inténtalo de nuevo.',

  'sfrManagement.alert.invalidWeightTemp': 'Ingresa números válidos para peso y temperatura',
  'sfrManagement.confirm.sharedPresetNote': ' (compartido por Trucha y Salmón)',
  'sfrManagement.confirm.resetDefaults': '¿Restablecer este preset SFR{sharedPresetNote} a su matriz por defecto? Esto no se puede deshacer.',
  'sfrManagement.confirm.resetCta': 'Confirmar restablecer',
  'sfrManagement.alert.resetFailed': 'No se pudo restablecer la matriz SFR. Intenta de nuevo o contacta soporte.',

  'sfrManagement.alert.invalidNewWeight': 'Ingresa un peso válido en gramos (número positivo)',
  'sfrManagement.alert.weightExists': 'Ese peso ya existe en la matriz',
  'sfrManagement.alert.minWeightRows': 'Se requiere al menos una fila de peso',
  'sfrManagement.alert.invalidNewTemperature': 'Ingresa una temperatura válida en °C',
  'sfrManagement.alert.temperatureExists': 'Esa temperatura ya existe en la matriz',
  'sfrManagement.alert.minTemperatureColumns': 'Se requiere al menos una columna de temperatura',

  'sfrManagement.calculator.title': 'Calculadora SFR',
  'sfrManagement.calculator.weightLabel': 'Peso:',
  'sfrManagement.calculator.weightPlaceholder': 'gramos',
  'sfrManagement.calculator.temperatureLabel': 'Temperatura:',
  'sfrManagement.calculator.temperaturePlaceholder': 'celsius',
  'sfrManagement.calculator.calculate': 'Calcular',
  'sfrManagement.calculator.result': 'SFR: {value}%',
  'sfrManagement.calculator.diagnosticsTitle': 'Detalles del cálculo',
  'sfrManagement.calculator.diagnosticsCurrent': 'Ruta actual de la calculadora: perfil de temperatura de la especie seleccionada, temperatura efectiva de interpolación {temperature}°C.',
  'sfrManagement.calculator.diagnosticsReference': 'Referencia con el preset seleccionado ({profile}): temperatura efectiva de interpolación {temperature}°C, SFR interpolado {value}%.',
  'sfrManagement.calculator.help': 'Esta calculadora usa interpolación para encontrar valores SFR entre puntos de la matriz.',

  'sfrManagement.tools.title': 'Herramientas de estructura de matriz',
  'sfrManagement.tools.weightRows': 'Filas de peso',
  'sfrManagement.tools.addWeightPlaceholder': 'Agregar nuevo peso (g)',
  'sfrManagement.tools.addRow': 'Agregar fila',
  'sfrManagement.tools.temperatureColumns': 'Columnas de temperatura',
  'sfrManagement.tools.addTemperaturePlaceholder': 'Agregar nueva temp (°C)',
  'sfrManagement.tools.addColumn': 'Agregar columna',
  'sfrManagement.tools.remove': 'Quitar',

  'sfrManagement.usage.title': 'Uso',
  'sfrManagement.usage.item1': 'Haz clic en cualquier celda de la matriz para editar valores SFR.',
  'sfrManagement.usage.item2': 'Los cambios requieren confirmación antes de guardarse.',
  'sfrManagement.usage.item3': 'Datos de peso desde Base de datos + datos de temperatura desde Agua → consulta SFR.',
  'sfrManagement.usage.item4': 'Los valores SFR se interpolan automáticamente para cálculos precisos.',
  'sfrManagement.usage.item5': 'Exporta a CSV para respaldo o análisis externo.',

  // Owner console
  'ownerConsole.title': 'Consola del dueño',
  'ownerConsole.subtitle': 'Crea y revoca tokens de API para usuarios de pruebas de campo. Los tokens están vinculados al tenant.',

  'ownerConsole.nav.members': 'Miembros del equipo',
  'ownerConsole.nav.tokens': 'Tokens',
  'ownerConsole.nav.organizations': 'Organizaciones',
  'ownerConsole.nav.groups': 'Grupos',

  'ownerConsole.me.tenant': 'Tenant:',
  'ownerConsole.me.role': 'Rol:',
  'ownerConsole.me.accountName': 'Nombre de cuenta:',
  'ownerConsole.me.username': 'Nombre de usuario:',
  'ownerConsole.me.email': 'Correo:',
  'ownerConsole.me.membership': 'ID de membresía:',
  'ownerConsole.me.user': 'ID de usuario:',
  'ownerConsole.me.actor': 'Actor:',
  'ownerConsole.me.currentToken': 'ID del token actual:',
  'ownerConsole.me.compatibilityMember': 'ID de miembro de compatibilidad:',

  'ownerConsole.notice.notAdmin': 'Esta cuenta no es admin, por lo que la gestión de miembros y tokens está deshabilitada.',

  'ownerConsole.error.failedToLoad': 'No se pudo cargar',
  'ownerConsole.error.enterLabel': 'Ingresa una etiqueta (p. ej., “Equipo A - Alice”).',
  'ownerConsole.error.createFailed': 'Falló la creación',
  'ownerConsole.error.revokeFailed': 'Falló la revocación',
  'ownerConsole.error.memberUpdateFailed': 'Falló la actualización del miembro',
  'ownerConsole.error.memberRevokeFailed': 'Falló la revocación del miembro',
  'ownerConsole.error.enterGroupName': 'Ingresa un nombre de grupo.',
  'ownerConsole.error.groupCreateFailed': 'Falló la creación del grupo',
  'ownerConsole.error.enterGroupMember': 'Selecciona un miembro del equipo para agregar al grupo.',
  'ownerConsole.error.groupMembershipCreateFailed': 'Falló la actualización de la membresía del grupo',
  'ownerConsole.error.enterPartnerOrganizationName': 'Ingresa un nombre de organización asociada.',
  'ownerConsole.error.partnerOrganizationCreateFailed': 'Falló la creación de la organización asociada',

  'ownerConsole.members.title': 'Miembros del equipo',
  'ownerConsole.members.subtitle': 'Filtra membresías activas y revocadas, luego cambia el rol o revoca tokens vinculados cuando corresponda.',
  'ownerConsole.members.loading': 'Cargando miembros…',
  'ownerConsole.members.empty': 'Todavía no hay miembros activos.',
  'ownerConsole.members.emptyFiltered': 'Ningún miembro coincide con este filtro.',
  'ownerConsole.members.addMember': 'Agregar miembro',
  'ownerConsole.members.note': 'Las membresías admin se muestran como solo lectura aquí. Usa la tabla de tokens de abajo para revocar un token individual.',
  'ownerConsole.members.migrationNote': 'Activación requerida significa que el miembro todavía necesita configurar sus credenciales humanas por primera vez. Usa un enlace de activación para ese estado; usa restablecimiento de contraseña solo cuando las credenciales ya existen.',
  'ownerConsole.members.revokedAtPrefix': 'Revocado',
  'ownerConsole.members.neverUsed': 'Sin uso todavía',
  'ownerConsole.members.activeTokens': 'Tokens activos',
  'ownerConsole.members.revokedTokens': 'Tokens revocados',
  'ownerConsole.members.activationRequired': 'Activación requerida',
  'ownerConsole.members.credentialsReady': 'Credenciales listas',
  'ownerConsole.members.status.pinReady': 'Activo · PIN listo',
  'ownerConsole.members.status.noPin': 'Activo · Sin PIN',
  'ownerConsole.members.status.noPinHint': 'Asígnale un PIN en esta fila para que registre en Crew Mode.',
  'ownerConsole.members.status.canSignIn': 'Activo · Puede iniciar sesión',
  'ownerConsole.members.status.neverSignedIn': 'Activo · Nunca ha iniciado sesión',
  'ownerConsole.members.status.needsActivation': 'Activo · Falta activar',
  'ownerConsole.members.status.needsActivationHint': 'Envíale un enlace de activación para que elija su contraseña.',
  'ownerConsole.members.searchLabel': 'Buscar miembros',
  'ownerConsole.members.searchPlaceholder': 'Buscar por miembro, actor, usuario, ID de membresía o estado',
  'ownerConsole.members.filter.all': 'Todos',
  'ownerConsole.members.filter.active': 'Activos',
  'ownerConsole.members.filter.revoked': 'Revocados',
  'ownerConsole.passwordReset.title': 'Enlace para restablecer contraseña (se muestra una sola vez)',
  'ownerConsole.passwordReset.activationTitle': 'Enlace de activación de cuenta (se muestra una sola vez)',
  'ownerConsole.passwordReset.expiresAt': 'Expira',
  'ownerConsole.passwordReset.copy': 'Copiar enlace',
  'ownerConsole.passwordReset.dismiss': 'Cerrar',

  'ownerConsole.partnerOrganizations.title': 'Organizaciones asociadas',
  'ownerConsole.partnerOrganizations.subtitle': 'Crea identidades explícitas de organización que las membresías de grupo puedan representar más adelante durante el intercambio confiable con socios.',
  'ownerConsole.partnerOrganizations.loading': 'Cargando organizaciones asociadas…',
  'ownerConsole.partnerOrganizations.empty': 'Todavía no hay organizaciones asociadas.',
  'ownerConsole.partnerOrganizations.nameLabel': 'Nombre de la organización',
  'ownerConsole.partnerOrganizations.namePlaceholder': 'Comprador de cosecha norte',
  'ownerConsole.partnerOrganizations.create': 'Crear organización',
  'ownerConsole.partnerOrganizations.note': 'Estas identidades siguen siendo del tenant por ahora y no cambian la visibilidad de artefactos.',
  'ownerConsole.partnerOrganizations.status.active': 'Activa',
  'ownerConsole.partnerOrganizations.status.inactive': 'Inactiva',

  'ownerConsole.groups.title': 'Grupos asociados',
  'ownerConsole.groups.subtitle': 'Crea grupos del tenant dueño y adjunta membresías existentes del equipo. Esto prepara la identidad de grupo para el futuro uso de GROUP sin compartir artefactos todavía.',
  'ownerConsole.groups.loading': 'Cargando grupos…',
  'ownerConsole.groups.empty': 'Todavía no hay grupos.',
  'ownerConsole.groups.nameLabel': 'Nombre del grupo',
  'ownerConsole.groups.namePlaceholder': 'Círculo asociado alfa',
  'ownerConsole.groups.create': 'Crear grupo',
  'ownerConsole.groups.note': 'Esta superficie solo gestiona la base de identidad de grupo. La visibilidad de artefactos no cambia.',
  'ownerConsole.groups.createdBy': 'Creado por',
  'ownerConsole.groups.activeMembers': 'Activos',
  'ownerConsole.groups.invitedMembers': 'Invitados',
  'ownerConsole.groups.revokedMembers': 'Revocados',
  'ownerConsole.groups.noMemberships': 'Todavía no hay membresías.',
  'ownerConsole.groups.addMemberLabel': 'Agregar miembro del equipo',
  'ownerConsole.groups.addMemberPartnerOrganizationLabel': 'Organización asociada',
  'ownerConsole.groups.addMemberRoleLabel': 'Rol del grupo',
  'ownerConsole.groups.addMember': 'Agregar al grupo',
  'ownerConsole.groups.noAvailableMembers': 'Todos los miembros activos del equipo ya están adjuntos.',
  'ownerConsole.groups.selectMemberPlaceholder': 'Selecciona miembro del equipo',
  'ownerConsole.groups.selectPartnerOrganizationPlaceholder': 'Sin organización asociada',
  'ownerConsole.groups.partnerOrganizationAssigned': 'Representa a',
  'ownerConsole.groups.status.active': 'Activo',
  'ownerConsole.groups.status.archived': 'Archivado',
  'ownerConsole.groups.role.owner': 'owner',
  'ownerConsole.groups.role.editor': 'editor',
  'ownerConsole.groups.role.viewer': 'viewer',
  'ownerConsole.groups.membershipStatus.invited': 'Invitado',
  'ownerConsole.groups.membershipStatus.active': 'Activo',
  'ownerConsole.groups.membershipStatus.revoked': 'Revocado',

  'ownerConsole.create.title': 'Crear token de usuario',
  'ownerConsole.create.openOnboarding': 'Abrir alta de miembro',
  'ownerConsole.create.label': 'Etiqueta',
  'ownerConsole.create.labelPlaceholder': 'Equipo A - Alice',
  'ownerConsole.create.role': 'Rol',
  'ownerConsole.create.roleOption.viewer': 'visor (solo lectura)',
  'ownerConsole.create.roleOption.contributor': 'colaborador (solo puede crear tareas)',
  'ownerConsole.create.roleOption.editor': 'editor (puede escribir)',
  'ownerConsole.create.createToken': 'Crear token',
  'ownerConsole.create.refresh': 'Actualizar',

  'ownerConsole.createdToken.title': 'Token (se muestra una sola vez)',
  'ownerConsole.createdToken.copy': 'Copiar',
  'ownerConsole.createdToken.dismiss': 'Cerrar',

  'ownerConsole.existing.title': 'Tokens existentes',
  'ownerConsole.existing.loading': 'Cargando…',
  'ownerConsole.existing.empty': 'Aún no hay tokens.',

  'ownerConsole.table.member': 'Miembro',
  'ownerConsole.table.membership': 'ID de membresía',
  'ownerConsole.table.user': 'ID de usuario',
  'ownerConsole.table.role': 'Rol',
  'ownerConsole.table.actor': 'Actor',
  'ownerConsole.table.compatibilityMember': 'ID de miembro de compatibilidad',
  'ownerConsole.table.lastUsed': 'Último uso',
  'ownerConsole.table.status': 'Estado',
  'ownerConsole.table.actions': 'Acciones',

  'ownerConsole.status.revoked': 'Revocado',
  'ownerConsole.status.active': 'Activo',
  'ownerConsole.action.revoke': 'Revocar',
  'ownerConsole.action.saveRole': 'Guardar rol',
  'ownerConsole.members.unsavedChangesChip': 'Cambios sin guardar',
  'ownerConsole.members.unsavedChangesTitle': 'Cambiaste este rol pero aún no lo guardaste. Pulsa “Guardar rol” para aplicarlo, o salí de la página para descartar.',
  'ownerConsole.action.revokeMember': 'Revocar miembro',
  'ownerConsole.action.issueActivation': 'Crear enlace de activación',
  'ownerConsole.action.issuePasswordReset': 'Crear enlace de contraseña',
  'ownerConsole.action.issuingPasswordReset': 'Creando enlace…',
  'ownerConsole.action.setPin': 'Asignar PIN',
  'ownerConsole.action.settingPin': 'Guardando…',
  'ownerConsole.action.clearPin': 'Borrar PIN',
  'ownerConsole.action.clearingPin': 'Borrando…',
  'ownerConsole.pin.placeholder': 'PIN de 4 dígitos',
  'ownerConsole.pin.invalid': 'El PIN debe tener exactamente 4 dígitos.',
  'ownerConsole.pin.setSuccess': 'PIN guardado para {label}.',
  'ownerConsole.pin.clearSuccess': 'PIN borrado para {label}.',
  'ownerConsole.error.pinSetFailed': 'No se pudo guardar el PIN.',
  'ownerConsole.error.pinClearFailed': 'No se pudo borrar el PIN.',

  // Crew Mode Charter D-4 shared identity mechanism — OperatorGate
  'crewMode.operatorGate.title': '¿Quién está registrando?',
  'crewMode.operatorGate.switchOperator': 'Cambiar',
  'crewMode.operatorGate.error.invalidPin': 'PIN no reconocido. Intenta de nuevo.',
  'crewMode.operatorGate.lockedOut': 'Demasiados intentos. Intenta de nuevo en un minuto.',

  // Fast Entry v0 — minimal shell wrapping every /crew* route
  'crewMode.shell.confirmSignOut': '¿Cerrar sesión en este dispositivo?',
  'crewMode.shell.backToMenu': 'Volver al menú',
  'crewMode.shell.permissionBlocked': 'Este celular no tiene permiso para guardar registros. Avisa al administrador. Los registros siguen guardados en el celular y se enviarán solos cuando tenga permiso.',
  'syncRefused.title.withWaiting': 'Un registro no se pudo enviar y detiene {count} cambio(s) más de este equipo.',
  'syncRefused.title.alone': 'Un registro no se pudo enviar.',
  'syncRefused.reason.unitMismatch': 'En esa fecha el lote {lot} no estaba en {unit}. Revisa la fecha del registro.',
  'syncRefused.reason.lotNotActive': 'El lote {lot} ya no está activo.',
  'syncRefused.reason.lotNotFound': 'El lote de este registro ya no existe.',
  'syncRefused.reason.other': 'El servidor lo rechazó: {message}',
  'syncRefused.action.office': 'Elimínalo o corrígelo en {screen}; los demás cambios se enviarán solos.',
  'syncRefused.action.crew': 'Avisa a la oficina. Los registros siguen guardados en el celular.',
  'syncRefused.open': 'Ver',
  'syncRefused.kind.farm': 'Instalación',
  'syncRefused.kind.productionUnit': 'Unidad de producción',
  'syncRefused.kind.lot': 'Lote',
  'syncRefused.kind.lotMove': 'Traslado de lote',
  'syncRefused.kind.lotSplit': 'División de lote',
  'syncRefused.kind.lotMerge': 'Unión de lotes',
  'syncRefused.kind.waterLog': 'Calidad de agua',
  'syncRefused.kind.productionRecord': 'Registro de producción',
  'syncRefused.kind.feedLog': 'Alimentación',
  'syncRefused.kind.mortalityLog': 'Mortalidad',
  'syncRefused.kind.weightSampleLog': 'Muestreo',
  'syncRefused.kind.fishStockLog': 'Conteo de peces',
  'syncRefused.kind.harvestLog': 'Cosecha',
  'syncRefused.kind.lotCostEvent': 'Costo',
  'syncRefused.kind.inventoryItem': 'Ítem de inventario',
  'syncRefused.kind.task': 'Tarea',
  'syncRefused.kind.matrix': 'Tabla de referencia',
  'syncRefused.kind.other': 'Registro',
  'syncRefused.screen.editFarm': 'Editar instalación',
  'syncRefused.screen.lots': 'Lotes',
  'syncRefused.screen.water': 'Agua',
  'syncRefused.screen.database': 'Base de datos',
  'syncRefused.screen.feed': 'Alimento',
  'syncRefused.screen.biomass': 'Biomasa',
  'syncRefused.screen.costs': 'Costos',
  'syncRefused.screen.inventory': 'Inventario',
  'syncRefused.screen.tasks': 'Tareas',
  'syncRefused.screen.matrix': 'la tabla de referencia',
  'syncRefused.screen.home': 'Inicio',
  'syncRefused.rowTag': 'No enviado',

  // WaterLog v0 Stage 4 capture screen
  'crewMode.water.productionUnit': 'Estanque',
  'crewMode.water.selectParameter': '¿Qué estás midiendo?',
  'crewMode.water.parameter.temperature': 'Temperatura',
  'crewMode.water.parameter.ph': 'pH',
  'crewMode.water.parameter.phUnit': 'unidades',
  'crewMode.water.parameter.dissolvedOxygen': 'Oxígeno disuelto',
  'crewMode.water.parameter.salinity': 'Salinidad',
  'crewMode.water.error.invalidValue': 'Ingresa un número.',
  'crewMode.water.error.outOfRange': 'El valor debe estar entre {min} y {max} {unit}.',
  'crewMode.water.warning.duplicate': 'Ya se guardó una lectura reciente para este estanque y parámetro. Toca Confirmar de nuevo para guardar igual.',
  'crewMode.water.confirm': 'Confirmar',
  'crewMode.water.confirmAnyway': 'Confirmar igual',
  'crewMode.water.sync.local': 'Guardado en el dispositivo',
  'crewMode.water.sync.pending': 'Sincronizando…',
  'crewMode.water.sync.synced': 'Sincronizado',
  'crewMode.water.sync.error': 'Error al sincronizar',
  'crewMode.water.retry': 'Reintentar',
  'crewMode.water.notEnabledForFarm': 'La captura de agua de Crew Mode aún no está habilitada para esta granja. Consulta a tu administrador.',

  'crewMode.feed.pond': 'Estanque',
  'crewMode.feed.lot.choose': '¿Qué lote?',
  'crewMode.feed.lot.none': 'No hay un lote activo en este estanque. Consulta a tu supervisor.',
  'crewMode.feed.lot.current': 'Lote: {lotKey}',
  'crewMode.feed.selectItem': '¿Qué alimentaste?',
  'crewMode.feed.noItems': 'Aún no hay ítems de alimento configurados para esta granja. Consulta a tu administrador.',
  'crewMode.feed.quantity': 'Cantidad',
  'crewMode.feed.quantityUnit': 'kg',
  'crewMode.feed.error.invalidValue': 'Ingresa una cantidad mayor a 0.',
  'crewMode.feed.warning.largeValue': 'Es una cantidad grande. Toca Confirmar de nuevo para guardar igual.',
  'crewMode.feed.warning.duplicate': 'Ya se guardó una alimentación reciente para este lote. Toca Confirmar de nuevo para guardar igual.',
  'crewMode.feed.confirm': 'Confirmar',
  'crewMode.feed.confirmAnyway': 'Confirmar igual',
  'crewMode.feed.sync.local': 'Guardado en el dispositivo',
  'crewMode.feed.sync.pending': 'Sincronizando…',
  'crewMode.feed.sync.synced': 'Sincronizado',
  'crewMode.feed.sync.error': 'Error al sincronizar',
  'crewMode.feed.retry': 'Reintentar',
  'crewMode.feed.notEnabledForFarm': 'La captura de alimentación de Crew Mode aún no está habilitada para esta granja. Consulta a tu administrador.',
  'crewMode.feed.giveDayTotal': 'Hoy toca: {feeds}',
  'crewMode.feed.giveDayTotalDetail': 'Total del día · toca para registrarlo',
  'crewMode.feed.weighed.title': 'Pesada del día',
  'crewMode.feed.weighed.morningHelp': 'Anota lo que pesaste para hoy. Al final del día anotarás lo que sobró.',
  'crewMode.feed.weighed.planHint': 'Plan: {kg} kg',
  'crewMode.feed.weighed.weighedLabel': 'Pesado {feed} (kg)',
  'crewMode.feed.weighed.saveWeighed': 'Guardar pesado',
  'crewMode.feed.weighed.weighedToday': 'Pesado hoy: {kg} kg {feed}',
  'crewMode.feed.weighed.leftoverLabel': 'Sobrante {feed} (kg)',
  'crewMode.feed.weighed.leftoverHelp': 'Al final del día pesa lo que sobró. Vacío = no sobró nada.',
  'crewMode.feed.weighed.saveLeftover': 'Guardar sobrante',
  'crewMode.feed.weighed.fedToday': 'Dado hoy: {fed} kg {feed} (pesado {weighed} − sobrante {leftover})',
  'crewMode.feed.weighed.error.weighed': 'Ingresa lo pesado: un número mayor que 0 en al menos un alimento.',
  'crewMode.feed.weighed.error.leftover': 'El sobrante debe estar entre 0 y lo pesado.',
  'crewMode.feed.givePlan': 'Dado según plan: {kg} kg {feed}',
  'crewMode.feed.mixBadge': 'Mezcla',

  'crewMode.mortality.pond': 'Estanque',
  'crewMode.mortality.lot.choose': '¿Qué lote?',
  'crewMode.mortality.lot.none': 'No hay un lote activo en este estanque. Consulta a tu supervisor.',
  'crewMode.mortality.lot.current': 'Lote: {lotKey}',
  'crewMode.mortality.count': '¿Cuántos muertos?',
  'crewMode.mortality.error.invalidValue': 'Ingresa un número entero (0 o más).',
  'crewMode.mortality.warning.largeValue': 'Es un número grande. Toca Confirmar de nuevo para guardar igual.',
  'crewMode.mortality.warning.duplicate': 'Ya se guardó un registro de mortalidad reciente para este lote. Toca Confirmar de nuevo para guardar igual.',
  'crewMode.mortality.cause.prompt': 'Causa (opcional)',
  'crewMode.mortality.cause.predation': 'Depredación',
  'crewMode.mortality.cause.disease': 'Enfermedad',
  'crewMode.mortality.cause.handling': 'Manipulación',
  'crewMode.mortality.cause.waterQuality': 'Calidad de agua',
  'crewMode.mortality.cause.unknown': 'Desconocida',
  'crewCorrection.button': 'Corregir…',
  'crewCorrection.title': 'Corregir un registro capturado',
  'crewCorrection.resource.water-log': 'Lectura de agua',
  'crewCorrection.resource.feed-log': 'Registro de alimento',
  'crewCorrection.resource.mortality-log': 'Registro de mortalidad',
  'crewCorrection.resource.weight-sample-log': 'Muestreo de peso',
  'crewCorrection.field.temperatureC': 'Temperatura',
  'crewCorrection.field.ph': 'pH',
  'crewCorrection.field.dissolvedOxygenMgL': 'Oxígeno disuelto',
  'crewCorrection.field.dissolvedOxygenSaturationPct': 'Oxígeno disuelto (saturación)',
  'crewCorrection.field.manualDissolvedOxygenMgL': 'Oxígeno disuelto manual',
  'crewCorrection.field.manualDissolvedOxygenSaturationPct': 'Oxígeno disuelto manual (saturación)',
  'crewCorrection.field.salinityPpt': 'Salinidad',
  'crewCorrection.field.recordedAt': 'Registrado el',
  'crewCorrection.field.notes': 'Notas',
  'crewCorrection.field.feedKg': 'Cantidad de alimento',
  'crewCorrection.field.feedType': 'Tipo de alimento',
  'crewCorrection.field.sfrPercent': 'SFR',
  'crewCorrection.field.biomassKg': 'Biomasa',
  'crewCorrection.field.fcr': 'FCR',
  'crewCorrection.field.feedingResponse': 'Respuesta a la alimentación',
  'crewCorrection.field.mortalityCount': 'Cantidad de muertos',
  'crewCorrection.field.observedCause': 'Causa observada',
  'crewCorrection.field.weightGrams': 'Peso muestreado',
  'crewCorrection.field.sampleCount': 'Individuos muestreados',
  'crewCorrection.field.countedStock': 'Stock',
  'crewCorrection.field.stockMethod': 'Método',
  'crewCorrection.reason.label': 'Motivo de la corrección',
  'crewCorrection.reason.labelRequired': 'Motivo (obligatorio)',
  'crewCorrection.reason.placeholder': 'p. ej. el operario invirtió la lectura',
  'crewCorrection.error.noChange': 'Cambia al menos un valor antes de guardar.',
  'crewCorrection.error.reasonRequired': 'El motivo es obligatorio.',
  'crewCorrection.error.generic': 'No se pudo guardar la corrección. Tus datos se conservan — inténtalo de nuevo.',
  'crewCorrection.error.conflict': 'Este registro cambió desde que lo abriste. Cierra y vuelve a abrirlo para ver los valores actuales antes de corregir.',
  'crewCorrection.review.title': 'Revisa la corrección',
  'crewCorrection.review.field': 'Campo',
  'crewCorrection.review.priorValue': 'Valor anterior',
  'crewCorrection.review.newValue': 'Valor nuevo',
  'crewCorrection.review.empty': '(vacío)',
  'crewCorrection.button.review': 'Revisar cambios',
  'crewCorrection.button.back': 'Atrás',
  'crewCorrection.button.confirm': 'Confirmar y guardar',
  'crewCorrection.button.cancel': 'Cancelar',
  'crewCorrection.button.close': 'Cerrar',
  'crewCorrection.observedCause.none': '— ninguna —',
  'crewCorrection.feedType.none': 'Mantener actual',
  'crewCorrection.feedType.loading': 'Cargando catálogo de alimento…',
  'crewCorrection.field.lot': 'Lote · Unidad',
  'crewCorrection.field.lotName': 'Lote',
  'crewCorrection.field.productionUnit': 'Unidad',
  'crewCorrection.field.lengthMm': 'Longitud',
  'crewCorrection.reason.deletePlaceholder': 'p. ej. se registró dos veces',
  'crewCorrection.reason.operatorUndo': 'Deshecho por el operario (Crew Mode)',
  'crewCorrection.mode.edit': 'Corregir valores',
  'crewCorrection.mode.move': 'Mover a otro lote/unidad',
  'crewCorrection.mode.moveUnit': 'Mover a otra unidad',
  'crewCorrection.mode.delete': 'Eliminar',
  'crewCorrection.move.current': 'Ahora en',
  'crewCorrection.move.targetLot': 'Mover a (Lote · Unidad)',
  'crewCorrection.move.targetUnit': 'Mover a la unidad',
  'crewCorrection.move.pick': '— elige —',
  'crewCorrection.move.currentTag': 'actual',
  'crewCorrection.move.guardHint': 'El lote debe haber estado en esa unidad en la fecha del registro; si no, el cambio se rechaza.',
  'crewCorrection.delete.warning': 'El registro se eliminará. Se guarda una copia completa con el motivo en el historial de correcciones.',
  'crewCorrection.delete.reviewTitle': 'Revisa la eliminación',
  'crewCorrection.delete.confirm': 'Eliminar registro',
  'crewCorrection.delete.steps': 'Para eliminar: 1) escribe el motivo · 2) Revisar eliminación · 3) Eliminar registro.',
  'crewCorrection.delete.review': 'Revisar eliminación',
  'crewCorrection.delete.done': 'Registro eliminado. La copia queda en el historial de correcciones.',
  'crewCorrection.unsynced.note': 'Este registro aún no llegó al servidor (sigue esperando sincronizar en este dispositivo), así que aquí solo se puede eliminar. Los valores se pueden corregir cuando se sincronice.',
  'crewCorrection.error.pickMoveTarget': 'Elige a dónde debe ir el registro.',
  'crewCorrection.error.moveRejected': 'Se rechazó el cambio: ese lote no estaba en esa unidad en la fecha del registro, o el lote/unidad es de otra instalación.',
  'crewCorrection.history.empty': 'Sin correcciones todavía.',
  'crewCorrection.history.title': 'Historial de correcciones ({count})',
  'crewCorrection.history.action.update': 'valores corregidos',
  'crewCorrection.history.action.move': 'movido',
  'crewCorrection.history.action.delete': 'eliminado',
  'crewCorrection.badge.crew': 'Crew',
  'crewCorrection.badge.crewTitle': 'Capturado en Crew Mode',
  'crewCorrection.badge.corrected': 'Corregido',
  'crewCorrection.badge.correctedTitle': 'Corregido {count} vez/veces — abre "Corregir…" para ver el historial',
  'crewCorrection.badge.loggedBy': 'por {name}',
  'crewCorrection.badge.late': 'Registrado tarde',
  'crewCorrection.badge.noMortality': 'Sin mortalidad',
  'crewCorrection.badge.notChecked': 'No revisado',
  'crewCorrection.badge.notCheckedTitle': 'No se pudo revisar el estanque; no es un registro de cero muertos',
  'crewMode.day.label': 'Día',
  'crewMode.day.today': 'Hoy',
  'crewMode.day.yesterday': 'Ayer',
  'crewMode.day.twoDaysAgo': 'Hace 2 días',
  'crewMode.home.today.field.notChecked': 'No revisado',
  'crewMode.lateEntry': 'registrado tarde',
  'crewMode.location.youAreIn': 'Estás en',
  'crewMode.location.change': 'Cambiar',
  'crewMode.location.close': 'Cerrar',
  'crewMode.location.pickerTitle': '¿Dónde estás?',
  'crewMode.location.noneLot': 'Elige lote y unidad',
  'crewMode.location.noneUnit': 'Elige la unidad',
  'crewMode.location.emptyLot': 'Ninguna unidad tiene un lote activo. Pide a la oficina que active o siembre uno.',
  'crewMode.location.emptyUnit': 'Esta instalación no tiene unidades para Crew Mode.',
  'crewMode.location.next': 'Siguiente: {label} →',
  'crewMode.mortality.noneToday': 'Sin mortalidad hoy',
  'crewMode.mortality.noneThatDay': 'Sin mortalidad ese día',
  'crewMode.mortality.addCause': '+ Otra causa',
  'crewMode.mortality.removeCause': 'Quitar',
  'crewMode.mortality.note': 'Nota',
  'crewMode.mortality.notePlaceholder': 'Nota opcional',
  'crewMode.mortality.summary.none': 'Sin mortalidad',
  'crewMode.mortality.summary.notChecked': 'No revisado ({reason})',
  'crewMode.mortality.notChecked.open': 'No se pudo revisar',
  'crewMode.mortality.notChecked.prompt': '¿Por qué no se pudo revisar?',
  'crewMode.mortality.notChecked.weather': 'Clima',
  'crewMode.mortality.notChecked.equipment': 'Equipo',
  'crewMode.mortality.notChecked.noStaff': 'Sin personal',
  'crewMode.mortality.notChecked.other': 'Otro',
  'crewMode.undo': 'Deshacer',
  'crewMode.weightSample.round.remove': 'Quitar',
  'crewMode.weightSample.round.replace': 'Corregir',
  'crewMode.weightSample.round.fishNumber': 'Pez {n}',
  'crewMode.weightSample.round.removedReason': 'Quitado por el operario durante la ronda (Crew Mode)',
  'crewMode.mortality.confirm': 'Confirmar',
  'crewMode.mortality.confirmAnyway': 'Confirmar igual',
  'crewMode.mortality.lastEntry': '{count} muertos',
  'crewMode.mortality.sync.local': 'Guardado en el dispositivo',
  'crewMode.mortality.sync.pending': 'Sincronizando…',
  'crewMode.mortality.sync.synced': 'Sincronizado',
  'crewMode.mortality.sync.error': 'Error al sincronizar',
  'crewMode.mortality.retry': 'Reintentar',
  'crewMode.mortality.notEnabledForFarm': 'La captura de mortalidad de Crew Mode aún no está habilitada para esta granja. Consulta a tu administrador.',

  'crewMode.weightSample.pond': 'Estanque',
  'crewMode.weightSample.lot.choose': '¿Qué lote?',
  'crewMode.weightSample.lot.none': 'No hay un lote activo en este estanque. Consulta a tu supervisor.',
  'crewMode.weightSample.lot.current': 'Lote: {lotKey}',
  'crewMode.weightSample.weight': 'Peso muestreado',
  'crewMode.weightSample.weightUnit': 'g',
  'crewMode.weightSample.sampleCount': '¿Cuántos individuos? (opcional)',
  'crewMode.weightSample.error.invalidWeight': 'Ingresa el peso muestreado en gramos.',
  'crewMode.weightSample.error.outOfRangeWeight': 'El peso debe ser mayor que 0 y como máximo {max} g.',
  'crewMode.weightSample.error.invalidSampleCount': 'Ingresa un número entero de individuos.',
  'crewMode.weightSample.error.outOfRangeSampleCount': 'El número de individuos debe ser al menos 1.',
  'crewMode.weightSample.warning.duplicate': 'Ya se guardó un muestreo reciente para este lote. Toca Confirmar de nuevo para guardar igual.',
  'crewMode.weightSample.confirm': 'Confirmar',
  'crewMode.weightSample.confirmAnyway': 'Confirmar igual',
  'crewMode.weightSample.lastEntry': '{weight} g',
  'crewMode.weightSample.lastEntryCount': '{count} muestreados',
  'crewMode.weightSample.sync.local': 'Guardado en el dispositivo',
  'crewMode.weightSample.sync.pending': 'Sincronizando…',
  'crewMode.weightSample.sync.synced': 'Sincronizado',
  'crewMode.weightSample.sync.error': 'Error al sincronizar',
  'crewMode.weightSample.retry': 'Reintentar',
  'crewMode.weightSample.notEnabledForFarm': 'La captura de muestreo de Crew Mode aún no está habilitada para esta granja. Consulta a tu administrador.',
  'crewMode.weightSample.mode.label': 'Modo de captura',
  'crewMode.weightSample.mode.individual': 'Un pez a la vez',
  'crewMode.weightSample.mode.mean': 'Promedio de varios',
  'crewMode.weightSample.length': 'Longitud (opcional)',
  'crewMode.weightSample.lengthUnit': 'mm',
  'crewMode.weightSample.error.invalidLength': 'Ingresa la longitud en milímetros.',
  'crewMode.weightSample.error.outOfRangeLength': 'La longitud debe ser mayor que 0 y como máximo {max} mm.',
  'crewMode.weightSample.add': 'Agregar',
  'crewMode.weightSample.addAnyway': 'Agregar igual',
  'crewMode.weightSample.undoLast': 'Deshacer último',
  'crewMode.weightSample.finishRound': 'Terminar ronda',
  'crewMode.weightSample.session.count': '{count} registrados en esta ronda',
  'crewMode.weightSample.plan.counter': '{count} de {total}',
  'crewMode.weightSample.plan.complete': 'Muestreo completo — toca Terminar ronda',
  'crewMode.weightSample.session.syncSummary': '{synced} de {total} sincronizados',
  'crewMode.weightSample.session.syncSummaryWithIssues': '{synced} de {total} sincronizados, {issues} pendientes o con error',
  'crewMode.weightSample.session.retryFailed': 'Reintentar fallidos',

  // CrewModeFarmBar -- shared farm context indicator/selector across all five Crew Mode screens
  'crewMode.farmBar.label': 'Granja',
  'crewMode.farmBar.changeLabel': 'Cambiar granja',

  'crewMode.home.prompt': '¿Qué vas a registrar?',
  'crewMode.home.noStreams': 'Aún no hay nada habilitado para esta granja. Consulta a tu administrador.',
  'crewMode.home.stream.water': 'Agua',
  'crewMode.home.stream.feed': 'Alimento',
  'crewMode.home.stream.mortality': 'Mortalidad',
  'crewMode.home.stream.weightSample': 'Muestreo',
  'crewMode.home.today.heading': 'Tus registros de hoy',
  'crewMode.home.today.waitingToSync': '{count} sin sincronizar',
  'crewMode.home.today.sync.local': 'Guardado en el dispositivo',
  'crewMode.home.today.sync.pending': 'Sincronizando…',
  'crewMode.home.today.sync.synced': 'Sincronizado',
  'crewMode.home.today.sync.error': 'Error al sincronizar',
  'crewMode.home.today.field.feedType': 'Alimento',
  'crewMode.home.today.field.feedKg': 'kg',
  'crewMode.home.today.field.mortalityCount': 'Muertos',
  'crewMode.home.today.field.weightGrams': 'g',
  'crewMode.home.today.field.sampleCount': 'muestreados',

  // Optional header shortcuts
  'shortcut.createAccount': 'Crear cuenta',
  'shortcut.iconDemo': 'Demo de iconos',
  'shortcut.kpiDemo': 'Demo de KPI',
  'shortcut.formDemo': 'Demo de formulario',
  'shortcut.buttonDemo': 'Demo de botones',

  // Common aria
  'aria.settings': 'Configuración',
  'aria.teamName': 'Nombre del equipo',
  'aria.createNewTask': 'Crear una nueva tarea',

  // Auth
  'auth.titleHuman': 'Inicia sesión con tu correo o nombre de usuario',
  'auth.helpHuman': 'Usa las credenciales asignadas a tu cuenta de miembro del tenant. La clave del tenant solo se necesita si la misma persona pertenece a varios equipos.',
  'auth.humanModeNotice': 'Usa correo o nombre de usuario más contraseña para el acceso normal de miembros. El acceso por token de compatibilidad ahora vive en una ruta separada para arranque, soporte o flujos explícitamente administrativos.',
  'auth.titleToken': 'Inicia sesión con el token de acceso de tu equipo',
  'auth.helpToken': 'Pega un token de compatibilidad solo cuando un dueño o admin te lo haya entregado explícitamente para arranque, soporte o acceso administrativo. Esto te inicia en el equipo correcto y bloquea el almacenamiento offline a ese equipo.',
  'auth.tokenModeNotice': 'El acceso por token es secundario y específico para ciertos casos. Los miembros humanos deben iniciar con correo o nombre de usuario más contraseña, salvo que un dueño o admin les indique usar un token de compatibilidad.',
  'auth.apiToken': 'Token de API',
  'auth.tokenPlaceholder': 'sun_...',
  'auth.tokenAccessTitle': '¿Necesitas un token de acceso de compatibilidad?',
  'auth.tokenAccessHelp': 'Abre el acceso por token solo para arranque, soporte, integración o flujos explícitamente administrativos. El inicio normal de miembros sigue siendo con correo o nombre de usuario más contraseña.',
  'auth.openTokenAccess': 'Abrir acceso por token',
  'auth.backToHumanSignIn': 'Volver al inicio con correo',
  'auth.identifier': 'Correo o nombre de usuario',
  'auth.identifierPlaceholder': 'tu@empresa.com o operador-campo',
  'auth.password': 'Contraseña',
  'auth.passwordPlaceholder': 'Al menos 8 caracteres',
  'auth.tenantKeyOptional': 'Clave del tenant (opcional)',
  'auth.tenantKeyPlaceholder': 'Solo se necesita para membresías en varios tenants',
  'auth.signIn': 'Iniciar sesión',
  'auth.signInWithToken': 'Entrar con token',
  'auth.signingIn': 'Iniciando…',
  'auth.clear': 'Limpiar',
  'auth.enterCredentialsFirst': 'Primero ingresa tu correo o nombre de usuario y tu contraseña.',
  'auth.pasteTokenFirst': 'Primero pega un token.',
  'auth.signInFailed': 'Error al iniciar sesión',
  'auth.tooManyAttempts': 'Demasiados intentos de inicio de sesión. Espera 15 minutos y vuelve a intentarlo.',
  'auth.memberRevoked': 'Esta cuenta fue revocada. Habla con el administrador.',
  'auth.signedInAsPrefix': 'Sesión iniciada como',
  'auth.onTenant': 'en el tenant',
  'auth.resetActivationTitle': 'Configura las credenciales de tu cuenta',
  'auth.resetPasswordTitle': 'Restablece tu contraseña',
  'auth.resetHelp': 'Usa este enlace de un solo uso que te entregó el dueño de tu equipo para configurar o recuperar tus credenciales de acceso humano.',
  'auth.resetLoading': 'Cargando enlace de contraseña…',
  'auth.resetInvalid': 'Este enlace de contraseña es inválido, expiró o ya fue usado.',
  'auth.resetTokenMissing': 'A este enlace de contraseña le falta su token.',
  'auth.resetEmail': 'Correo',
  'auth.resetEmailPlaceholder': 'tu@empresa.com',
  'auth.resetUsername': 'Nombre de usuario',
  'auth.resetUsernamePlaceholder': 'operador-campo',
  'auth.resetConfirmPassword': 'Confirmar contraseña',
  'auth.resetConfirmPasswordPlaceholder': 'Repite tu contraseña',
  'auth.resetPasswordMismatch': 'Las contraseñas deben coincidir.',
  'auth.resetSubmitting': 'Guardando…',
  'auth.resetActivateAction': 'Guardar credenciales y activar cuenta',
  'auth.resetPasswordAction': 'Guardar nueva contraseña',
  'auth.resetSuccess': 'Contraseña actualizada. Inicia sesión con tus nuevas credenciales.',
  'ownerConsole.error.passwordResetFailed': 'No se pudo crear el enlace para restablecer la contraseña.',
  'auth.resetExpiresAt': 'Expira',

  // Tasks
  'tasks.title': 'Tareas',
  'tasks.subtitle': 'Coordina tareas operativas con claridad, responsabilidad y recordatorios a tiempo.',
  'tasks.notice.cachedTasks': 'Mostrando tareas en caché. Las últimas actualizaciones pueden faltar hasta que el servidor esté disponible.',
    'tasks.confirm.deleteTask': '¿Eliminar esta tarea?',
  'tasks.confirm.deleteCta': 'Confirmar eliminar',
  'tasks.error.unableToLoad': 'No se pudieron cargar las tareas',
  'tasks.error.resolveBeforeSaving': 'Resuelve los errores resaltados antes de guardar.',
  'tasks.error.unableToCreate': 'No se pudo crear la tarea en este momento.',
  'tasks.error.failedToCreate': 'No se pudo crear la tarea',
    'tasks.error.failedToUpdate': 'No se pudo actualizar la tarea',
    'tasks.error.unableToUpdateStatus': 'No se pudo actualizar el estado de la tarea',
    'tasks.error.failedToDelete': 'No se pudo eliminar la tarea',
  'tasks.error.unableToExport': 'No se pudieron exportar las tareas en este momento.',
  'tasks.error.unableToImport': 'No se pudieron importar las tareas.',
  'tasks.error.readonlyCreate': 'Acceso de solo lectura: los tokens de visor no pueden crear tareas.',
  'tasks.error.activeLotRequired': 'Selecciona un lote activo o limpia el filtro de lote antes de crear una tarea.',
  'tasks.error.taskMissing': 'La tarea ya no existe. Actualiza e intenta de nuevo.',
  'tasks.error.readonlyImport': 'Acceso de solo lectura: este token no puede importar tareas.',

  'tasks.validation.titleTooShort': 'El título debe tener al menos 3 caracteres.',
  'tasks.validation.descriptionEmpty': 'La descripción no puede estar vacía.',
  'tasks.validation.dueInvalid': 'La fecha límite debe ser un timestamp ISO válido.',
  'tasks.validation.dueMustBeFutureForActive': 'Las tareas activas necesitan una fecha límite en el futuro.',
  'tasks.validation.parentMissing': 'La tarea padre seleccionada ya no existe.',
  'tasks.validation.parentSelf': 'Una tarea no puede ser su propia tarea padre.',
  'tasks.validation.parentCycle': 'La cadena de padres crearía un ciclo.',
  'tasks.validation.cannotCompleteWithActiveLinked.one': 'No se puede completar mientras {count} tarea vinculada siga activa.',
  'tasks.validation.cannotCompleteWithActiveLinked.many': 'No se puede completar mientras {count} tareas vinculadas sigan activas.',
  'tasks.validation.objectiveConsiderDueDate': 'Hay tareas vinculadas programadas; considera establecer una fecha límite para este objetivo.',
  'tasks.status.exportBrowserOnly': 'La exportación solo está disponible en el navegador.',
  'tasks.status.noTasksToExport': 'Aún no hay tareas para exportar.',
  'tasks.status.exportedPrefix': 'Exportadas',
    'tasks.status.createdLocal': 'La tarea se guardó en este dispositivo. La sincronización con el servidor sigue pendiente.',
    'tasks.status.createdOffline': 'La tarea se guardó en este dispositivo. Se sincronizará cuando vuelva la conexión.',
    'tasks.status.createdSynced': 'La tarea quedó creada y sincronizada.',
    'tasks.status.updatedLocal': 'Los cambios de la tarea se guardaron en este dispositivo. La sincronización con el servidor sigue pendiente.',
    'tasks.status.updatedOffline': 'Los cambios de la tarea se guardaron en este dispositivo. Se sincronizarán cuando vuelva la conexión.',
    'tasks.status.updatedSynced': 'La tarea quedó actualizada y sincronizada.',
    'tasks.status.deletedLocal': 'La tarea se eliminó en este dispositivo. La sincronización con el servidor sigue pendiente.',
    'tasks.status.deletedOffline': 'La tarea se eliminó en este dispositivo. Se sincronizará cuando vuelva la conexión.',
    'tasks.status.deletedSynced': 'La tarea quedó eliminada y sincronizada.',
  'tasks.status.importedPrefix': 'Importadas',
  'tasks.status.importedTaskSingular': 'tarea importada',
  'tasks.status.importedTaskPlural': 'tareas importadas',
  'tasks.status.skippedPrefix': ', se omitieron',
  'tasks.status.duplicateSingular': 'duplicada',
  'tasks.status.duplicatePlural': 'duplicadas',
  'tasks.sync.pending': 'Los cambios de tareas siguen en cola para sincronizarse.',
  'tasks.sync.offline': 'Los cambios de tareas se guardaron localmente y se sincronizarán cuando vuelva la conexión.',
  'tasks.sync.blocked': '{count} cambio(s) de tareas necesitan atención antes de continuar la sincronización.',
  'tasks.sync.blockedWithReason': '{count} cambio(s) de tareas necesitan atención: {reason}',
  'tasks.sync.retryAction': 'Reintentar sincronización',
  'tasks.sync.retrying': 'Reintentando sincronización…',
  'tasks.sync.refreshAction': 'Actualizar tareas',
  'tasks.sync.refreshing': 'Actualizando tareas…',
  'tasks.sync.retrySynced': 'La sincronización de tareas esta al dia.',
  'tasks.sync.retryPending': 'La sincronización de tareas sigue pendiente. Seguiremos reintentando.',
  'tasks.sync.retryOffline': 'Sin conexión aun. Los cambios de tareas siguen en cola de forma segura.',
  'tasks.sync.retryResolvedMissing': 'La sincronización termino con {count} cambio(s) en cola omitidos porque la tarea ya no existe en el servidor.',
  'tasks.sync.retryFailed': 'No se pudo reintentar la sincronización de tareas ahora.',
  'tasks.sync.refreshComplete': 'La lista de tareas se actualizo.',
  'tasks.sync.refreshFailed': 'No se pudo actualizar las tareas ahora.',
  'tasks.sync.lastResult': 'Último resultado de sincronización: {result}',
  'tasks.sync.lastAttempted': 'Último intento: {time}',
  'tasks.context.facility': 'Instalación',
  'tasks.context.productionUnit': 'Unidad de producción',
  'tasks.context.lot': 'Lote',
  'tasks.filter.allFacilities': 'Todas las granjas',
  'tasks.filter.allProductionUnits': 'Todas las unidades de producción',
  'tasks.filter.allUnitsInFacility': 'Todas las unidades en la instalación seleccionada',
  'tasks.filter.allLots': 'Todos los lotes',
  'tasks.filter.loadingLots': 'Cargando lotes…',
  'tasks.filter.noLotsForUnit': 'No hay lotes para la unidad seleccionada',
  'tasks.filter.allLotsInUnit': 'Todos los lotes en la unidad seleccionada',
  'tasks.speciesPresetPrefix': 'Preset de especie:',
  'tasks.selectionHelperSuffix': 'Las selecciones etiquetan nuevas tareas y filtran aquellas con metadatos coincidentes.',
  'tasks.section.taskList': 'Lista de tareas',
  'tasks.view.list': 'Lista',
  'tasks.view.agenda': 'Agenda',
  'tasks.view.month': 'Mes',
  'tasks.searchPlaceholder': 'Buscar tareas, etiquetas, personas',
  'tasks.clearFilters': 'Limpiar filtros',
  'tasks.export': 'Exportar',
  'tasks.import': 'Importar',
  'tasks.importing': 'Importando…',
  'tasks.loading': 'Cargando tareas...',
  'tasks.empty.noTasks': 'Aún no hay tareas. Crea una nueva tarea o aplica una sugerencia.',
  'tasks.empty.noMatches': 'Ninguna tarea coincide con las selecciones actuales. Ajusta los filtros para ver más.',
  'tasks.empty.searchNoMatch': 'Ninguna tarea coincide con esta búsqueda.',
  'tasks.empty.adjustFilters': 'No hay tareas para mostrar. Ajusta los filtros para ver tareas.',
  'tasks.empty.adjustFiltersOrGrouping': 'No hay tareas para mostrar. Ajusta filtros o agrupación para ver tareas.',
  'tasks.month.prev': 'Anterior',
  'tasks.month.today': 'Hoy',
  'tasks.month.next': 'Siguiente',
  'tasks.weekday.mon': 'Lun',
  'tasks.weekday.tue': 'Mar',
  'tasks.weekday.wed': 'Mié',
  'tasks.weekday.thu': 'Jue',
  'tasks.weekday.fri': 'Vie',
  'tasks.weekday.sat': 'Sáb',
  'tasks.weekday.sun': 'Dom',
  'tasks.table.what': 'Qué',
  'tasks.table.who': 'Quién',
  'tasks.table.when': 'Cuándo',
  'tasks.table.done': 'Hecho',
    'tasks.completion.completed': 'Completada',
    'tasks.completion.markDone': 'Marcar como hecha',
  'tasks.due.none': 'Sin fecha',
  'tasks.due.invalid': 'Fecha inválida',
  'tasks.due.overdueByPrefix': 'Atrasada por',
  'tasks.due.dueInPrefix': 'Vence en',
  'tasks.due.dueOnPrefix': 'Vence',
  'tasks.due.minute': 'minuto',
  'tasks.due.minutes': 'minutos',
  'tasks.due.hour': 'hora',
  'tasks.due.hours': 'horas',
  'tasks.due.day': 'día',
  'tasks.due.days': 'días',

  'tasks.statusInsight.completed.label': 'Completada',
  'tasks.statusInsight.completed.description.withAge': 'Finalizada hace {duration}.',
  'tasks.statusInsight.completed.description.noAge': 'Marcada como completada.',

  'tasks.statusInsight.blocked.unassigned.label': 'Sin asignar',
  'tasks.statusInsight.blocked.unassigned.description': 'Asigna un responsable para desbloquear el progreso.',
  'tasks.statusInsight.blocked.invalidDue.label': 'Fecha de vencimiento inválida',
  'tasks.statusInsight.blocked.invalidDue.description': 'No se pudo interpretar la fecha de vencimiento. Actualiza el cronograma.',

  'tasks.statusInsight.overdue.label': 'Vencida',
  'tasks.statusInsight.overdue.description': 'Vencida por {duration}.',
  'tasks.statusInsight.dueSoon.label': 'Por vencer',
  'tasks.statusInsight.dueSoon.description': 'Vence en {duration}.',
  'tasks.statusInsight.onTrack.label': 'En buen camino',
  'tasks.statusInsight.onTrack.description': 'Tiene responsable asignado y no hay una fecha límite próxima.',
  'tasks.suggestions.title': 'Sugerencias',
  'tasks.suggestions.subtitle': 'Las señales del panel sugieren las siguientes tareas. Haz clic para prellenar una nueva tarea.',
  'tasks.create.title': 'Crear nueva tarea',
  'tasks.create.viewerNoticeSignedInAs': 'Sesión iniciada como',
  'tasks.create.viewerNoticeReadOnlyPrefix': 'Las tareas son de solo lectura; para crear se requiere un token de',
  'tasks.create.viewerNoticeOr': 'o',
  'tasks.create.viewerNoticeTokenSuffix': '.',
  'tasks.form.whatLabel': '¿Qué debe ocurrir?',
  'tasks.form.whatPlaceholder': 'Describe la acción, el contexto y el resultado esperado',
  'tasks.form.additionalContextLabel': 'Contexto adicional (opcional)',
  'tasks.form.tagsLabel': 'Etiquetas',
  'tasks.form.tagsPlaceholder': 'alerta, agua, urgente',
  'tasks.form.tagsHint': 'Usa "alert" para mostrar en Alerta del sistema.',
    'tasks.edit.tagsPlaceholder': 'Etiquetas (separadas por comas)',
  'tasks.form.responsibleLabel': 'Responsable',
  'tasks.form.responsiblePlaceholder': 'Selecciona un compañero',
  'tasks.form.collaboratorsLabel': 'Colaboradores',
  'tasks.form.objectiveLabel': 'Agrupar bajo objetivo',
  'tasks.form.objectivePlaceholder': 'Tarea independiente',
  'tasks.form.objectiveHelp': 'Vincula trabajo relacionado a un objetivo compartido para que todos vean la cadena de dependencias.',
  'tasks.form.whenLabel': 'Cuándo',
  'tasks.form.reminderCadenceLabel': 'Cadencia de recordatorio',
  'tasks.form.enableReminders': 'Habilitar recordatorios',
  'tasks.form.saving': 'Guardando...',
  'tasks.form.addTask': 'Agregar tarea',
  'tasks.reminder.off': 'Recordatorios desactivados',
    'tasks.reminder.on': 'Recordatorios activados',
  'tasks.reminder.cadencePrefix': 'Cadencia:',
  'tasks.cadence.every30min': 'Cada 30 minutos',
  'tasks.cadence.every2h': 'Cada 2 horas',
  'tasks.cadence.every12h': 'Cada 12 horas',
  'tasks.cadence.every24h': 'Cada 24 horas',
  'tasks.cadence.every3d': 'Cada 3 días',

    'tasks.group.expandAria': 'Expandir grupo',
    'tasks.group.collapseAria': 'Contraer grupo',
    'tasks.clarity.clear': 'Claro para el equipo',
    'tasks.groupInsight.label': 'Resumen del grupo:',
    'tasks.assignee.unassigned': 'Sin asignar',
    'tasks.collaborators.prefix': 'Colaboradores:',
    'tasks.objective.prefix': 'Objetivo:',
    'tasks.groupSummary.linkedTaskSingularSuffix': 'tarea vinculada',
    'tasks.groupSummary.linkedTaskPluralSuffix': 'tareas vinculadas',
    'tasks.groupSummary.overdueSingularSuffix': 'atrasada',
    'tasks.groupSummary.overduePluralSuffix': 'atrasadas',
    'tasks.groupSummary.activeSingularSuffix': 'activa',
    'tasks.groupSummary.activePluralSuffix': 'activas',
    'tasks.groupSummary.doneSingularSuffix': 'hecha',
    'tasks.groupSummary.donePluralSuffix': 'hechas',
    'tasks.groupSummary.unassignedSingularSuffix': 'sin asignar',
    'tasks.groupSummary.unassignedPluralSuffix': 'sin asignar',

    // Database (Production Data Table)
    'datatable.title': 'Tabla de datos de producción',
    'datatable.lead.editable': 'Edita celdas en cualquier momento — los cambios se guardan offline en este dispositivo y se sincronizan cuando hay conexión.',
    'datatable.lead.readonlyPrefix': 'Modo de solo lectura',
    'datatable.lead.readonlySuffix': 'Editar y sincronizar registros de producción requiere un token de editor.',

    'datatable.context.facility': 'Instalación',
    'datatable.context.productionUnit': 'Unidad de producción',
    'datatable.filter.allFacilities': 'Todas las granjas',
    'datatable.filter.allProductionUnitsShort': 'Todas las UP',

    'datatable.action.exportCsv': 'Exportar CSV',
    'datatable.action.importWorkspace': 'Espacio de importación',
    'datatable.action.syncNow': 'Sincronizar ahora',
    'datatable.action.fuseLegacyDuplicates': 'Fusionar duplicados ({count})',
    'datatable.action.fuseLegacyDuplicatesTitle': 'Combina filas heredadas con el mismo lote y fecha en una sola, preservando muestreos y eventos de mortalidad.',
    'datatable.table.actions': 'Acciones',
    'datatable.hint.selectContextForImport': 'Selecciona una Granja y una Unidad de producción para habilitar la importación CSV.',

    'datatable.syncNow.offline': 'Estás sin conexión. Los cambios se guardan localmente y se sincronizarán cuando haya internet.',
    'datatable.syncNow.started': 'Sincronización iniciada. Si la conexión es inestable, continuará cuando haya internet.',
    'datatable.syncNow.failed': 'No se pudo iniciar la sincronización. Intenta de nuevo cuando la conexión esté estable.',
    'datatable.sync.title': 'Estado de sincronización',
    'datatable.sync.retryAction': 'Reintentar sincronización',
    'datatable.sync.refreshAction': 'Actualizar registros',
    'datatable.sync.retrySynced': 'La sincronización de Base de Datos ya está al día.',
    'datatable.sync.retryOffline': 'Los cambios de Base de Datos quedan locales mientras este dispositivo esté sin conexión.',
    'datatable.sync.retryPending': 'Los cambios de Base de Datos siguen pendientes de sincronización.',
    'datatable.sync.blocked': '{count} cambio(s) de producción están bloqueados.',
    'datatable.sync.blockedWithReason': '{count} cambio(s) de producción están bloqueados: {reason}',
    'datatable.sync.retryResolvedMissing': 'El reintento omitió {count} cambio(s) de producción faltante(s) y sincronizó el resto.',
    'datatable.sync.retryFailed': 'Falló el reintento de sincronización de Base de Datos.',
    'datatable.sync.refreshFailed': 'No se puede actualizar el estado de sincronización de Base de Datos ahora.',
    'datatable.sync.attentionBlocked': '{count} cambio(s) de producción están bloqueados y requieren atención.',
    'datatable.sync.attentionBlockedWithReason': '{count} cambio(s) de producción están bloqueados: {reason}',
    'datatable.sync.attentionOffline': 'Este dispositivo está sin conexión. Los cambios de Base de Datos se sincronizarán cuando vuelva la conexión.',
    'datatable.sync.attentionPending': 'Los cambios de Base de Datos están en cola y siguen pendientes de sincronización.',
    'datatable.sync.lastResult': 'Último resultado de sincronización: {result}',
    'datatable.sync.lastAttempted': 'Último intento: {time}',

    'datatable.notification.closeTitle': 'Cerrar notificación',
    'datatable.lotNotice.label': 'Aviso de lote:',

    'datatable.dateNotice.title': 'Aviso de formato de fecha:',
    'datatable.dateNotice.message': 'Usa el selector de fecha/hora. Fechas CSV como DD/MM/AAAA HH:mm se normalizan automáticamente.',

    'datatable.empty.noDataTitle': 'No se encontraron datos de producción.',
    'datatable.emptyRows.hidden': '{count} días pasados sin ningún registro están ocultos (se eliminaron sus registros o el lote).',
    'datatable.emptyRows.shown': 'Mostrando {count} días pasados sin ningún registro.',
    'datatable.movedLot.tag': 'trasladado a otra unidad',
    'datatable.movedLot.tagTo': 'trasladado a {unit}',
    'datatable.movedLot.title': 'Este lote ya no está en esta unidad: fue trasladado a otra. Sus registros aquí se conservan y siguen en el historial del lote, pero no se pueden editar.',
    'datatable.movedLot.readOnly': 'Esta fila es de un lote que fue trasladado a otra unidad y no se puede editar aquí.',
    'datatable.movedLot.hidden': '{count} filas de lotes trasladados a otra unidad están ocultas (se conservan en el historial del lote).',
    'datatable.movedLot.hiddenOne': '1 fila de un lote trasladado a otra unidad está oculta (se conserva en el historial del lote).',
    'datatable.movedLot.shown': 'Mostrando {count} filas de lotes trasladados a otra unidad (solo lectura).',
    'datatable.movedLot.shownOne': 'Mostrando 1 fila de un lote trasladado a otra unidad (solo lectura).',
    'datatable.deletedLot.tag': 'lote eliminado',
    'datatable.context.lot': 'Lote',
    'datatable.filter.allLots': 'Todos los lotes',
    'datatable.lotFilter.moved': '(trasladado)',
    'datatable.lotFilter.from': 'desde {day}',
    'datatable.deletedLot.title': 'Este lote fue eliminado. Sus registros se conservan pero no se pueden editar. Para recuperarlo: Lotes → Lotes eliminados → Restaurar.',
    'datatable.deletedLot.readOnly': 'Esta fila es de un lote eliminado y no se puede editar. Restaura el lote en Lotes → Lotes eliminados.',
    'datatable.deletedLot.hidden': '{count} filas de lotes eliminados están ocultas (se conservan; Lotes → Lotes eliminados → Restaurar las recupera).',
    'datatable.deletedLot.hiddenOne': '1 fila de un lote eliminado está oculta (se conserva; Lotes → Lotes eliminados → Restaurar la recupera).',
    'datatable.deletedLot.shown': 'Mostrando {count} filas de lotes eliminados (solo lectura).',
    'datatable.deletedLot.shownOne': 'Mostrando 1 fila de un lote eliminado (solo lectura).',
    'datatable.emptyRows.show': 'Mostrar',
    'datatable.emptyRows.hide': 'Ocultar',
    'datatable.emptyRows.hiddenOne': '1 día pasado sin ningún registro está oculto (se eliminaron sus registros o el lote).',
    'datatable.emptyRows.shownOne': 'Mostrando 1 día pasado sin ningún registro.',
    'datatable.empty.noDataSubtitle': 'Agrega un nuevo registro para comenzar.',

    'datatable.date.placeholder': 'YYYY-MM-DDThh:mm',
    'datatable.date.invalidHint': 'Fecha inválida — usa el selector de fecha/hora',

    'datatable.readonly.cannotEditRecords': 'Acceso de solo lectura: este token no puede editar registros de producción.',
    'datatable.readonly.cannotDeleteRecords': 'Acceso de solo lectura: este token no puede eliminar registros de producción.',
    'datatable.readonly.cannotImportRecords': 'Acceso de solo lectura: este token no puede importar registros de producción.',

    'datatable.error.activeLotRequired': 'Selecciona un lote activo antes de asignar un registro de producción.',
    'datatable.error.lotEditOutsideRecovery': 'Editá el lote en la pantalla de captura original, no en el rollup.',

    'datatable.import.noFileSelected': 'No se seleccionó archivo.',
    'datatable.import.selectCsvFile': 'Selecciona un archivo CSV.',
    'datatable.import.fileEmpty': 'El archivo está vacío o no se pudo leer.',
    'datatable.import.noRowsFound': 'No se encontraron filas en el CSV',
    'datatable.import.success': '¡CSV importado correctamente!',
    'datatable.import.clearedForLimitsPrefix': 'Algunos valores excedieron límites',
    'datatable.import.numericExceededNotice': 'Algunos valores importados excedieron límites numéricos. Revisa esas celdas en la tabla.',

    'datatable.lots.autoCreatedPrefix': 'Lotes auto-creados:',
    'datatable.lots.autoCreatedSuffix': '— agregados a Lotes para la Granja + Unidad de producción seleccionadas.',
    'datatable.lots.foundNotValidatedPrefix': 'Lotes encontrados en el archivo pero no validados (sin Granja + Unidad de producción seleccionadas):',
    'datatable.lots.ambiguousPrefix': 'Lotes con coincidencias ambiguas en el registro dejados para mapeo manual:',
    'datatable.lots.leftUnmappedPrefix': 'Lotes no registrados y dejados sin mapear:',

    'datatable.numericNotice.storedPrefix': 'Algunos valores guardados eran inválidos o estaban fuera de los rangos permitidos',
    'datatable.numericNotice.storedSuffix': 'Revisa esas celdas en la tabla.',

    'datatable.storageWriteFailed': 'No se pudo guardar localmente en este dispositivo (el almacenamiento puede estar lleno). Exporta el CSV como respaldo, luego borra datos/cachés del sitio (especialmente respaldos de la tabla de producción) e inténtalo de nuevo.',

    'datatable.numericValidation.mustBeNumber': '{label} debe ser un número.',
    'datatable.numericValidation.mustBeWholeNumber': '{label} debe ser un número entero.',
    'datatable.numericValidation.min': '{label} debe ser al menos {min}.',
    'datatable.numericValidation.max': '{label} debe ser {max} o menos.',

    'datatable.feedKg.autoLabel': 'Auto desde registros de Alimento',
    'datatable.feedKg.autoTitle': 'Auto-rellenado desde registros de Alimento (edita para sobrescribir).',
    'datatable.feedKg.manualLabel': 'Anulación manual',
    'datatable.feedKg.manualTitle': 'Valor ingresado manualmente (no será sobrescrito por el auto-rellenado).',

    'datatable.weight.lastKnownLabel': 'último',
    'datatable.weight.lastKnownTitle': 'Último peso promedio registrado para este lote (de un muestreo anterior). Se muestra como referencia; no se almacena en esta fila.',
    'datatable.fishStock.derivedLabel': 'derivado',
    'datatable.fishStock.derivedTitle': 'Stock de fin de dia derivado del stock previo conocido menos la mortalidad diaria. El valor almacenado de stock de peces permanece en blanco.',
    'datatable.fishStock.derivedUnknownLabel': 'sin stock previo',
    'datatable.fishStock.derivedUnknownTitle': 'No se puede derivar el stock porque ninguna fila previa tiene un valor conocido para este lote. Registra un stock inicial para habilitar la derivación.',

    'datatable.sameDayRows.badge': '{count} filas este día',
    'datatable.sameDayRows.badgeTitle': 'Este día tiene {count} filas de muestreo para este lote. Haz clic para ver cada fila del día.',
    'datatable.sameDayRows.popover.title': 'Filas del mismo día — {lot} · {date}',
    'datatable.sameDayRows.popover.total': '{count} filas registradas este día',
    'datatable.sameDayRows.popover.empty': 'No hay otras filas enlazadas a este día.',
    'datatable.sameDayRows.popover.column.time': 'Hora',
    'datatable.sameDayRows.popover.column.weight': 'Peso (g)',
    'datatable.sameDayRows.popover.column.mortality': 'Mortalidad',
    'datatable.sameDayRows.popover.column.stock': 'Stock',
    'datatable.sameDayRows.popover.close': 'Cerrar',

    'datatable.mortalityRate.cell': '{pct}%',
    'datatable.mortalityRate.cellTitle': 'Tasa de mortalidad diaria: {count} muertes ÷ {stock} peces al inicio del día. Derivada sobre datos sincronizados; no se almacena.',
    'datatable.mortalityRate.readOnly': 'La mortalidad diaria % es un indicador calculado (mortalidad ÷ stock al inicio del día); no se puede editar aquí.',
    'datatable.mortalityRate.severity.green': 'Dentro de lo esperado ({expected}% según la matriz de mortalidad). Clic para crear una tarea.',
    'datatable.mortalityRate.severity.yellow': 'Por encima de lo esperado ({expected}% según la matriz de mortalidad). Clic para crear una tarea.',
    'datatable.mortalityRate.severity.red': 'Muy por encima de lo esperado ({expected}% según la matriz de mortalidad, 1.5x o más). Clic para crear una tarea.',
    'datatable.mortalityRate.stage.green': '{day}: dentro de la referencia (verde hasta {green} %/día, rojo desde {red} %; Editar instalación → Incubación). Clic para crear una tarea.',
    'datatable.mortalityRate.stage.yellow': '{day}: por encima de lo esperado (verde hasta {green} %/día, rojo desde {red} %; Editar instalación → Incubación). Clic para crear una tarea.',
    'datatable.mortalityRate.stage.red': '{day}: muy por encima de lo esperado (rojo desde {red} %/día; Editar instalación → Incubación). Clic para crear una tarea.',
    'datatable.mortalityRate.stage.eggs': 'Ovas',
    'datatable.mortalityRate.stage.yolkSac': 'Alevines con saco',
    'datatable.mortalityRate.stage.critical': 'Día crítico ({moment})',
    'datatable.mortalityRate.critical.arrival': 'llegada y reincubación de las ovas',
    'datatable.mortalityRate.critical.hatch': 'eclosión',
    'datatable.mortalityRate.critical.firstFeeding': 'primera alimentación',
    'datatable.mortalityRate.critical.firstTransfer': 'primer traslado',
    'datatable.mortalityRate.missing.noWeight': 'Falta peso: registra un muestreo del lote para comparar con la matriz de mortalidad. Clic para crear una tarea.',
    'datatable.mortalityRate.missing.noTemperature': 'Falta temperatura: no hay lectura de temperatura del lote en los últimos 7 días para comparar con la matriz. Clic para crear una tarea.',
    'datatable.mortalityRate.taskTitle': 'Revisar mortalidad — lote {lot} ({date})',
    'datatable.mortality.derivedFromEventsLabel': 'de {count} eventos',
    'datatable.mortality.derivedFromEventsTitle': 'La mortalidad diaria es la suma canónica de {count} eventos de mortalidad registrados para este lote y fecha. El valor almacenado de la fila se preserva pero no se muestra; edita eventos individuales desde la pantalla Biomasa.',
    'datatable.mortality.readOnlyEditAttempt': 'La mortalidad diaria es de solo lectura aquí porque existen eventos de mortalidad para este lote y fecha. Edita eventos individuales desde la pantalla Biomasa.',
    'datatable.weight.readOnlyEditAttempt': 'El peso es de solo lectura aquí porque existen muestras de peso registradas para este lote y fecha. Registra nuevas muestras desde la pantalla Biomasa (Muestreo).',
    'datatable.harvest.readOnlyEditAttempt': 'La cosecha es de solo lectura aquí porque existen eventos de cosecha para este lote y fecha. Registra o edita la cosecha desde la pantalla Biomasa.',
    'datatable.date.readOnlyEditAttempt': 'La fecha de esta fila es de solo lectura aquí — cambiarla directamente la desconectaría de sus propios eventos de peso, mortalidad y cosecha. Para mover un registro a otra fecha, corrígelo desde la pantalla Biomasa.',
    'datatable.mortality.events.badgeAction': 'Haz clic para ver los {count} eventos individuales de mortalidad que suman este total diario.',
    'datatable.mortality.events.popover.title': 'Eventos de mortalidad — {lot} · {date}',
    'datatable.mortality.events.popover.total': '{count} eventos · total diario: {sum}',
    'datatable.mortality.events.popover.column.time': 'Hora',
    'datatable.mortality.events.popover.column.count': 'Cantidad',
    'datatable.mortality.events.popover.column.notes': 'Notas',
    'datatable.mortality.events.popover.close': 'Cerrar',
    'datatable.mortality.events.popover.empty': 'No hay eventos de mortalidad enlazados a esta fila.',
    'datatable.mortality.events.popover.column.actions': 'Acciones',
    'datatable.mortality.events.popover.delete': 'Borrar',
    'datatable.mortality.events.popover.deleteTitle': 'Borra este evento de mortalidad (no borra la fila de muestreo).',
    'datatable.mortality.events.popover.deleteConfirm': '¿Borrar este evento de mortalidad de {count} a las {time}? No se puede deshacer.',
    'datatable.mortality.events.popover.deleteCta': 'Confirmar eliminar',
    'datatable.mortality.events.popover.deleting': 'Borrando…',

    'datatable.sampling.averagedFromEventsLabel': 'promediado de {count} muestreos',
    'datatable.sampling.averagedFromEventsTitle': 'Este peso promedio es la media aritmética de {count} muestreos registrados para este lote y fecha. Haz clic para revisar los pesos individuales.',
    'datatable.sampling.events.badgeAction': 'Haz clic para ver los {count} muestreos individuales que componen este peso promedio.',
    'datatable.sampling.events.popover.title': 'Muestreos del día — {lot} · {date}',
    'datatable.sampling.events.popover.total': '{count} muestreos · peso promedio: {mean} g',
    'datatable.sampling.events.popover.column.time': 'Hora',
    'datatable.sampling.events.popover.column.weight': 'Peso (g)',
    'datatable.sampling.events.popover.column.length': 'Longitud',
    'datatable.sampling.events.popover.close': 'Cerrar',
    'datatable.sampling.events.popover.empty': 'No hay muestreos individuales registrados para esta fila.',

    'datatable.legacyDuplicates.modal.title': 'Fusionar filas duplicadas heredadas',
    'datatable.legacyDuplicates.modal.subtitle': '{groupCount} grupos · {affected} filas → {kept} fila por grupo · {deleted} filas se eliminarán.',
    'datatable.legacyDuplicates.modal.intro': 'Esta acción combina filas con el mismo lote y fecha en una sola. El peso será el promedio aritmético de las muestras, el stock final mantendrá el valor más reciente y los eventos de mortalidad enlazados se rebindean a la fila conservada. La acción no se puede deshacer automáticamente.',
    'datatable.legacyDuplicates.modal.itemFormat': '{lot} · {date} · {from} filas → 1 ({rebinds} eventos rebindados)',
    'datatable.legacyDuplicates.modal.truncatedHint': 'Mostrando {shown} de {total} grupos.',
    'datatable.legacyDuplicates.modal.cancel': 'Cancelar',
    'datatable.legacyDuplicates.modal.confirm': 'Confirmar fusión',
    'datatable.legacyDuplicates.modal.running': 'Fusionando…',
    'datatable.legacyDuplicates.toast.success': 'Fusión completada: {kept} fila por grupo, {deleted} filas eliminadas, {rebinds} eventos rebindados.',
    'datatable.legacyDuplicates.toast.failure': 'Error al fusionar duplicados. Detalle: {reason}',

    'datatable.column.weight': 'Peso (g)',
    'datatable.column.dailyMortality': 'Mortalidad diaria',
    'datatable.column.dailyMortalityRate': 'Mortalidad diaria %',
    'datatable.column.fishStock': 'Stock (peces u ovas)',
    'datatable.column.plCount': 'Conteo de PL',
    'datatable.column.mort': 'Tratamiento',
    'datatable.column.do': 'Longitud',
    'datatable.column.upVol': 'Notas',
    'datatable.column.avgLengthMm': 'Longitud prom. (mm)',
    'datatable.column.feedKg': 'Alimento (kg)',
    'datatable.column.fcr': 'FCR',
    'datatable.column.feedProteinPct': '% proteína del alimento',
    'datatable.column.harvestKg': 'Cosecha (kg)',
    'datatable.column.harvestCount': 'Cosecha (conteo)',
    'datatable.column.temperatureC': 'Temperatura (°C)',
    'datatable.column.salinityPpt': 'Salinidad (ppt)',

    'datatable.option.none': '(ninguno)',
    'datatable.lot.noneYet': 'Aún no hay lotes',
    'datatable.lot.createInLotsHelp': 'Crea un Lote en la pantalla de Lotes para habilitar la selección aquí.',
    'datatable.lot.goToLots': 'Ir a Lotes',
    'datatable.lot.clearedNotInList': 'Limpio (no está en la lista de lotes)',
    'datatable.lot.ambiguousPrefix': 'Coincidencia ambigua:',
    'datatable.lot.unmappedPrefix': 'Sin mapear:',
    'datatable.lot.mapToExisting': 'Mapear a existente',
    'datatable.lot.ignoreUnmapped': 'Ignorar etiqueta',
    'datatable.mortalityGuide.recommendation': 'Guía de matriz: mortalidad esperada {expectedMortality}% a {temperature}°C. Supervivencia proyectada {projectedSurvival}%, stock proyectado {projectedStock}, biomasa proyectada {projectedBiomass} kg.',
    'datatable.mortalityGuide.noTemperature': 'La guía de matriz está lista, pero este lote aún no tiene temperatura de agua asociada para la misma semana.',
    'datatable.mortalityGuide.missingInputs': 'Agrega fecha, lote, peso y stock para mostrar aquí la recomendación de la matriz de mortalidad.',

    'datatable.stage.active': 'Activo',
    'datatable.stage.inactive': 'Inactivo',
    'datatable.health.good': 'Bueno',
    'datatable.health.issue': 'Problema',
    'datatable.health.emergency': 'Emergencia',
    'datatable.treatment.vaccine': 'Vacuna',
    'datatable.treatment.antibiotic': 'Antibiótico',
    'datatable.treatment.disinfectant': 'Desinfectante',
    'datatable.treatment.salt': 'Sal',
    'datatable.treatment.other': 'Otro',

    // Costs (v2.2 T3-C-07 — pantalla dedicada /costs para el stream Tier A LotCostEvent)
    'costs.title': 'Costos',
    'costs.subtitle': 'Registra costos manuales (Genética / Sanidad / Mano de obra) por lote y revisa los costos de alimento derivados automáticamente.',
    'costs.readonly.banner': 'Modo de solo lectura. Registrar o editar costos requiere un token de editor.',
    'costs.context.facility': 'Instalación',
    'costs.context.productionUnit': 'Unidad de producción',
    'costs.context.lot': 'Lote',
    'costs.placeholder.selectFacility': 'Selecciona una instalación...',
    'costs.placeholder.selectFacilityFirst': 'Primero selecciona una instalación...',
    'costs.placeholder.selectProductionUnit': 'Selecciona unidad de producción...',
    'costs.placeholder.selectLot': 'Selecciona un lote...',
    'costs.placeholder.noLotsInScope': 'No hay lotes en este alcance',

    // Water
    'water.title': '🌊 Parámetros de calidad del agua',
    'water.readonly.bannerPrefix': 'Modo de solo lectura (token ',
    'water.readonly.bannerMiddle': ').',
    'water.readonly.bannerSuffix': 'Editar registros de agua y crear lotes requiere un token de editor.',

    'water.context.facility': 'Instalación',
    'water.context.productionUnit': 'Unidad de producción',

    'water.placeholder.selectFacility': 'Selecciona una instalación...',
    'water.placeholder.selectFacilityFirst': 'Primero selecciona una instalación...',
    'water.placeholder.selectProductionUnit': 'Selecciona unidad de producción...',

    'water.action.exportCsv': 'Exportar CSV',
    'water.action.importWorkspace': 'Espacio de importación',
    'water.action.importCsv': 'Importar CSV',
    'water.action.addMeasurement': '+ Agregar medición',
    'water.action.refreshLogs': 'Actualizar registros de agua',
    'water.hint.selectContextForImport': 'Selecciona una Granja y una Unidad de producción para habilitar la importación de agua.',

    'water.notification.closeTitle': 'Cerrar notificación',
    'water.lotNotice.label': 'Aviso de lote:',

    'water.dateNotice.title': 'Aviso de formato de fecha:',
    'water.dateNotice.message': 'Usa el selector de fecha/hora. Fechas CSV como DD/MM/AAAA HH:mm se normalizan automáticamente.',

    'water.date.placeholder': 'YYYY-MM-DDThh:mm',
    'water.date.invalidHint': 'Fecha inválida — usa el selector de fecha/hora',

    'water.import.readonlyCannotImport': 'Acceso de solo lectura: este token no puede importar registros de agua.',
    'water.import.noFileSelected': 'No se seleccionó archivo.',
    'water.import.selectCsvFile': 'Selecciona un archivo CSV.',
    'water.import.fileEmpty': 'El archivo está vacío o no se pudo leer.',
    'water.import.success': '¡CSV importado correctamente!',

    'water.status.savedOffline': 'El registro de agua se guardó localmente sin conexión.',
    'water.status.savedPending': 'El registro de agua se guardó localmente. La sincronización con el servidor está pendiente.',
    'water.status.savedSynced': 'El registro de agua se sincronizó.',
    'water.status.deletedOffline': 'El registro de agua se eliminó localmente sin conexión.',
    'water.status.deletedPending': 'El registro de agua se eliminó localmente. La sincronización con el servidor está pendiente.',
    'water.status.deletedSynced': 'La eliminación del registro de agua se sincronizó.',
    'water.status.refreshing': 'Actualizando registros de agua...',
    'water.status.refreshComplete': 'Los registros de agua se actualizaron desde el servidor.',
    'water.status.refreshFailed': 'No se pudieron actualizar los registros de agua en este momento.',
    'water.sync.retrySynced': 'La sincronización de agua ya esta al dia.',
    'water.sync.retryOffline': 'Los cambios de agua quedan solo locales mientras este dispositivo esta sin conexión.',
    'water.sync.retryPending': 'Los cambios de agua siguen pendientes de sincronización.',
    'water.sync.blocked': '{count} cambio(s) de agua requieren atención antes de sincronizarse.',
    'water.sync.blockedWithReason': '{count} cambio(s) de agua requieren atención: {reason}',
    'water.sync.retryResolvedMissing': 'El reintento omitió {count} cambio(s) de agua faltantes y continuo con el resto.',
    'water.sync.retryAction': 'Reintentar sincronización',
    'water.sync.retrying': 'Reintentando sincronización...',
    'water.sync.refreshAction': 'Actualizar registros de agua',
    'water.sync.refreshing': 'Actualizando registros de agua...',
    'water.sync.lastResult': 'Último resultado de sincronización: {result}',
    'water.sync.lastAttempted': 'Último intento: {time}',
    'water.sync.baselineCaughtUp': 'La sincronización de Agua está al día. No hay cambios en cola.',


    'water.readonly.cannotAddMeasurements': 'Acceso de solo lectura: este token no puede agregar mediciones de agua.',
    'water.readonly.cannotDeleteMeasurements': 'Acceso de solo lectura: este token no puede eliminar mediciones de agua.',

    'water.option.none': '(ninguno)',
    'water.lot.loadingLots': 'Cargando lotes…',
    'water.lot.noneYet': 'Aún no hay lotes',
    'water.lot.selectContext': 'Selecciona una Granja + Unidad de producción',
    'water.lot.createInLotsHelp': 'Crea un Lote en la pantalla de Lotes para habilitar la selección aquí.',
    'water.lot.selectContextHelp': 'Selecciona una Granja y una Unidad de producción para cargar la lista de lotes.',
    'water.lot.savedLabelPrefix': 'Etiqueta guardada:',
    'water.lot.ambiguousPrefix': 'Coincidencia ambigua:',
    'water.lot.unmappedPrefix': 'Sin mapear:',
    'water.lot.clearedNotInList': 'Limpio (no está en la lista de lotes)',
    'water.lot.transferredTag': 'transferido',
    'water.lot.transferredTitle': 'Este lote fue transferido a otra unidad productiva. Sus lecturas aquí siguen visibles pero de solo lectura: gestiona el lote desde su unidad actual.',
    'water.lot.deletedTag': 'lote eliminado',
    'water.lot.deletedTitle': 'Este lote se eliminó; la lectura se conserva como registro del estanque.',
    'water.lot.ignoreUnmapped': 'Ignorar etiqueta',
    'water.lot.goToLots': 'Ir a Lotes',

    'water.lots.autoCreatedPrefix': 'Lotes auto-creados:',
    'water.lots.autoCreatedSuffix': '— agregados a Lotes para la Granja + Unidad de producción seleccionadas.',
    'water.lots.foundNotValidatedPrefix': 'Lotes encontrados en el archivo pero no validados (sin Granja + Unidad de producción seleccionadas):',
    'water.lots.ambiguousPrefix': 'Lotes con coincidencias ambiguas en el registro dejados para mapeo manual:',
    'water.lots.leftUnmappedPrefix': 'Lotes no registrados y dejados sin mapear:',

    'water.table.date': 'Fecha',
    'water.table.lot': 'Lote',
    'water.table.temperature': 'Temperatura (°C)',
    'water.table.ph': 'pH',
    'water.table.doEstimated': 'OD (mg/L) estimado',
    'water.table.doSaturationEstimated': 'Saturación de OD (%) vs nivel del mar',
    'water.table.doManual': 'OD (mg/L) manual',
    'water.table.doSaturationManual': 'Saturación de OD (%) vs nivel del mar (manual)',
    'water.table.salinity': 'Salinidad (‰)',
    'water.table.notes': 'Notas',
    'water.table.actions': 'Acciones',
    'water.lockedRowHint': 'Lectura guardada: se cambia o elimina con "Corregir…" (con motivo obligatorio; se guardan los valores anteriores).',
    'water.delete.draftReason': 'Fila nueva eliminada mientras se escribía',

    'water.placeholder.celsius': '°C',
    'water.placeholder.ph': 'pH',
    'water.placeholder.salinity': '‰',
    'water.placeholder.manualReading': 'Lectura manual',
    'water.placeholder.manualSaturation': '% saturación manual',
    'water.placeholder.observations': 'Observaciones...',

    'water.do.autoFromPrefix': 'Auto desde',
    'water.do.vsSeaLevelStandard': 'vs estándar a nivel del mar',
    'water.do.manualSaturationDerived': 'Auto desde el OD manual y la temperatura: {value}%',

    'water.empty.title': '🌊 Aún no hay mediciones de calidad del agua.',
    'water.empty.subtitlePrefix': 'Haz clic en "',
    'water.empty.subtitleAction': 'Agregar medición',
    'water.empty.subtitleSuffix': '" para comenzar a monitorear tu sistema acuícola.',

    'water.info.do.heading': '🌡️🏔️ ⇄ 💧 Oxígeno disuelto corregido por temperatura y altitud',
    'water.info.do.baseFormula': 'Fórmula base:',
    'water.info.do.altitudeCorrection': 'Corrección por altitud:',
    'water.info.do.currentAltitudePrefix': 'Altitud actual:',
    'water.info.do.pressureRatioPrefix': 'ratio de presión:',
    'water.info.do.examplesPrefix': 'Ejemplos a',
    'water.info.do.examplesSeaLevel': '10°C → 11.3 mg/L | 20°C → 9.1 mg/L',
    'water.info.do.tip': '💡 El oxígeno disuelto se estima automáticamente a partir de la temperatura y la altitud de la granja (configurada en Editar instalación). A mayor altitud = menor OD por menor presión atmosférica. Usa la columna "OD manual" para valores medidos.',

    'water.info.monitoring.title': '💡 Información de monitoreo de calidad del agua',
    'water.info.monitoring.temperature.title': '🌡️ Temperatura (°C)',
    'water.info.monitoring.temperature.optimalRangeLabel': 'Rango óptimo:',
    'water.info.monitoring.temperature.optimalRangeValue': '9-17°C para cálculos de SFR',
    'water.info.monitoring.temperature.note': 'La temperatura se usa automáticamente en el sistema de Matriz SFR.',
    'water.info.monitoring.ph.title': '🧪 Nivel de pH',
    'water.info.monitoring.ph.optimalRangeLabel': 'Rango óptimo:',
    'water.info.monitoring.ph.optimalRangeValue': '6.5-8.5',
    'water.info.monitoring.ph.note': 'Monitorea acidez/alcalinidad para una salud óptima de los peces.',
    'water.info.monitoring.do.title': '💨 Oxígeno disuelto',
    'water.info.monitoring.do.minimumLabel': 'Mínimo:',
    'water.info.monitoring.do.minimumValue': '5.0 mg/L',
    'water.info.monitoring.do.note': 'Crítico para la respiración y la salud del sistema.',
    'water.info.monitoring.salinity.title': '🧂 Salinidad',
    'water.info.monitoring.salinity.variesBySpecies': 'Varía según la especie',
    'water.info.monitoring.salinity.note': 'Monitorea la concentración de sal en sistemas marinos.',

    // Feed
    'feed.title': '🐟 Planificación de alimento y KPIs',

    'feed.context.facility': 'Instalación',
    'feed.context.productionUnit': 'Unidad de producción',

    'feed.placeholder.selectFacility': 'Selecciona una instalación...',
    'feed.placeholder.selectFacilityFirst': 'Primero selecciona una instalación...',
    'feed.placeholder.selectProductionUnit': 'Selecciona unidad de producción...',

    'feed.stockMetric.fishStock': 'Stock de peces',
    'feed.stockMetric.plCount': 'Conteo de PL',

    'feed.summary.calculationPeriods': '{count} períodos de cálculo',

    'feed.section.actualFed.title': 'Alimento real (eventos de alimentación)',
    'feed.section.actualFed.lead': 'Registra cada evento de alimentación. Se guarda primero offline y se sincroniza al estar en línea.',
    'feed.readonly.banner': 'Modo de solo lectura (token {role}). Crear, editar y eliminar eventos de alimento requiere un token de editor.',

    'feed.form.recordedAt': 'Registrado en',
    'feed.form.lot': 'Lote',
    'feed.form.feedKg': 'Alimento (kg)',
    'feed.form.feedKg.placeholder': 'p. ej. 12.5',
    'feed.form.feedType': 'Tipo de alimento (opcional)',
    'feed.form.feedType.placeholder': 'p. ej. pellet 3mm',
    'feed.form.feedType.suggestionsHelp': 'Sugerencias basadas en tipos registrados en esta granja en los últimos {days} días.',
    'feed.form.notes': 'Notas (opcional)',
    'feed.form.feedingResponse': 'Respuesta a la alimentación (opcional)',
    'feed.form.feedingResponseHelp': 'Cómo tomaron los peces el alimento. Crew Mode no lo pregunta.',
    'feed.feedingResponse.notRecorded': 'Sin registrar',
    'feed.feedingResponse.good': 'Buena — comieron con ganas',
    'feed.feedingResponse.normal': 'Normal',
    'feed.feedingResponse.poor': 'Pobre — sobró alimento',
    'feed.feedingResponse.none': 'No comieron',
    'feed.table.response': 'Respuesta: {response}',
    'feed.table.mixPart': 'Mezcla: {mix}',
    'feed.table.weighed': 'Pesado {weighed} kg − sobrante {leftover} kg',
    'feed.table.weighedNoLeftover': 'Pesado {weighed} kg · sin sobrante',
    'feed.table.feedLot': 'Lote de alimento {lot}',

    'feed.lots.loadingLots': 'Cargando lotes…',
    'feed.lots.noneLoaded': 'No hay lotes cargados',

    'feed.errors.lotsPrefix': 'Lotes:',
    'feed.errors.eventsPrefix': 'Eventos de alimento:',

    'feed.error.readonlyCannotCreateOrEdit': 'Acceso de solo lectura: este token no puede crear ni editar eventos de alimento.',
    'feed.error.readonlyCannotEdit': 'Acceso de solo lectura: este token no puede editar eventos de alimento.',
    'feed.error.readonlyCannotDelete': 'Acceso de solo lectura: este token no puede eliminar eventos de alimento.',
    'feed.confirm.deleteEvent': '¿Eliminar este evento de alimento?',
    'feed.confirm.deleteEventCta': 'Confirmar eliminar',
    'feed.error.activeLotRequired': 'Selecciona un lote activo antes de guardar un evento de alimento.',
    'feed.error.feedKgRequired': 'Se requiere Alimento (kg).',
    'feed.error.feedKgNonNegative': 'Alimento (kg) debe ser un número válido no negativo.',
    'feed.error.unableToLoadEvents': 'No se pudieron cargar los eventos de alimento.',
    'feed.error.unableToSaveEvent': 'No se pudo guardar el evento de alimento.',
    'feed.error.unableToDeleteEvent': 'No se pudo eliminar el evento de alimento.',
    'feed.status.savedLocal': 'El evento de alimento se guardó en este dispositivo. La sincronización con el servidor sigue pendiente.',
    'feed.status.savedOffline': 'El evento de alimento se guardó en este dispositivo. Se sincronizará cuando vuelva la conexión.',
    'feed.status.savedSynced': 'El evento de alimento quedó guardado y sincronizado.',
    'feed.status.deletedLocal': 'El evento de alimento se eliminó en este dispositivo. La sincronización con el servidor sigue pendiente.',
    'feed.status.deletedOffline': 'El evento de alimento se eliminó en este dispositivo. Se sincronizará cuando vuelva la conexión.',
    'feed.status.deletedSynced': 'El evento de alimento quedó eliminado y sincronizado.',
    'feed.status.refreshing': 'Actualizando eventos de alimento...',
    'feed.status.refreshed': 'Eventos de alimento actualizados desde el servidor.',
    'feed.status.refreshFailed': 'No se pudieron actualizar los eventos de alimento en este momento.',
    'feed.sync.retrySynced': 'La sincronización de alimento ya esta al dia.',
    'feed.sync.retryOffline': 'Los cambios de alimento quedan solo locales mientras este dispositivo esta sin conexión.',
    'feed.sync.retryPending': 'Los cambios de alimento siguen pendientes de sincronización.',
    'feed.sync.blocked': '{count} cambio(s) de alimento requieren atención antes de sincronizarse.',
    'feed.sync.blockedWithReason': '{count} cambio(s) de alimento requieren atención: {reason}',
    'feed.sync.retryResolvedMissing': 'El reintento omitió {count} cambio(s) de alimento faltantes y continuo con el resto.',
    'feed.sync.retryAction': 'Reintentar sincronización',
    'feed.sync.retrying': 'Reintentando sincronización...',
    'feed.sync.refreshAction': 'Actualizar eventos de alimento',
    'feed.sync.refreshing': 'Actualizando eventos de alimento...',
    'feed.sync.retryFailed': 'Fallo el reintento de sincronización de alimento.',
    'feed.sync.lastResult': 'Último resultado de sincronización: {result}',
    'feed.sync.lastAttempted': 'Último intento: {time}',

    'feed.button.addEvent': 'Agregar evento',
    'feed.button.updateEvent': 'Actualizar evento',
    'feed.button.cancelEdit': 'Cancelar edición',
    'feed.action.importWorkspace': 'Espacio de importación',
    'feed.button.refreshEvents': 'Actualizar eventos de alimento',
    'feed.button.refreshEventsTooltip': 'Actualizar los eventos de alimento desde el servidor para ver cambios hechos en otros dispositivos.',
    'feed.button.showLog': 'Mostrar registro',
    'feed.button.hideLog': 'Ocultar registro',
    'feed.button.loadOlderWeeks': 'Cargar semanas anteriores',
    'feed.instructions.refreshHint': 'Usa Actualizar eventos de alimento si este dispositivo todavía no muestra cambios hechos en otro dispositivo.',

    'feed.section.recentEvents': 'Eventos recientes',
    'feed.status.loading': 'Cargando…',
    'feed.empty.noFeedEvents': 'Aún no hay eventos de alimento para esta unidad.',

    'feed.table.recorded': 'Registrado',
    'feed.table.lot': 'Lote',
    'feed.table.feedKg': 'Alimento (kg)',
    'feed.table.type': 'Tipo',
    'feed.table.notes': 'Notas',
    'feed.table.actions': 'Acciones',
    'feed.table.costBadgeTooltip': 'Costo auto-derivado del alimento × costo unitario configurado en Inventario.',

    'feed.note.recommendedVsActual': 'Los KPIs recomendados se mantienen. Los valores reales de alimento se derivan de estos eventos y se muestran junto a ellos para comparar.',

    'feed.viewMode.daily': 'Vista diaria',
    'feed.viewMode.weekly': 'Vista semanal',

    'feed.panel.kpis': 'KPIs',
    'feed.panel.breakdown': 'Tabla de desglose',
    'feed.panel.charts': '📊 Gráficos y análisis',

    'feed.empty.noData.title': '⚠️ No hay datos disponibles',
    'feed.empty.noData.intro': 'Asegúrate de tener:',
    'feed.empty.noData.item.database': 'Registros en Base de datos con datos de Peso y {stockMetric}',
    'feed.empty.noData.item.water': 'Registros de calidad de agua con datos de Temperatura',
    'feed.empty.noData.item.lots': 'Números de Lote coincidentes entre Base de datos y Agua',

    'feed.kpi.weekLabel': 'Semana:',
    'feed.temperatureAlert.title': 'Alerta de temperatura',
    'feed.kpi.biomass': 'Biomasa:',
    'feed.kpi.sfr': 'SFR:',
    'feed.kpi.dailyFeed': 'Alimento diario:',
    'feed.kpi.weeklyFeed': 'Alimento semanal:',
    'feed.kpi.actualFeed': 'Alimento real:',
    'feed.kpi.eventsSuffix': 'eventos',
    'feed.kpi.adherence': 'Adherencia:',
    'feed.kpi.sgr': 'SGR:',
    // v2.2 T3-B-06d: KPI del FCR predicho por el modelo SFR (alimento
    // recomendado ÷ ganancia de biomasa semanal). Distinto del FCR del
    // reporte costo-por-kg (alimento real ÷ cosecha real).
    'feed.kpi.fcrPlanned': 'FCR (planificado):',
    'feed.kpi.fcrPlannedTooltip': 'Predicho por el modelo SFR — alimento recomendado ÷ ganancia de biomasa observada por semana. Distinto del FCR del reporte de costo por kg, que usa alimento real y cosecha real.',

    'feed.missingData.title': 'Datos faltantes:',
    'feed.missingData.weight': 'Datos de peso en Base de datos',
    'feed.missingData.stockFish': 'Datos de stock de peces en Base de datos',
    'feed.missingData.stockPl': 'Datos de conteo de PL en Base de datos',
    'feed.missingData.temperature': 'Datos de temperatura en la pantalla de Agua',

    'feed.quality.complete': 'Completo',
    'feed.quality.partial': 'Parcial',
    'feed.quality.incomplete': 'Incompleto',

    'feed.summaryStats.title': '📊 Estadísticas resumen',
    'feed.summaryStats.totalBiomass': 'Biomasa total:',
    'feed.summaryStats.totalDailyFeed': 'Alimento diario total:',
    'feed.summaryStats.totalWeeklyFeed': 'Alimento semanal total:',
    'feed.summaryStats.totalActualFeed': 'Alimento real total:',
    'feed.summaryStats.overallAdherence': 'Adherencia general:',
    'feed.summaryStats.avgSfr': 'SFR prom.:',
    'feed.summaryStats.avgFcr': 'FCR prom.:',
    'feed.summaryStats.periodsSuffix': 'períodos',
    'feed.summaryStats.dataQuality': 'Calidad de datos:',

    'feed.period.day': 'Día',
    'feed.period.week': 'Semana',
    'feed.period.daily': 'Diario',
    'feed.period.weekly': 'Semanal',

    'feed.breakdown.title': '🐟 Desglose por {period}',
    'feed.breakdown.column.period': 'Período',
    'feed.breakdown.column.lot': 'Lote',
    'feed.breakdown.column.biomassKg': 'Biomasa (kg)',
    'feed.breakdown.column.sfrPct': 'SFR (%)',
    'feed.breakdown.column.feedKg': 'Alimento {period} (kg)',
    'feed.breakdown.column.actualKg': 'Real (kg)',
    'feed.breakdown.column.adherence': 'Adherencia',
    'feed.breakdown.column.events': 'Eventos',
    'feed.breakdown.column.fcr': 'FCR (planificado)',
    'feed.breakdown.column.status': 'Estado',
    'feed.value.na': 'N/D',

    'feed.charts.heading': '📊 Analítica visual',
    'feed.charts.lead': 'Los gráficos se derivan de los mismos períodos KPI mostrados en tarjetas y tablas.',
    'feed.charts.tipLandscape': 'Tip: rota a horizontal para leer mejor. También puedes desplazarte horizontalmente.',
    'feed.charts.noData': 'No hay datos disponibles para los gráficos',
    'feed.charts.recommendedVsActualTitle': 'Alimento {period} recomendado vs real (kg) por período',
    'feed.charts.axis.feedKg': 'Alimento (kg)',
    'feed.charts.sfrTitle': 'SFR prom. (%) por período (ponderado por biomasa; solo lotes completos)',
    'feed.charts.axis.sfrPct': 'SFR (%)',
    'feed.charts.noFcr': 'Aún no hay gráfico de FCR (se necesitan al menos 2 semanas de datos completos).',
    'feed.charts.fcrTitle': 'FCR prom. (planificado) por período (solo lotes completos)',
    'feed.charts.axis.fcr': 'FCR',
    'feed.charts.relationshipNeedsData': 'El gráfico de relación necesita semanas con datos completos de SFR + SGR + FCR.',
    'feed.charts.relationshipTitle': 'Relación: SGR (izq.) y FCR (der.) vs SFR (x)',
    'feed.charts.axis.sgr': 'SGR (%/día)',
    'feed.charts.legend.sgr': 'SGR',
    'feed.charts.legend.fcr': 'FCR',

    'feed.guide.title': '📊 Guía de métricas para planificación de alimento',
    'feed.guide.sfr.title': '🌡️ Tasa específica de alimentación (SFR)',
    'feed.guide.fcr.title': '📈 Tasa de conversión alimenticia (FCR)',
    'feed.guide.biomass.title': '⚖️ Cálculo de biomasa',
    'feed.guide.quality.title': '🚨 Calidad de datos',
    'feed.guide.label.definition': 'Definición:',
    'feed.guide.label.calculation': 'Cálculo:',
    'feed.guide.label.temperatureDependency': 'Dependencia de temperatura:',
    'feed.guide.sfr.definition': 'Porcentaje del peso corporal a alimentar diariamente',
    'feed.guide.sfr.calculation': 'Basado en el peso y la temperatura del agua',
    'feed.guide.sfr.temperatureDependency': 'Óptimo 9-17°C para trucha/salmón',
    'feed.guide.fcr.definition': 'Alimento consumido ÷ peso ganado',
    'feed.guide.fcr.calculation': 'Alimento semanal ÷ aumento de biomasa',
    'feed.guide.fcr.good': 'Buen FCR:',
    'feed.guide.fcr.goodValue': '1.0-1.5 (más bajo es mejor)',
    'feed.guide.fcr.requires': 'Requiere:',
    'feed.guide.fcr.requiresValue': 'Al menos 2 semanas de datos',
    'feed.guide.sgr.title': '🌱 Tasa específica de crecimiento (SGR)',
    'feed.guide.sgr.definition': 'Cuánto crece el peso promedio por día, en %',
    'feed.guide.sgr.calculation': 'Peso promedio de dos muestreos y los días reales entre ellos. SGR = 100 × (e^g − 1), con g = (ln P2 − ln P1) ÷ días',
    'feed.guide.sgr.example': 'Ejemplo:',
    'feed.guide.sgr.exampleValue': 'de 2,5 g a 3,0 g en 7 días = 2,64 % por día (2,5 g crecen 2,64 % cada día y llegan a 3,0 g)',
    'feed.guide.sgr.classic': 'Tablas y artículos:',
    'feed.guide.sgr.classicValue': 'muchos usan 100 × g, que da un poco menos (2,60 en el ejemplo). En Reportes está como «SGR clásico» para comparar.',
    'feed.guide.biomass.formula': 'Fórmula:',
    'feed.guide.biomass.formulaValue': '{stockMetric} × Peso promedio ÷ 1000',
    'feed.guide.biomass.units': 'Unidades:',
    'feed.guide.biomass.unitsValue': 'Conteo × gramos = kilogramos',
    'feed.guide.biomass.purpose': 'Propósito:',
    'feed.guide.biomass.purposeValue': 'Peso total en la unidad de producción',
    'feed.guide.quality.completeLabel': 'Completo (100%):',
    'feed.guide.quality.completeValue': 'Datos de peso, stock y temperatura',
    'feed.guide.quality.incompleteLabel': 'Incompleto:',
    'feed.guide.quality.incompleteValue': 'Faltan datos críticos para cálculos',
    'feed.guide.quality.impactLabel': 'Impacto:',
    'feed.guide.quality.impactValue': 'Los datos incompletos afectan la precisión del cálculo de FCR',

    'feed.fcrInterp.title': '💡 Interpretación de FCR:',
    'feed.fcrInterp.excellent': 'Eficiencia excelente',
    'feed.fcrInterp.good': 'Buen desempeño',
    'feed.fcrInterp.fair': 'Regular; necesita mejora',
    'feed.fcrInterp.poor': 'Malo; revisa prácticas',

    'feed.controls.fcrDecimals': 'Decimales de FCR: {count}',
    'feed.controls.biomassDecimals': 'Decimales de biomasa: {count}',

    'feed.temperatureWarning.criticalCold': '🚨 CRÍTICO: Temperatura por debajo de {min}°C - suspende la alimentación para {context}. Los valores se limitan a {clamp}°C para interpolación.',
    'feed.temperatureWarning.tooCold': '❄️ ADVERTENCIA: La temperatura está cerca del umbral inferior para {context}. Monitorea el oxígeno disuelto antes de alimentar.',
    'feed.temperatureWarning.tooWarm': '🔥 ADVERTENCIA: La temperatura se acerca a la tolerancia superior para {context}. Reduce las tasas de alimentación y monitorea la calidad del agua.',
    'feed.temperatureWarning.criticalWarm': '🚨 CRÍTICO: Temperatura por encima de {max}°C - suspende la alimentación para {context}. Los valores se limitan a {clamp}°C para interpolación.',

    // Biomass
    'biomass.title': '📊 Biomasa',

    'biomass.context.facility': 'Instalación',
    'biomass.context.productionUnit': 'Unidad de producción',
    'biomass.context.selectFacility': 'Selecciona una instalación...',
    'biomass.context.selectFacilityFirst': 'Selecciona primero una instalación...',
    'biomass.context.selectProductionUnit': 'Selecciona unidad de producción...',
    'biomass.summary.lotRecords': '{count} registros de lotes',

    'biomass.aria.panels': 'Paneles de biomasa',
    'biomass.panel.log': 'Registro',
    'biomass.panel.analyze': 'Analizar',

    'biomass.section.logOperations': '🧾 Operaciones de registro',
    'biomass.details.sampling.title': '🧾 Muestreo y mortalidad',
    'biomass.details.count.title': '🔢 Conteo / Estimación',
    'biomass.details.harvest.title': '🧺 Cosecha',

    'biomass.readonly.sampling': 'Sesión como viewer. Los registros de muestreo son de solo lectura.',
    'biomass.readonly.count': 'Sesión como viewer. El conteo/estimación es de solo lectura.',
    'biomass.readonly.harvest': 'Sesión como viewer. La cosecha es de solo lectura.',

    'biomass.stockLabel.fish': 'Stock (peces u ovas)',
    'biomass.stockLabel.shrimp': 'Conteo de PL',

    'biomass.field.recordedAt': 'Registrado en',
    'biomass.field.lot': 'Lote',
    'biomass.field.stage': 'Estado',
    'biomass.field.avgWeightG': 'Peso promedio (g)',
    'biomass.field.dailyMortality': 'Mortalidad diaria',
    'biomass.field.notes': 'Notas',
    'biomass.field.method': 'Método',
    'biomass.field.harvestKg': 'Cosecha (kg)',
    'biomass.field.harvestCount': 'Cosecha (cantidad)',

    'biomass.lot.placeholder.selectUnitFirst': 'Selecciona una unidad de producción primero',
    'biomass.lot.placeholder.loadingLots': 'Cargando lotes…',
    'biomass.lot.placeholder.noLots': 'No hay lotes para esta unidad (créalo en Lotes)',
    'biomass.lot.placeholder.chooseLot': 'Elige lote',

    'biomass.button.addSamplingRow': 'Agregar fila de muestreo',
    'biomass.button.addCountRow': 'Agregar fila de conteo',
    'biomass.button.addHarvestRow': 'Agregar fila de cosecha',
    'biomass.button.refreshLogs': 'Actualizar registros de biomasa',
    'biomass.button.useAsTemplate': 'Usar como plantilla',
    'biomass.action.importOperationalCsv': 'Importar CSV (base de datos operativa)',

    'biomass.status.savedOffline': 'El registro de biomasa se guardó localmente sin conexión.',
    'biomass.status.savedPending': 'El registro de biomasa se guardó localmente. La sincronización con el servidor está pendiente.',
    'biomass.status.savedSynced': 'El registro de biomasa se sincronizó.',
    'biomass.status.deletedOffline': 'El registro de biomasa se eliminó localmente sin conexión.',
    'biomass.status.deletedPending': 'El registro de biomasa se eliminó localmente. La sincronización con el servidor está pendiente.',
    'biomass.status.deletedSynced': 'La eliminación del registro de biomasa se sincronizó.',
    'biomass.status.refreshing': 'Actualizando registros de biomasa...',
    'biomass.status.refreshComplete': 'Los registros de biomasa se actualizaron desde el servidor.',
    'biomass.status.refreshFailed': 'No se pudieron actualizar los registros de biomasa en este momento.',
    'biomass.sync.retrySynced': 'Sincronizado: todos los registros de biomasa están en el servidor.',
    'biomass.sync.retryOffline': 'Los cambios de biomasa quedan locales mientras este dispositivo este sin conexión.',
    'biomass.sync.retryPending': 'Los cambios de biomasa siguen pendientes de sincronización.',
    'biomass.sync.blocked': '{count} cambio(s) de biomasa requieren atención antes de sincronizar.',
    'biomass.sync.blockedWithReason': '{count} cambio(s) de biomasa requieren atención: {reason}',
    'biomass.sync.retryResolvedMissing': 'El reintento omitió {count} cambio(s) de biomasa faltantes y continuo con el resto.',
    'biomass.sync.retryAction': 'Reintentar sincronización',
    'biomass.sync.retrying': 'Reintentando sincronización...',
    'biomass.sync.refreshAction': 'Actualizar registros de biomasa',
    'biomass.sync.attentionBlocked': '{count} cambio(s) de biomasa están bloqueados y requieren atención.',
    'biomass.sync.attentionBlockedWithReason': '{count} cambio(s) de biomasa están bloqueados: {reason}',
    'biomass.sync.attentionOffline': 'Este dispositivo esta sin conexión. Los cambios de biomasa se sincronizarán al volver la conexión.',
    'biomass.sync.attentionPending': 'Los cambios de biomasa están en cola y siguen pendientes de sincronización.',
    'biomass.sync.lastResult': 'Último resultado de sincronización: {result}',
    'biomass.sync.lastAttempted': 'Último intento: {time}',

    'biomass.recent.samplingTitle': 'Filas recientes de muestreo',
    'biomass.recent.countTitle': 'Filas recientes de conteo',
    'biomass.recent.harvestTitle': 'Filas recientes de cosecha',
    'biomass.recent.noneSampling': 'Aún no hay filas de muestreo para esta unidad.',
    'biomass.recent.noneCount': 'Aún no hay filas de conteo para esta unidad.',
    'biomass.recent.noneHarvest': 'Aún no hay filas de cosecha para esta unidad.',
    'biomass.recent.loadMore': 'Ver más ({count} anteriores)',
    'biomass.row.unmappedLot': 'Lote sin mapear',
    'biomass.row.deletedLot': 'Lote eliminado (el registro se conserva)',
    'biomass.row.avgWeightPrefix': 'Peso prom.:',
    'biomass.row.methodPrefix': 'Método:',
    'biomass.row.harvestPrefix': 'Cosecha:',
    'biomass.unit.count': 'cantidad',

    'biomass.method.estimate': 'Estimación',
    'biomass.method.exact': 'Exacto',

    'biomass.error.chooseLot': 'Elige un lote.',
    'biomass.error.saveFailed': 'No se pudo guardar. Intenta nuevamente.',
    'biomass.error.deleteFailed': 'No se pudo eliminar. Intenta nuevamente.',
    'biomass.error.enterRequired': 'Ingresa {field}.',
    'biomass.error.enterWeightOrMortality': 'Ingresa peso promedio o mortalidad diaria.',
    'biomass.error.harvestRequired': 'Ingresa kg de cosecha, cantidad, o ambos.',
    'biomass.error.mustBeNumber': 'Ingresa un número para {field}.',
    'biomass.error.mustBePositive': 'Ingresa un número positivo para {field}.',
    'biomass.error.mustBeWholeNumber': 'Ingresa un número entero para {field}.',

    // PR-α3b U5: harvest-driven Lot.stage auto-transition (warning banner +
    // button-flip confirm). See docs/lot-lifecycle-vs-concerns-audit.md §1.1 X8/X9.
    'biomass.harvest.transition.warningBanner': 'Cosecha acumulada llegó al {ratio}% de la biomasa viva. Considerá cerrar el lote.',
    'biomass.harvest.transition.confirmCta': 'Confirmar cierre del lote',
    'biomass.harvest.transition.confirmed': 'Lote cerrado',

    'biomass.view.current': 'Estado actual',
    'biomass.view.historical': 'Tendencias históricas',
    'biomass.view.charts': '📊 Gráficos',

    'biomass.empty.noData.title': 'No hay datos disponibles',
    'biomass.empty.noData.subtitle': 'Asegúrate de que existan entradas en la Base de datos para {farm} - {unit}',

    'biomass.cards.totalActiveBiomass.title': '🐟 Biomasa activa total',
    'biomass.cards.totalActiveBiomass.needsSample': '{count} lote(s) sin muestreo de peso: registra un muestreo para calcular su biomasa.',
    'biomass.cards.totalActiveBiomass.caption': 'Lotes activos: {count}',
    'biomass.cards.totalActiveBiomass.activeLabel': 'Activo',
    'biomass.cards.totalActiveBiomass.historicalLabel': 'Histórico',
    'biomass.cards.totalActiveBiomass.breakdownTitle': 'Desglose por lote',
    'biomass.cards.totalStock.title': '🔢 Total de {stockLabel}',
    'biomass.cards.totalStock.caption': 'Conteo activo',
    'biomass.cards.avgWeight.title': '⚖️ Peso promedio',
    'biomass.cards.avgWeight.caption': 'Promedio ponderado',
    'biomass.cards.survival.title': '💚 Supervivencia derivada',
    'biomass.cards.survival.caption': '{count} lotes activos con supervivencia derivada',
    'biomass.cards.observedMortality.title': '🟥 Mortalidad observada',
    'biomass.cards.observedMortality.caption': '{count} lotes activos con mortalidad diaria registrada',
    'biomass.cards.expectedMortality.title': '🟥 Mortalidad esperada',
    'biomass.cards.expectedMortality.caption': '{count} lotes activos con temperatura de agua asociada',
    'biomass.cards.projectedBiomass.title': '🧮 Biomasa proyectada',
    'biomass.cards.projectedBiomass.caption': '{count} lotes activos proyectados desde la matriz de mortalidad',
    'biomass.projection.emptyHint': 'Agrega registros de temperatura en Agua y configura la Matriz de mortalidad para mostrar proyecciones aquí.',
    'biomass.projection.assumptions.title': 'Supuestos de la proyeccion',
    'biomass.projection.assumptions.observed': 'La mortalidad observada se mide con la mortalidad diaria registrada y el stock conocido previo.',
    'biomass.projection.assumptions.expected': 'La mortalidad esperada se deriva de la matriz de mortalidad usando peso y temperatura del agua.',
    'biomass.projection.assumptions.stock': 'El stock proyectado aplica la mortalidad esperada dia por dia en cada salto de fechas.',
    'biomass.projection.assumptions.biomass': 'La biomasa proyectada usa el ultimo peso valido como supuesto de peso fijo.',
    'biomass.projection.scenarios.title': 'Division de escenarios de proyeccion',
    'biomass.projection.scenarios.currentTrendLabel': 'Proyeccion por tendencia actual (mortalidad observada)',
    'biomass.projection.scenarios.currentTrendCaption': '{count} lotes activos con tasa de mortalidad observada disponible',
    'biomass.projection.scenarios.expectedLabel': 'Proyeccion por condicion esperada (mortalidad de matriz)',
    'biomass.projection.scenarios.expectedCaption': '{count} lotes activos con proyeccion basada en matriz',
    'biomass.performance.title': 'Resumen de desempeno de mortalidad (7 dias)',
    'biomass.performance.asOf': 'Corte al: {date}',
    'biomass.performance.activeLots': 'Lotes activos monitoreados: {count}',
    'biomass.performance.currentObserved': 'Mortalidad observada actual: {value}',
    'biomass.performance.previousObserved': 'Mortalidad observada previa: {value}',
    'biomass.performance.expected': 'Mortalidad esperada actual: {value}',
    'biomass.performance.gap': 'Brecha observada vs esperada: {value}',
    'biomass.performance.trend': 'Tendencia: {value}',
    'biomass.performance.trend.improving': 'Mejorando',
    'biomass.performance.trend.worsening': 'Empeorando',
    'biomass.performance.trend.stable': 'Estable',
    'biomass.performance.trend.insufficient-history': 'Historial insuficiente',
    'biomass.performance.samples': 'Muestras (actual/previa): {current}/{previous}',
    'biomass.performance.sourceContract': 'La mortalidad observada usa filas vinculadas de Mortality Log cuando existen; si no, usa la fila de resumen diario.',
    'biomass.performance.trustSummary': 'Confianza del resumen: {value}',
    'biomass.performance.trustSummary.strong': 'Fuerte',
    'biomass.performance.trustSummary.caution': 'Precaucion',
    'biomass.performance.trustSummary.weak': 'Debil',
    'biomass.performance.trustReason.current-summary-fallback': 'La ventana actual usa solo respaldo de resumen.',
    'biomass.performance.trustReason.previous-no-observed': 'La ventana previa no tiene muestras observadas.',
    'biomass.performance.trustReason.previous-stale': 'La evidencia previa de Mortality Log esta desactualizada.',
    'biomass.performance.trustReason.current-no-observed': 'La ventana actual no tiene muestras observadas.',
    'biomass.performance.trustReason.both-log-backed-recent': 'Ambas ventanas están respaldadas por logs recientes.',
    'biomass.performance.trustReason.mixed-evidence': 'La evidencia observada mezcla Mortality Log y senales de respaldo.',
    'biomass.performance.sourceMode': 'Modo de fuente observada (actual/previa): {currentMode}, {previousMode}',
    'biomass.performance.sourceMode.mortality-log-only': 'Solo Mortality Log',
    'biomass.performance.sourceMode.mixed': 'Mixto (Mortality Log + respaldo de resumen)',
    'biomass.performance.sourceMode.summary-fallback': 'Solo respaldo de resumen',
    'biomass.performance.sourceMode.no-observed': 'Sin muestras observadas',
    'biomass.performance.sourceCoverage': 'Muestras respaldadas por Mortality Log (actual/previa): {currentLog}/{currentTotal}, {previousLog}/{previousTotal}',
    'biomass.performance.sourceCoverageDates': 'Fechas mas recientes de muestra de Mortality Log (actual/previa): {currentDate}, {previousDate}',
    'biomass.performance.sourceRecencyRisk': 'Riesgo de vigencia de Mortality Log (actual/previa): {currentRisk}, {previousRisk}',
    'biomass.performance.sourceRecencyRisk.fresh': 'Reciente',
    'biomass.performance.sourceRecencyRisk.aging': 'En envejecimiento',
    'biomass.performance.sourceRecencyRisk.stale': 'Desactualizado',
    'biomass.performance.sourceRecencyRisk.unknown': 'Desconocido',
    'biomass.performance.details.show': 'Mostrar detalles de fuente observada',
    'biomass.performance.details.hide': 'Ocultar detalles de fuente observada',
    'biomass.performance.empty': 'Aun no hay suficientes datos activos de mortalidad para calcular el resumen de 7 dias.',

    'biomass.lotDetails.title': '📋 Detalles del lote',
    'biomass.lotDetails.metric.biomass': 'Biomasa:',
    'biomass.lotDetails.metric.stock': 'Stock:',
    'biomass.lotDetails.metric.avgWeight': 'Peso prom.:',
    'biomass.lotDetails.metric.mortality': 'Mortalidad observada:',
    'biomass.lotDetails.metric.survival': 'Supervivencia derivada:',
    'biomass.lotDetails.metric.density': 'Densidad:',
    'biomass.lotDetails.metric.fcrInFlight': 'eFCR en curso:',
    'biomass.lotDetails.metric.fcrInFlightHelp': 'Alimento a la fecha ÷ (biomasa actual − biomasa sembrada). "--" si falta el primer conteo o el primer muestreo del lote.',
    'biomass.lotDetails.metric.expectedMortality': 'Mortalidad esperada:',
    'biomass.lotDetails.metric.projectedStock': 'Stock proyectado:',
    'biomass.lotDetails.metric.projectedBiomass': 'Biomasa proyectada:',
    'biomass.lotDetails.metric.temperature': 'Temperatura:',

    'biomass.charts.title': '📊 Panel de analítica visual',
    'biomass.charts.lead': 'Gráficos que muestran tendencias de crecimiento, niveles de stock y métricas de desempeño a lo largo del tiempo.',
    'biomass.charts.tipLandscape': 'Tip: rota a horizontal para leer mejor. También puedes desplazarte horizontalmente.',
    'biomass.charts.avgWeightGrowth.title': '📈 Crecimiento de peso promedio en el tiempo',
    'biomass.charts.stockLevels.title': '📊 Niveles de {stockLabel} en el tiempo',
    'biomass.charts.stock.noData': 'No hay datos de stock disponibles para el gráfico',
    'biomass.charts.stock.chartTitle': '{stockLabel} por lote y fecha',
    'biomass.charts.stock.series.actual': 'Real',
    'biomass.charts.stock.series.projected': 'Proyectado',
    'biomass.charts.stock.barTooltip': '{lot}\nFecha: {date}\n{stockLabel}: {stock}',
    'biomass.charts.stock.projectedBarTooltip': '{lot}\nFecha: {date}\n{stockLabel} proyectado: {stock}',
    'biomass.charts.stock.projectedMissing': 'Sin proyección',
    'biomass.charts.stock.axisTitle': 'Cantidad',

    'biomass.historical.title': '📈 Datos históricos de biomasa',
    'biomass.historical.column.period': 'Período',
    'biomass.historical.column.lot': 'Lote',
    'biomass.historical.column.biomassKg': 'Biomasa (kg)',
    'biomass.historical.column.stock': 'Stock',
    'biomass.historical.column.avgWeightG': 'Peso prom. (g)',
    'biomass.historical.column.temperatureC': 'Temp (C)',
    'biomass.historical.column.survivalPct': 'Supervivencia derivada (%)',
    'biomass.historical.column.mortalityPct': 'Mortalidad observada (%)',
    'biomass.historical.column.expectedMortalityPct': 'Mortalidad esperada (%)',
    'biomass.historical.column.projectedStock': 'Stock proyectado',
    'biomass.historical.column.projectedBiomassKg': 'Biomasa proyectada (kg)',
    'biomass.historical.column.fcrInFlight': 'eFCR en curso',
    'biomass.historical.column.stage': 'Estado',

    'biomass.guide.title': '📊 Guía de métricas de biomasa',
    'biomass.guide.totalBiomass.title': '🐟 Biomasa total',
    'biomass.guide.survival.title': '💚 Supervivencia derivada',
    'biomass.guide.density.title': '📏 Densidad de siembra',
    'biomass.guide.growth.title': '⚖️ Seguimiento de crecimiento',

    'biomass.guide.label.formula': 'Fórmula:',
    'biomass.guide.label.purpose': 'Propósito:',
    'biomass.guide.label.units': 'Unidades:',
    'biomass.guide.label.example': 'Ejemplo:',
    'biomass.guide.label.goodRate': 'Buena tasa:',
    'biomass.guide.label.note': 'Nota:',
    'biomass.guide.label.optimal': 'Óptimo:',
    'biomass.guide.label.averageWeight': 'Peso promedio:',
    'biomass.guide.label.monitoring': 'Seguimiento:',
    'biomass.guide.label.target': 'Objetivo:',

    'biomass.guide.totalBiomass.formulaValue': '{stockLabel} × Peso promedio ÷ 1000',
    'biomass.guide.totalBiomass.purposeValue': 'Peso vivo total en la unidad de producción',
    'biomass.guide.totalBiomass.unitsValue': 'Kilogramos (kg)',

    'biomass.guide.survival.formulaValue': '((Stock previo - Mortalidad diaria) ÷ Stock previo) × 100',
    'biomass.guide.survival.exampleValue': '(80 - 15) ÷ 80 = 81.25%',
    'biomass.guide.survival.goodRateValue': 'Más cerca de 100% día a día',
    'biomass.guide.survival.noteValue': 'Solo se muestra cuando la fila tiene mortalidad diaria y existe un stock previo',

    'biomass.guide.density.formulaValue': 'Biomasa total ÷ Volumen',
    'biomass.guide.density.unitsValue': 'kg/m³',
    'biomass.guide.density.optimalValue': 'Varía por especie y etapa',

    'biomass.guide.growth.averageWeightValue': 'Indicador clave de crecimiento',
    'biomass.guide.growth.monitoringValue': 'Monitorea incrementos semanales',
    'biomass.guide.growth.targetValue': 'Curvas de crecimiento consistentes',

    // Dashboard (New)
    'dashboardNew.title': 'Panel (nuevo)',
    'dashboardNew.subtitle': 'Tablas dinámicas y gráficos construidos a partir de reportes guardados.',

    'dashboardNew.addWidget.title': 'Agregar widget de pivote',
    'dashboardNew.addWidget.triggerSubtitle': 'Crea una tabla dinámica o gráfico a partir de uno de tus reportes guardados.',
    'dashboardNew.addWidget.empty.noReports': 'Aún no hay reportes guardados. Crea uno en Reportes primero.',

    'dashboardNew.form.title.label': 'Título',
    'dashboardNew.form.title.placeholder': 'p. ej. Alimento total por lote',
    'dashboardNew.form.report.label': 'Reporte',
    'dashboardNew.form.rows.label': 'Filas (agrupar por)',
    'dashboardNew.form.rows.dateGrouping.label': 'Agrupación de fecha (filas)',
    'dashboardNew.form.columns.label': 'Columnas (opcional)',
    'dashboardNew.form.columns.dateGrouping.label': 'Agrupación de fecha (columnas)',
    'dashboardNew.form.aggregation.label': 'Agregación',
    'dashboardNew.form.valueField.label': 'Campo de valor',
    'dashboardNew.form.valueField.placeholder.count': '(no se usa para conteo)',
    'dashboardNew.form.valueField.placeholder.select': 'Selecciona un campo…',
    'dashboardNew.form.showChart': 'Mostrar gráfico',
    'dashboardNew.form.chartType.label': 'Tipo de gráfico',
    'dashboardNew.chartType.bar': 'Barras',
    'dashboardNew.chartType.line': 'Líneas',

    'dashboardNew.option.none': 'Ninguno',
    'dashboardNew.option.noneDailyRaw': 'Ninguno (diario/sin agrupar)',
    'dashboardNew.option.week': 'Semana',
    'dashboardNew.option.month': 'Mes',
    'dashboardNew.option.quarter': 'Trimestre',
    'dashboardNew.option.year': 'Año',

    'dashboardNew.aggregation.count': 'Conteo',
    'dashboardNew.aggregation.sum': 'Suma',
    'dashboardNew.aggregation.avg': 'Promedio',
    'dashboardNew.aggregation.min': 'Mínimo',
    'dashboardNew.aggregation.max': 'Máximo',
    'dashboardNew.aggregation.last': 'Último valor',
    'dashboardNew.aggregation.sumOfLast': 'Suma del último valor por entidad',
    'dashboardNew.aggregation.ratio': 'Razón',
    'dashboardNew.aggregation.weightedAvg': 'Promedio ponderado',
    'dashboardNew.option.day': 'Día',
    'dashboardNew.aggregation.help.count': 'Cuenta cuántas filas hay en cada grupo.',
    'dashboardNew.aggregation.help.sum': 'Suma el campo de valor. Úsalo para flujos (alimento, mortalidad), no para niveles como el stock.',
    'dashboardNew.aggregation.help.avg': 'Promedio simple de las filas: cada fila pesa lo mismo, sin importar el tamaño del lote.',
    'dashboardNew.aggregation.help.min': 'El valor más bajo del grupo.',
    'dashboardNew.aggregation.help.max': 'El valor más alto del grupo.',
    'dashboardNew.aggregation.help.last': 'El valor de la fila más reciente del grupo (p. ej. peso actual).',
    'dashboardNew.aggregation.help.sumOfLast': 'Para niveles como stock o biomasa: toma el último valor de cada lote en el grupo y los suma. Da el total correcto.',
    'dashboardNew.aggregation.help.ratio': 'Suma del valor ÷ suma del denominador (p. ej. muertes ÷ stock × 100 = mortalidad %). Pondera cada lote por su tamaño.',
    'dashboardNew.aggregation.help.weightedAvg': 'Promedio ponderado por otro campo (p. ej. peso promedio ponderado por stock).',
    'dashboardNew.form.entityField.label': 'Sumar el último valor de cada',
    'dashboardNew.form.entityField.hint': 'Normalmente «Lote».',
    'dashboardNew.form.orderField.label': 'Más reciente según',
    'dashboardNew.form.orderField.auto': 'Automático (fecha de las filas)',
    'dashboardNew.form.orderField.hint': 'Qué fecha decide cuál fila es la más reciente.',
    'dashboardNew.form.denominatorField.label': 'Dividir entre (denominador)',
    'dashboardNew.form.ratioMultiplier.label': 'Expresar como',
    'dashboardNew.form.ratioMultiplier.none': 'Razón (× 1)',
    'dashboardNew.form.ratioMultiplier.percent': 'Porcentaje (× 100)',
    'dashboardNew.form.ratioMultiplier.perMille': 'Por mil (× 1000)',
    'dashboardNew.form.weightField.label': 'Ponderar por',
    'dashboardNew.form.weightField.hint': 'Normalmente «Stock (derivado)».',
    'dashboardNew.form.chartSeries.label': 'Series del gráfico',
    'dashboardNew.form.chartSeries.total': 'Una serie (total de la fila)',
    'dashboardNew.form.chartSeries.byColumn': 'Una serie por columna (p. ej. una línea por lote)',
    'dashboardNew.chart.titleBySeries': 'Gráfico por {field}',
    'dashboardNew.chart.truncatedSeries': 'Mostrando {shownSeries} de {totalSeries} series y {shown} de {total} grupos. La tabla de abajo tiene todo.',

    'dashboardNew.button.addWidget': 'Agregar widget',
    'dashboardNew.button.updateWidget': 'Actualizar widget',
    'dashboardNew.button.refresh': 'Actualizar',
    'dashboardNew.button.pinToHome': 'Fijar en Inicio',
    'dashboardNew.button.unpinFromHome': 'Quitar de Inicio',

    'dashboardNew.help.datasetAllowlist': 'Los datos provienen de la lista permitida de datasets ({count} datasets) y funciona offline-first.',

    'dashboardNew.widgets.title': 'Widgets',
    'dashboardNew.widgets.empty': 'Aún no hay widgets. Agrega un widget de pivote arriba.',
    'dashboardNew.widgets.dragHandleHint': 'Arrastra para mover, o arrastra la esquina para cambiar el tamaño',
    'dashboardNew.widgets.missingReport': 'Reporte faltante',
    'dashboardNew.widgets.rowsPrefix': 'Filas',
    'dashboardNew.widgets.colsPrefix': 'Columnas',
    'dashboardNew.widgets.missingReportWarning': 'Este widget hace referencia a un reporte que ya no existe.',

    'dashboardNew.status.loadingReportRows': 'Cargando filas del reporte…',
    'dashboardNew.status.showingUpTo': 'Mostrando hasta {rowCount} grupos de filas y {colCount} grupos de columnas.',

    'dashboardNew.error.unknownDataset': 'Dataset desconocido: {datasetKey}',
    'dashboardNew.error.runFailed': 'Falló la ejecución: {message}',
    'dashboardNew.error.pivotFailed': 'Falló el pivote: {message}',

    'dashboardNew.chart.title': 'Gráfico (grupos principales)',
    'dashboardNew.chart.ariaLabel': 'Gráfico de pivote',
    'dashboardNew.chart.truncated': 'Mostrando {shown} de {total} grupos en el gráfico. La tabla de abajo tiene la lista completa.',

    'dashboardNew.pivot.total': 'Total',
    'dashboardNew.pivot.grandTotal': 'Total general',

    // Home (Dashboard)
    'home.title': 'Inicio',
    'home.subtitle': 'Bienvenido a tu app de gestión.',
    'home.error.dataRefreshFailed': 'Falló la actualización de datos',

    'home.reportPdf.error.unableToGenerate': 'No se pudo generar el PDF del reporte',
    'home.reportPdf.error.generateReportFailed': 'Falló la generación del reporte: {message}',

    'home.debug.na': 'n/d',
    'home.debug.week.current': 'Semana actual',
    'home.debug.week.previous': 'Semana anterior',
    'home.debug.label.date': 'Fecha',
    'home.debug.gap.inline': ', brecha {days}d',
    'home.debug.gap.parens': ' (brecha {days}d)',

    'home.debug.fishStock.unavailable': 'Información de depuración no disponible',
    'home.debug.fishStock.title': '{emoji} {metricLabel} — Resumen de depuración',
    'home.debug.fishStock.section.current': '📊 Período actual ({label}):',
    'home.debug.fishStock.section.compare': '📈 Período de comparación ({label}):',
    'home.debug.fishStock.section.trend': '🔄 Cálculo de tendencia:',
    'home.debug.fishStock.section.activeEntries': '📋 Entradas activas esta semana:',
    'home.debug.fishStock.section.historicalEntries': '📋 Entradas históricas coincidentes:',
    'home.debug.fishStock.line.totalActiveStock': '• Total activo: {value} {unit}',
    'home.debug.fishStock.line.activeLots': '• Lotes activos: {count}',
    'home.debug.fishStock.line.matchedHistoricalStock': '• Stock histórico coincidente: {value} {unit}',
    'home.debug.fishStock.line.matchedLots': '• Lotes coincidentes: {count}',
    'home.debug.fishStock.line.change': '• Cambio: {value} {unit}',
    'home.debug.fishStock.line.percentage': '• Porcentaje: {value}%',
    'home.debug.fishStock.line.formula': '• Fórmula: (({current} - {lastMonth}) / {denominator}) × 100',
    'home.debug.fishStock.entry.current': '{index}. {facilityLabel}: {facility} | {lotLabel}: {lot} | {metricLabel}: {metric}',
    'home.debug.fishStock.entry.historical': '{index}. {facilityLabel}: {facility} | {lotLabel}: {lot} | {metricLabel}: {metric} | {dateLabel}: {date}',
    'home.debug.fishStock.noneActive': 'No hay entradas activas',
    'home.debug.fishStock.noneMatches': 'No se encontraron coincidencias',

    'home.debug.feed.title': '🍽️ Consumo diario de alimento (activo)',
    'home.debug.feed.noActiveRows': 'No se encontraron filas activas para la semana actual.',
    'home.debug.feed.summaryUnavailable': 'Resumen de depuración no disponible.',
    'home.debug.comparison': '📆 Comparación: {current} vs {previous}',
    'home.debug.feed.totals': '🔢 Totales: {currentKg} kg vs {previousKg} kg',
    'home.debug.feed.delta': 'Δ Cambio: {deltaKg} kg ({percent})',
    'home.debug.matchedLots': '✅ Lotes coincidentes: {matched}/{total}',
    'home.debug.feed.missingPrevSuffix': ' (Faltan {count} lotes de la semana anterior)',
    'home.debug.feed.noPreviousWeekData': 'sin datos de la semana anterior',
    'home.debug.feed.row.matched': '• {farm} · {lotLabel} {lot}: {currentKg} kg → {previousKg} kg (Δ {deltaKg} kg, {percent})',
    'home.debug.feed.row.unmatched': '• {farm} · {lotLabel} {lot}: {currentKg} kg ({noPreviousWeekData})',
    'home.debug.moreLots': '• … y {count} lotes más',

    'home.debug.actualFeed.title': '🍽️ Alimento diario real (eventos)',
    'home.debug.actualFeed.selectContext': 'Selecciona una granja y una unidad de producción para ver los totales de alimento real.',
    'home.debug.actualFeed.noEvents': 'No se cargaron eventos de FeedLog para el contexto actual.',
    'home.debug.actualFeed.weeklyTotals': '🔢 Totales semanales: {currentKg} kg ({currentEvents} eventos) vs {previousKg} kg ({previousEvents} eventos)',
    'home.debug.actualFeed.dailyAvg': '📅 Promedio diario: {kgPerDay} kg/día',
    'home.debug.actualFeed.adherence': '🎯 Adherencia vs recomendado: {adherence}%',
    'home.debug.actualFeed.adherenceNa': '🎯 Adherencia vs recomendado: {na} (sin línea base recomendada)',

    'home.debug.growth.title': '📈 Tasa de crecimiento (ganancia diaria)',
    'home.debug.growth.noActiveLots': 'No hay lotes activos coincidentes para el período actual.',
    'home.debug.growth.insufficientHistory': 'Datos históricos insuficientes para calcular la tendencia.',
    'home.debug.growth.currentAverage': '📊 Promedio actual: {value}',
    'home.debug.growth.specificGrowthRate': '• Tasa de crecimiento específica: {value}',
    'home.debug.growth.baselineAverage': '📉 Promedio base: {value}',
    'home.debug.growth.baselineSgr': '• SGR base: {value}',
    'home.debug.growth.deltaChange': 'Δ Cambio: {value}',
    'home.debug.growth.relativeVsBaseline': '   ({value} vs línea base)',
    'home.debug.growth.baselineUnavailable': '📉 Promedio base: {na} (coincidencias históricas insuficientes)',
    'home.debug.growth.deltaNeutral': 'Δ Cambio: 0.00 g/día (tendencia neutral)',
    'home.debug.gapWarningTitle': '⚠️ Lotes con brecha >7 días ({count}):',
    'home.debug.skippedTitle': '🚫 Omitidos (brecha >21 días) ({count}):',
    'home.debug.unmatchedLotsTitle': '📝 Lotes sin coincidencia ({count}):',
    'home.debug.matchedDetailTitle': '🔍 Detalle de lotes coincidentes:',
    'home.debug.noMatchedLotsContributed': '🔍 Ningún lote coincidente contribuyó a esta métrica.',
    'home.debug.detail.current': '  - Actual: {value}',
    'home.debug.detail.previous': '  - Previo: {value}',
    'home.debug.detail.baseline': '  - Línea base: {value}',
    'home.debug.detail.dailyGain': '  - Ganancia diaria: {value}',
    'home.debug.detail.sgr': '  - SGR: {value}',
    'home.debug.detail.previousGain': '  - Ganancia previa: {value}',
    'home.debug.detail.previousSgr': '  - SGR previo: {value}',
    'home.debug.detail.note': '  - Nota: {note}',

    'home.debug.mortality.title': '🪦 Mortalidad semanal',
    'home.debug.mortality.noActiveLots': 'No hay lotes activos con {stockMetricLabel} registrado esta semana.',
    'home.debug.mortality.insufficientHistory': 'Datos históricos insuficientes para la semana actual.',
    'home.debug.mortality.currentRate': '📊 Tasa actual: {rate}',
    'home.debug.mortality.mortalityLine': '• Mortalidad: {mortality} {unit} desde una línea base de {baseline}',
    'home.debug.mortality.previousRate': '📉 Tasa previa: {rate}',
    'home.debug.mortality.deltaPts': 'Δ Cambio: {pts} pts',
    'home.debug.mortality.previousRateNa': '📉 Tasa previa: {na} (línea base insuficiente)',
    'home.debug.mortality.deltaNeutral': 'Δ Cambio: 0.00 pts (tendencia neutral)',
    'home.debug.mortality.detail.mortality': '  - Mortalidad: {value}',
    'home.debug.mortality.detail.historical': '  - Histórica: {value}',

    'home.water.tooltip.rollup': 'Promedio de 7 días (última lectura por lote). Coinciden {matched}/{total} lotes.',
    'home.water.tooltip.trend': 'Tendencia vs 7 días previos: {trendText}.',
    'home.water.tooltip.noPrevBaseline': 'No hay línea base de los 7 días previos.',
    'home.water.tooltip.none.temp': 'No se encontraron lecturas de temperatura del agua para el contexto actual en los últimos 7 días.',
    'home.water.tooltip.none.ph': 'No se encontraron lecturas de pH para el contexto actual en los últimos 7 días.',
    'home.water.tooltip.none.do': 'No se encontraron lecturas de oxígeno disuelto para el contexto actual en los últimos 7 días.',
    'home.water.tooltip.none.salinity': 'No se encontraron lecturas de salinidad para el contexto actual en los últimos 7 días.',

    'home.context.facility': 'Instalación',
    'home.context.productionUnit': 'Unidad de producción',
    'home.context.lot': 'Lote',

    'home.selector.facility.label': 'Instalación',
    'home.selector.facility.placeholder.none': 'No hay instalaciones disponibles',
    'home.selector.facility.placeholder.select': 'Selecciona una instalación...',
    'home.selector.facility.unnamed': 'Instalación sin nombre',

    'home.selector.productionUnit.label': 'Unidad de producción',
    'home.selector.productionUnit.placeholder.selectFacilityFirst': 'Primero selecciona una instalación...',
    'home.selector.productionUnit.placeholder.noneForFacility': 'No hay unidades para la instalación seleccionada',
    'home.selector.productionUnit.placeholder.select': 'Selecciona una unidad de producción...',
    'home.selector.productionUnit.unnamed': 'Unidad sin nombre',

    'home.selector.lot.label': 'Lote',
    'home.selector.lot.placeholder.selectUnitFirst': 'Primero selecciona una unidad de producción...',
    'home.selector.lot.placeholder.noneForUnit': 'No hay lotes para la unidad seleccionada',
    'home.selector.lot.placeholder.select': 'Selecciona un lote...',

    'home.stockMetric.shrimp': 'Conteo de PL',
    'home.stockMetric.fish': 'Stock de peces',
    'home.stockUnit.shrimp': 'PL',
    'home.stockUnit.fish': 'peces',
    'home.stockCountLabel.shrimp': 'Conteo de PL',
    'home.stockCountLabel.fish': 'Conteo de peces',

    'home.alert.title': '⚠️ Alerta del sistema',
    'home.alert.viewTasks': 'Ver tareas',
    'home.alert.error.unableToLoad': 'No se pueden cargar las tareas de alerta en este momento.',
    'home.alert.empty.noAlerts': 'No hay tareas de alerta. Agrega la etiqueta “alert” a una tarea para verla aquí.',
    'home.alert.badge.alertTagged': 'Con etiqueta alert',
    'home.alert.badge.overdue': 'Vencida',
    'home.alert.badge.dueSoon': 'Por vencer',
    'home.alert.dueAt': 'Vence {date}',
    'home.alert.noDueDate': 'Sin fecha de vencimiento',

    'home.kpi.sectionTitle': '📈 Indicadores clave (KPI)',
    'home.kpi.totalActiveStock.title': 'Total activo {stockMetricLabel}',
    'home.kpi.avgWaterTemp.title': 'Temperatura promedio del agua',
    'home.kpi.dailyFeed.title': 'Consumo diario de alimento (activo)',
    'home.kpi.actualDailyFeed.title': 'Alimento diario real (eventos)',
    'home.kpi.weeklyMortality.title': 'Mortalidad semanal',
    'home.kpi.weeklySurvival.title': 'Supervivencia semanal',
    'home.kpi.mortalitySnapshot.title': 'Resumen de mortalidad (7 dias)',
    'home.kpi.mortalitySnapshot.empty': 'Aun no hay suficiente historial activo de mortalidad para calcular el resumen de 7 dias.',
    'home.kpi.mortalitySnapshot.tooltip.asOf': 'Corte al: {date}',
    'home.kpi.mortalitySnapshot.tooltip.activeLots': 'Lotes activos monitoreados: {count}',
    'home.kpi.mortalitySnapshot.tooltip.currentObserved': 'Mortalidad observada actual: {value}',
    'home.kpi.mortalitySnapshot.tooltip.previousObserved': 'Mortalidad observada previa: {value}',
    'home.kpi.mortalitySnapshot.tooltip.samples': 'Muestras (actual/previa): {current}/{previous}',
    'home.kpi.mortalitySnapshot.tooltip.sourceContract': 'La mortalidad observada usa filas vinculadas de Mortality Log cuando existen; de lo contrario usa la fila del resumen diario.',
    'home.kpi.mortalitySnapshot.tooltip.trustSummary': 'Confianza del resumen: {value}',
    'home.kpi.mortalitySnapshot.tooltip.trustSummary.strong': 'Fuerte',
    'home.kpi.mortalitySnapshot.tooltip.trustSummary.caution': 'Precaucion',
    'home.kpi.mortalitySnapshot.tooltip.trustSummary.weak': 'Debil',
    'home.kpi.mortalitySnapshot.tooltip.trustReason.current-summary-fallback': 'La ventana actual usa solo respaldo de resumen.',
    'home.kpi.mortalitySnapshot.tooltip.trustReason.previous-no-observed': 'La ventana previa no tiene muestras observadas.',
    'home.kpi.mortalitySnapshot.tooltip.trustReason.previous-stale': 'La evidencia previa de Mortality Log esta desactualizada.',
    'home.kpi.mortalitySnapshot.tooltip.trustReason.current-no-observed': 'La ventana actual no tiene muestras observadas.',
    'home.kpi.mortalitySnapshot.tooltip.trustReason.both-log-backed-recent': 'Ambas ventanas están respaldadas por logs recientes.',
    'home.kpi.mortalitySnapshot.tooltip.trustReason.mixed-evidence': 'La evidencia observada mezcla Mortality Log y senales de respaldo.',
    'home.kpi.mortalitySnapshot.tooltip.sourceMode': 'Modo de fuente observada (actual/previa): {currentMode}, {previousMode}',
    'home.kpi.mortalitySnapshot.tooltip.sourceMode.mortality-log-only': 'Solo Mortality Log',
    'home.kpi.mortalitySnapshot.tooltip.sourceMode.mixed': 'Mixto (Mortality Log + respaldo de resumen)',
    'home.kpi.mortalitySnapshot.tooltip.sourceMode.summary-fallback': 'Solo respaldo de resumen',
    'home.kpi.mortalitySnapshot.tooltip.sourceMode.no-observed': 'Sin muestras observadas',
    'home.kpi.mortalitySnapshot.tooltip.sourceCoverage': 'Muestras respaldadas por Mortality Log (actual/previa): {currentLog}/{currentTotal}, {previousLog}/{previousTotal}',
    'home.kpi.mortalitySnapshot.tooltip.sourceCoverageDates': 'Fechas mas recientes de muestra de Mortality Log (actual/previa): {currentDate}, {previousDate}',
    'home.kpi.mortalitySnapshot.tooltip.sourceRecencyRisk': 'Riesgo de vigencia de Mortality Log (actual/previa): {currentRisk}, {previousRisk}',
    'home.kpi.mortalitySnapshot.tooltip.sourceRecencyRisk.fresh': 'Reciente',
    'home.kpi.mortalitySnapshot.tooltip.sourceRecencyRisk.aging': 'En envejecimiento',
    'home.kpi.mortalitySnapshot.tooltip.sourceRecencyRisk.stale': 'Desactualizado',
    'home.kpi.mortalitySnapshot.tooltip.sourceRecencyRisk.unknown': 'Desconocido',
    'home.kpi.mortalitySnapshot.tooltip.trend': 'Tendencia: {value}',
    'home.kpi.mortalitySnapshot.tooltip.trend.improving': 'Mejorando',
    'home.kpi.mortalitySnapshot.tooltip.trend.worsening': 'Empeorando',
    'home.kpi.mortalitySnapshot.tooltip.trend.stable': 'Estable',
    'home.kpi.mortalitySnapshot.tooltip.trend.insufficient-history': 'Historial insuficiente',
    'home.kpi.weeklySurvival.tooltip': 'Se calcula como 100% - Mortalidad semanal.',
    'home.kpi.growthRate.title': 'Tasa de crecimiento',
    'home.kpi.activeTasks.title': 'Tareas activas',

    'home.kpi.trend.vsLastMonth': 'vs mes anterior',
    'home.kpi.trend.vsPrevious7Days': 'vs 7 días previos',
    'home.kpi.trend.vsLastWeek': 'vs semana anterior',
    'home.kpi.trend.vsPriorBaseline': 'vs línea base previa',

    'home.kpi.actualDailyFeed.detail.events': '{events} eventos',
    'home.kpi.actualDailyFeed.detail.eventsAdherence': '{events} eventos · {adherence}% adherencia',

    'home.kpi.activeTasks.tooltip.loading': 'Cargando tareas...',
    'home.kpi.activeTasks.tooltip.failed': 'Falló la carga de tareas: {error}',
    'home.kpi.activeTasks.tooltip.summary': 'Tareas activas para el contexto actual (granja/unidad/lote). Incluye tareas sin etiquetas de contexto. Actualizado {date}.',


    'home.pinnedWidgets.sectionTitle': '📌 Reportes y gráficos destacados',
    'home.pinnedWidgets.viewFullPanel': 'Ver Panel completo',
    'home.pinnedWidgets.empty': 'Aún no hay widgets fijados. Usa "Agregar widget" o fija uno desde Panel.',
    'home.pinnedWidgets.addWidget': 'Agregar widget',
    'home.pinnedWidgets.addWidget.empty': 'Ya agregaste todos los widgets disponibles de Panel. Crea uno nuevo en Panel para poder agregarlo aquí.',
    'home.pinnedWidgets.addWidget.add': 'Agregar',
    'home.pinnedWidgets.remove': 'Quitar',

    'home.water.sectionTitle': '💧 Monitoreo de calidad de agua',
    'home.water.ph.title': 'Nivel de pH',
    'home.water.do.title': 'Oxígeno disuelto',
    'home.water.salinity.title': 'Salinidad',
    'home.water.temp.title': 'Temperatura',

    'home.quickActions.sectionTitle': '⚡ Acciones rápidas',
    'home.quickActions.scheduleFeeding': 'Programar alimentación',
    'home.quickActions.recordWaterTest': 'Registrar prueba de agua',
    'home.quickActions.setTask': 'Crear tarea',
    'home.quickActions.backupData': 'Respaldar datos',
    'home.quickActions.generateReport': 'Generar reporte',

    'home.activity.sectionTitle': '🕒 Actividad reciente',
    'home.activity.error.unableToLoad': 'No se puede cargar la actividad reciente.',
    'home.activity.empty.noActivity': 'Aún no hay actividad. Las actualizaciones y acciones en cola de sync aparecerán aquí.',

    // Reports
    'reports.title': 'Reportes',
    'reports.subtitle': 'Crea y guarda tablas dinámicas (privadas o del equipo).',

    'reports.create.title': 'Crear reporte',
    'reports.field.name': 'Nombre',
    'reports.field.name.placeholder': 'Ej.: Mortalidad semanal Potgapampa',
    'reports.field.dataset': 'Tipo de reporte',
    'reports.field.dataset.placeholder': 'Elige qué quieres ver',
    'reports.field.visibility': 'Visibilidad',
    'reports.visibility.private': 'Privado (solo yo)',
    'reports.visibility.team': 'Equipo (compartido)',

    'reports.columns.title': 'Columnas',
    'reports.columns.noneAvailable': 'Elige primero el tipo de reporte.',

    'reports.fx.sourceTitle': 'Dinero fuente',
    'reports.fx.sourceBody': 'El dinero fuente sigue siendo la autoridad. La conversión FX solo agrega valores y nunca reescribe las columnas originales de dinero.',
    'reports.fx.convertedTitle': 'Valores convertidos',
    'reports.fx.subtitle': 'Activa FX solo cuando necesites una vista convertida. Si está apagado, el reporte corre solo con el dinero fuente.',
    'reports.fx.enable': 'Agregar valores convertidos por FX',
    'reports.fx.targetCurrency': 'Moneda destino',
    'reports.fx.asOf': 'Corte al',
    'reports.fx.off': 'Conversión apagada: el reporte conserva solo el dinero fuente.',
    'reports.fx.notAvailable': 'Este dataset no admite conversión FX.',
    'reports.fx.convertedMoney': 'Los valores convertidos solo se agregan y muestran procedencia explícita en las filas del reporte.',
    'reports.fx.diagnostics': 'La tasa faltante queda nula con motivo, y los lotes con moneda mixta siguen siendo diagnosticables antes de convertir.',
    'reports.fx.summaryOn': 'FX activado · {currency} al {asOf}',
    'reports.fx.summaryOff': 'FX apagado',
    'reports.fx.previewTitle': 'Vista previa FX',

    'reports.scope.title': '¿Qué datos? (filtro) — se guarda con el reporte',
    'reports.scope.subtitle': 'Este alcance se aplicará cuando corra el reporte (incluyendo en dashboards).',
    'reports.scope.from': 'Desde',
    'reports.scope.to': 'Hasta',
    // v2.2 T3-B-06f: sentinel `Hoy (rodante)` para el campo Hasta.
    'reports.scope.toDateMode.aria': 'Cómo resolver la fecha Hasta',
    'reports.scope.toDateMode.fixed': 'Fecha fija',
    'reports.scope.toDateMode.today': 'Hoy (rodante)',
    'reports.scope.toDateMode.todayHint': 'Se resuelve a la fecha de hoy al Correr — no hace falta editarla.',
    'reports.scope.facilities': 'Instalaciones',
    'reports.scope.productionUnits': 'Unidades de producción',
    'reports.scope.lots': 'Lotes',
    'reports.choice.clear': 'Limpiar',
    'reports.choice.noneAvailable': 'No hay opciones disponibles.',

    'reports.create.trigger.subtitle': 'Filtra, elige columnas y guarda un nuevo reporte.',
    'reports.button.newReport': 'Nuevo reporte',
    'reports.edit.title': 'Editar reporte',
    'reports.button.duplicate': 'Duplicar',
    'reports.duplicate.namePrefix': 'Copia de {name}',
    'reports.button.sendToPanel': 'Enviar a Panel',
    'reports.button.previewDraft': 'Vista previa',

    'reports.button.save': 'Guardar reporte',
    'reports.saved.title': 'Reportes guardados',
    'reports.saved.empty': 'Aún no hay reportes. Crea uno arriba.',
    'reports.button.run': 'Correr',
    // v2.2 T3-B-08: Reports v1 Edit button. Cierra el hallazgo #5 de v2.2.
    'reports.button.edit': 'Editar',
    'reports.button.cancelEdit': 'Cancelar edición',
    'reports.form.editingHint': 'Editando “{name}” — Guardar sobrescribe este reporte.',
    'reports.button.publishInternal': 'Publicar internamente',
    'reports.button.exportCsv': 'Exportar CSV',

    'reports.results.title': 'Resultados',
    'reports.preview.selectPrompt': 'Selecciona un reporte para ver la vista previa.',
    'reports.preview.scopeApplied': 'Alcance aplicado · Filas: {total} total · {scoped} en alcance',
    'reports.deletedLot.leftOut': 'No se incluyen los registros de {count} lotes eliminados (se conservan; Lotes → Lotes eliminados → Restaurar los recupera).',
    'reports.deletedLot.leftOutOne': 'No se incluyen los registros de 1 lote eliminado (se conservan; Lotes → Lotes eliminados → Restaurar los recupera).',
    'reports.preview.loading': 'Cargando…',
    'reports.preview.runFailed': 'Falló la ejecución: {error}',
    'reports.preview.clickRun': 'Haz clic en “Correr” para cargar filas.',
    'reports.publish.subtitle': 'Publica la vista previa actual con alcance aplicado como un snapshot inmutable de Collaboration usando la visibilidad de este reporte.',
    'reports.publish.noneYet': 'Todavía no hay un snapshot interno publicado para este reporte.',
    'reports.publish.current': 'Snapshot interno actual · Versión {version}',
    'reports.publish.publishedAt': 'Publicado el {date}',
    'reports.publish.success': 'Publicado internamente como versión {version}.',
    'reports.publish.error.noPreview': 'Corre el reporte y mantén al menos una fila en alcance antes de publicarlo internamente.',
    'reports.publish.error.failed': 'Falló la publicación interna: {error}',

    'reports.error.unknownDataset': 'Dataset desconocido: {datasetKey}',
    'reports.cell.unserializable': '[no serializable]',
    'reports.cell.removedFarmSuffix': '(granja eliminada)',
    'reports.cell.derivedTooltip': 'Valor estimado (calculado), no una lectura directa.',
    // 2026-09-12 pack: split the single ambiguous seeded report into two
    // unambiguously-named ones (harvest vs in-flight FCR). The old key
    // stays as the exact-match marker `seedDefaultReportsIfEmpty` uses to
    // migrate an existing tenant's already-seeded report without
    // clobbering a name the operator chose themselves.
    'reports.seed.costPerKg.name': 'Costo por kg — vista general',
    'reports.seed.costPerKgHarvest.name': 'Costo por kg — al cosechar',
    'reports.seed.costPerKgInFlight.name': 'Costo por kg — en curso',
    'dashboardNew.seed.fcrHarvestByLot.title': 'eFCR al cosechar, por lote',
    'dashboardNew.seed.fcrInFlightByLot.title': 'eFCR en curso, por lote',

    // Reports/Panel pack item (c): weekly SGR / FCR (planificado) / SFR
    // por lote.
    'reports.seed.lotGrowthPerformance.name': 'Crecimiento por lote — SGR, FCR, SFR (semanal)',
    'dashboardNew.seed.lotGrowthSgr.title': 'SGR semanal, por lote',
    'dashboardNew.seed.lotGrowthFcr.title': 'FCR (planificado) semanal, por lote',
    'dashboardNew.seed.lotGrowthSfr.title': 'SFR semanal, por lote',

    // v2.2 findings.md #45: widgets de monitoreo base (mortalidad, stock,
    // peso promedio) sobre el reporte Datatable de producción.
    'reports.seed.coreMonitoring.name': 'Monitoreo base — mortalidad, stock, peso (diario)',
    'dashboardNew.seed.coreMortalityRate.title': 'Mortalidad diaria promedio (%), por lote',
    'dashboardNew.seed.coreStock.title': 'Stock total (semanal)',
    'dashboardNew.seed.coreAvgWeight.title': 'Peso promedio semanal (g), por lote',

    // Lots
    'lots.title': 'Gestionar lotes',
    'lots.subtitle':
      'Crea y mantén lotes de producción para cada granja y unidad. Estos identificadores alimentan tareas, registros de agua y registros de producción.',
    'lots.instructions.refreshHint': 'Usa Actualizar lotes si todavía no ves cambios hechos desde otro dispositivo.',
    'lots.readonly.banner': 'Modo de solo lectura (token {role}). Editar lotes requiere un token de editor.',
    'lots.workspace.label': 'Espacio de trabajo',
    'lots.workspace.operations': 'Operaciones',
    'lots.workspace.operations.subtitle': 'Mantén la creación, transferencias, trazabilidad y mantenimiento de lotes en la superficie operativa.',
    'lots.workspace.story': 'Espacio de historia',
    'lots.workspace.story.subtitle': 'Revisa vistas previas, borradores, promoción y comprobaciones de entrega al receptor sin saturar las herramientas operativas.',
    'lots.workspace.story.activeSelection': 'Historia de lote actual: {lot}',
    'lots.workspace.story.empty': 'Abre una historia de lote desde la biblioteca o vuelve a Operaciones y lánzala desde una fila del lote.',

    'lots.filter.facilityLabel': 'Instalación',
    'lots.filter.productionUnitLabel': 'Unidad de producción',
    'lots.filter.processingSiteLabel': 'Sitio de procesamiento',
    'lots.filter.loadingContext': 'Cargando el contexto guardado de instalación y sububicación...',
    'lots.filter.allFacilities': 'Todas las granjas',
    'lots.filter.allUnits': 'Todas las unidades',
    'lots.filter.allUnitsInSelectedFacility': 'Todas las unidades en la instalación seleccionada',
    'lots.filter.allProcessingSites': 'Todos los sitios de procesamiento',
    'lots.filter.allProcessingSitesInSelectedFacility': 'Todos los sitios de procesamiento en la instalación seleccionada',

    'lots.processingSiteSummary.title': 'Resumen del sitio de procesamiento',
    'lots.processingSiteSummary.subtitle': 'Lotes visibles actualmente en {site}.',
    'lots.processingSiteSummary.totalLots': 'Lotes actuales',
    'lots.processingSiteSummary.activeLots': 'Lotes activos',
    'lots.processingSiteSummary.totalBiomass': 'Biomasa total (kg)',
    'lots.processingSiteSummary.species': 'Especies en vista',
    'lots.processingSiteSummary.noSpecies': 'No hay especies registradas',
    'lots.processingSiteSummary.latestActivity': 'Actividad visible mas reciente',
    'lots.processingSiteSummary.latestActivityValue': '{lot} se actualizo {timestamp}',
    'lots.processingSiteSummary.noActivity': 'Todavia no hay marca de actividad visible',
    'lots.processingSiteSummary.recentLots': 'Lotes recientes en vista',
    'lots.processingSiteSummary.noRecentLots': 'Todavia no hay lotes visibles recientes',
    'lots.processingSiteSummary.recentLotMeta': 'Estado: {stage} · Actualizado {timestamp}',
    'lots.processingSiteSummary.recentLotSource': 'Lote origen: {sourceLot}',
    'lots.processingSiteSummary.recentLotProvenance': '{eventType} desde {origin}',
    'lots.processingSiteSummary.recentLotProvenanceWithTimestamp': '{eventType} desde {origin} el {timestamp}',
    'lots.processingSiteSummary.recentLotPreviousProvenanceWithTimestamp': 'Origen previo registrado: {eventType} desde {origin} el {timestamp}',
    'lots.processingSiteSummary.siteActivity': 'Actividad reciente del sitio',
    'lots.processingSiteSummary.noSiteActivity': 'Todavia no hay movimientos o traslados recientes hacia este sitio',
    'lots.processingSiteSummary.siteActivityTransfers': 'Traslados: {count}',
    'lots.processingSiteSummary.siteActivityMoves': 'Movimientos: {count}',
    'lots.processingSiteSummary.siteActivityFilterAll': 'Todos',
    'lots.processingSiteSummary.siteActivityFilterTransfers': 'Solo traslados',
    'lots.processingSiteSummary.siteActivityFilterMoves': 'Solo movimientos',
    'lots.processingSiteSummary.originSummaryTitle': 'Origenes recientes principales en este filtro',
    'lots.processingSiteSummary.originSummaryEntry': '{origin} · {total} entradas ({transfers} traslados, {moves} movimientos) · mas reciente {timestamp}',
    'lots.processingSiteSummary.originRecencyBadgeLast24h': 'Ultimas 24h',
    'lots.processingSiteSummary.originRecencyBadgeLast7d': 'Ultimos 7 dias',
    'lots.processingSiteSummary.originRecencyBadgeStale': 'Desactualizado',
    'lots.processingSiteSummary.originRecencyBadgeUnknown': 'Desconocido',
    'lots.processingSiteSummary.originRecencyBreakdown': 'Mezcla de frescura por origen: Ultimas 24h {last24h} · Ultimos 7 dias {last7d} · Desactualizado {stale} · Desconocido {unknown}',
    'lots.processingSiteSummary.recencyWindowTitle': 'Ventana de actividad reciente',
    'lots.processingSiteSummary.recencyWindowValue': 'Ultimas 24h: {last24h} · Ultimos 7 dias: {last7d}',
    'lots.processingSiteSummary.recencyWindowStaleWarning': 'No hay llegadas registradas en los ultimos 7 dias para este filtro.',
    'lots.processingSiteSummary.unknownOrigin': 'Origen desconocido',
    'lots.processingSiteSummary.latestArrival': 'Ultima llegada en el filtro actual',
    'lots.processingSiteSummary.latestArrivalEntry': '{lot}: {eventType} desde {origin} el {timestamp}',
    'lots.processingSiteSummary.noSiteActivityForFilter': 'No hay entradas recientes para este filtro de actividad',
    'lots.processingSiteSummary.siteActivityEntry': '{lot}: {eventType} desde {origin} el {timestamp}',

    'app.localWriteFailed': 'Este dispositivo no pudo guardar un cambio localmente (almacenamiento lleno o bloqueado). Mantén esta página abierta con conexión para que se sincronice y avisa a tu administrador.',
    'lots.stockUnits.title': 'Sembrar en varias unidades',
    'lots.stockUnits.subtitle': 'Un lote llega y se siembra en varios estanques: un lote por unidad, con el mismo nombre y vinculado al lote de llegada.',
    'lots.stockUnits.intro': 'El lote se registra una vez a nivel de instalación y se divide en un lote por unidad. Cada unidad conserva el nombre; los reportes pueden agruparlos con "Lote (origen)".',
    'lots.stockUnits.name': 'Nombre del lote',
    'lots.stockUnits.namePlaceholder': 'p. ej. Lote 1',
    'lots.stockUnits.nameHint': 'El nombre solo debe ser único dentro de cada unidad.',
    'lots.stockUnits.date': 'Fecha de siembra',
    'lots.stockUnits.species': 'Especie',
    'lots.stockUnits.totalFish': 'Peces que llegaron',
    'lots.stockUnits.averageWeight': 'Peso promedio de llegada (g)',
    'lots.stockUnits.seedSupplier': 'Proveedor de semilla (hatchery / origen)',
    'lots.stockUnits.strain': 'Línea genética / cepa',
    'lots.stockUnits.units': 'Unidades y peces por unidad',
    'lots.stockUnits.noUnits': 'Esta instalación aún no tiene unidades de producción.',
    'lots.stockUnits.fishPerUnit': 'Peces',
    'lots.stockUnits.fishPerUnitFor': 'Peces para {unit}',
    'lots.stockUnits.nameTakenHere': 'ya tiene un lote con este nombre',
    'lots.stockUnits.spreadEvenly': 'Repartir en partes iguales',
    'lots.stockUnits.assignedOfTotal': '{assigned} de {total} peces asignados',
    'lots.stockUnits.assigned': '{assigned} peces en {units} unidades',
    'lots.stockUnits.notes': 'Notas',
    'lots.stockUnits.submit': 'Sembrar',
    'lots.stockUnits.success': '"{name}" sembrado en {count} unidades.',
    'lots.stockUnits.error.name': 'Escribe el nombre del lote.',
    'lots.stockUnits.error.date': 'Indica la fecha de siembra.',
    'lots.stockUnits.error.units': 'Elige al menos dos unidades (para una sola unidad, crea el lote normalmente).',
    'lots.stockUnits.error.nameTaken': 'Una de las unidades ya tiene un lote con este nombre. Cambia el nombre o la unidad.',
    'lots.stockUnits.error.countsAllOrNone': 'Indica los peces de cada unidad elegida, o deja todas vacías.',
    'lots.stockUnits.error.countsNeeded': 'Indicaste los peces que llegaron: repártelos entre las unidades ("Repartir en partes iguales" ayuda).',
    'lots.stockUnits.error.countsMismatch': 'Las unidades suman {assigned} peces, pero llegaron {total}.',
    'lots.stockUnits.error.weight': 'El peso promedio debe ser un número mayor que 0.',
    'lots.stockUnits.error.offline': 'Estás sin conexión. Sembrar en varias unidades necesita conexión.',
    'lots.stockUnits.error.generic': 'No se pudo sembrar el lote. No se guardó nada — inténtalo de nuevo.',
    'lots.lineage.title': 'Trazabilidad: dividir y unir lotes',
    'lots.lineage.subtitle': 'Registra divisiones y uniones de lotes para mantener la trazabilidad entre unidades de producción.',
    'lots.lineage.hint.selectContext': 'Selecciona una granja para dividir o unir lotes.',
    'lots.lineage.readonly.banner': 'Modo de solo lectura (token {role}). Dividir o unir lotes requiere un token de editor.',
    'lots.lineage.processingPlantNotice': 'Dividir y unir lotes sigue siendo exclusivo de granja. Usa transferencia, historial y revisión de historia desde contextos de planta de procesamiento por ahora.',

    'lots.lineage.split.title': 'Dividir lote',
    'lots.lineage.split.sourceLotLabel': 'Lote origen',
    'lots.lineage.split.selectLot': 'Selecciona lote',
    'lots.lineage.quickPickerLabel': 'Selector rápido de origen',
    'lots.lineage.quickPickerPlaceholder': 'Busca clave de lote o unidad de producción',
    'lots.lineage.quickPickerSuggested': 'Lotes origen sugeridos',
    'lots.lineage.quickPickerMatches': 'Lotes origen coincidentes',
    'lots.lineage.quickPickerEmpty': 'Todavía no hay lotes origen que coincidan con esta búsqueda.',
    'lots.lineage.split.recordedAtLabel': 'Registrado en',
    'lots.lineage.split.newLotKeyALabel': 'Nueva clave de lote A',
    'lots.lineage.split.newLotKeyBLabel': 'Nueva clave de lote B',
    'lots.lineage.split.notesLabel': 'Notas',
    'lots.lineage.split.placeholderKeyA': 'Ejemplo: LOT-123A',
    'lots.lineage.split.placeholderKeyB': 'Ejemplo: LOT-123B',
    'lots.lineage.split.recordButton': 'Registrar división',

    'lots.lineage.merge.title': 'Unir lotes',
    'lots.lineage.merge.sourceLotsLabel': 'Lotes origen (selecciona 2+)',
    'lots.lineage.merge.recordedAtLabel': 'Registrado en',
    'lots.lineage.merge.newMergedKeyLabel': 'Nueva clave del lote unido',
    'lots.lineage.merge.placeholderKey': 'Ejemplo: LOT-123M',
    'lots.lineage.merge.markInactiveLabel': 'Marcar lotes origen como inactivos',
    'lots.lineage.merge.notesLabel': 'Notas',
    'lots.lineage.merge.guidance.selectOneMore': 'Selecciona un lote origen más de {unit} para continuar.',
    'lots.lineage.merge.guidance.ready': 'Todos los lotes origen seleccionados están en {unit}. Puedes unirlos.',
    'lots.lineage.merge.guidance.crossUnit': 'La selección actual abarca varias unidades de producción: {units}. Para unir lotes, todos deben estar en la misma unidad de producción.',
    'lots.lineage.merge.selectedSummary': 'Lotes origen seleccionados ({count})',
    'lots.lineage.merge.groupSummary': '{unit} ({count})',
    'lots.lineage.merge.clearSelection': 'Limpiar selección',
    'lots.lineage.merge.removeSource': 'Quitar',
    'lots.lineage.merge.moveSourceEarlier': 'Antes',
    'lots.lineage.merge.moveSourceLater': 'Después',
    'lots.lineage.merge.review.compactSummary': 'Mostrando {shown} de {total} lotes origen seleccionados. {hidden} más quedan en la revisión compacta.',
    'lots.lineage.merge.review.expandedSummary': 'Revisando los {total} lotes origen seleccionados.',
    'lots.lineage.merge.review.showAll': 'Revisar todos los orígenes',
    'lots.lineage.merge.review.showLess': 'Mostrar revisión compacta',
    'lots.lineage.merge.recordButton': 'Registrar unión',

    'lots.lineage.error.selectContextFirst': 'Primero selecciona una granja.',
    'lots.lineage.error.chooseSourceLot': 'Elige el lote que quieres dividir.',
    'lots.lineage.error.enterTwoKeys': 'Ingresa al menos dos claves nuevas para dividir el lote.',
    'lots.lineage.error.mergeSelectAtLeastTwo': 'Selecciona al menos dos lotes para unir.',
    'lots.lineage.error.mergeSameUnit': 'Para unir lotes, todos deben estar en la misma unidad de producción.',
    'lots.lineage.error.mergeEnterTargetKey': 'Ingresa la clave del nuevo lote unido.',
    'lots.lineage.error.splitFailed': 'No se pudo dividir el lote.',
    'lots.lineage.error.mergeFailed': 'No se pudieron unir los lotes.',

    'lots.lineage.parentsPrefix': 'Padres:',
    'lots.lineage.childrenPrefix': 'Hijos:',
    'lots.lineage.summary': 'P:{parents} H:{children}',
    'lots.history.button.show': 'Historial',
    'lots.history.button.hide': 'Ocultar historial',
    'lots.history.title': 'Historial de {lot}',
    'lots.history.subtitle': 'Se carga bajo demanda desde el libro mayor LotEvent y queda en caché local después de cargarse. Las mutaciones locales pendientes pueden no aparecer aquí hasta que se sincronicen.',
    'lots.history.current.title': 'Estado actual del lote',
    'unit.inactive.suffix': '(Inactiva)',
    'unit.inactive.captureBlocked': 'Esta unidad está Inactiva: sus registros siguen visibles, pero no se pueden agregar nuevos. Reactívala en Editar instalación para volver a registrar.',
    'lots.projection.title': 'Proyección',
    'lots.projection.lowConfidence': 'Baja confianza — léela con cuidado',
    'lots.projection.loading': 'Calculando proyección…',
    'lots.projection.unavailable': 'Sin proyección para este lote.',
    'lots.projection.status.noSampling': 'Aún no hay muestreo: registra un muestreo para proyectar el crecimiento.',
    'lots.projection.status.noGrowthRate': 'Necesita dos muestreos con al menos una semana de diferencia, o un TGC de la instalación (Editar instalación).',
    'lots.projection.status.noTemperature': 'Sin temperatura del agua en esta unidad: registra la temperatura en Agua.',
    'lots.projection.status.noStock': 'Stock desconocido: registra un conteo de peces para este lote.',
    'lots.projection.target.label': 'Objetivo de cosecha',
    'lots.projection.target.fromLot': '{grams} g (este lote)',
    'lots.projection.target.fromFacility': '{grams} g (predeterminado de la instalación)',
    'lots.projection.target.none': 'sin definir',
    'lots.projection.target.edit': 'Cambiar',
    'lots.projection.target.help': 'Vacío = usa el predeterminado de la instalación.',
    'lots.projection.target.invalid': 'Ingresa un peso en gramos mayor que 0.',
    'lots.projection.target.saveFailed': 'No se pudo guardar el objetivo. Intenta de nuevo.',
    'lots.projection.harvest': 'Cosecha proyectada',
    'lots.projection.harvestValue': '{date} (en {days} días)',
    'lots.projection.weightToday': 'Peso estimado hoy',
    'lots.projection.weightIn30': 'Peso en 30 días',
    'lots.projection.biomass': 'Biomasa actual → a la cosecha',
    'lots.projection.stockAtHarvest': 'Peces a la cosecha',
    'lots.projection.feedToHarvest': 'Alimento hasta cosecha',
    'lots.projection.input.tgcObserved': 'Crecimiento: TGC {tgc} de los últimos muestreos (último: {date}, {weight} g).',
    'lots.projection.input.tgcOffice': 'Crecimiento: TGC de la instalación {tgc} (último muestreo: {date}, {weight} g).',
    'lots.projection.input.temperature': 'Temperatura: {temperature} °C (media de las lecturas recientes, constante).',
    'lots.projection.input.mortality': 'Mortalidad: {rate} %/día sobre días registrados ({recorded} de {total} días registrados).',
    'lots.projection.input.lowCompleteness': 'menos del {pct} % de días registrados',
    'lots.projection.caution.lowMortalityCompleteness': 'Pocos días con registro de mortalidad: la tasa puede no reflejar el lote (los días en blanco no se cuentan como cero).',
    'lots.projection.caution.noMortalityRecords': 'Sin registros de mortalidad en los últimos 30 días: no se aplica mortalidad.',
    'lots.projection.caution.officeTgc': 'El crecimiento usa el TGC de la instalación, no los muestreos de este lote.',
    'lots.projection.caution.oldSampling': 'El último muestreo tiene más de 30 días.',
    'lots.projection.caution.noTarget': 'Sin objetivo de cosecha: define uno para proyectar la fecha de cosecha y el alimento.',
    'lots.projection.caution.targetReached': 'El lote ya alcanzó el objetivo de cosecha.',
    'lots.projection.caution.horizonReached': 'Con el crecimiento actual no se alcanza el objetivo en 2 años.',
    'lots.projection.caution.noSfr': 'No aplica una matriz de SFR: no se calcula el alimento hasta cosecha.',
    'lots.projection.caution.unusualFcr': 'FCR proyectado fuera del rango habitual (0,8–2,5): el crecimiento y la matriz de SFR no concuerdan. Revisa los muestreos y la matriz de SFR.',
    'editFarm.projection.title': 'Proyección de lotes',
    'editFarm.projection.target': 'Objetivo de cosecha predeterminado (g)',
    'editFarm.projection.tgc': 'TGC cuando un lote tiene un solo muestreo',
    'editFarm.projection.help': 'Lo usan Lotes → lote → Proyección y el reporte "Proyección de lotes". Cada lote puede tener su propio objetivo. TGC típico en trucha: 1,5–3.',
    'editFarm.projection.invalid': 'Ingresa números positivos (TGC hasta 6).',
    'lots.hatchery.title': 'Incubación',
    'lots.hatchery.stage.eggs': 'Ovas',
    'lots.hatchery.stage.yolkSac': 'Alevines con saco vitelino',
    'lots.hatchery.stage.firstFeeding': 'Primera alimentación',
    'lots.hatchery.record.eggs': 'Registrar llegada de ovas',
    'lots.hatchery.record.yolkSac': 'Registrar eclosión',
    'lots.hatchery.record.firstFeeding': 'Registrar primera alimentación',
    'lots.hatchery.stageDate': 'Fecha real:',
    'lots.hatchery.dueNotice': 'Alcanzó las UTA objetivo — registra la fecha real cuando la observes.',
    'lots.hatchery.stageLine.eggs': 'Ovas desde {date}',
    'lots.hatchery.stageLine.yolkSac': 'eclosión {date}',
    'lots.hatchery.stageLine.firstFeeding': 'primera alimentación {date}',
    'lots.hatchery.noProjectionYet': 'Las ovas y los alevines con saco vitelino aún no comen ni crecen: la proyección de crecimiento y alimento empieza en la primera alimentación.',
    'lots.hatchery.loading': 'Cargando datos de incubación…',
    'lots.hatchery.unavailable': 'Sin datos de incubación para este lote.',
    'lots.hatchery.tuaToDate': 'UTA a la fecha',
    'lots.hatchery.tuaDetail': '{arrival} a la llegada + {accumulated} en {days} días',
    'lots.hatchery.milestone.hatch': 'Eclosión',
    'lots.hatchery.milestone.firstFeeding': 'Primera alimentación',
    'lots.hatchery.milestone.recorded': '{date} (con {tua} UTA)',
    'lots.hatchery.milestone.expected': '≈ {date} (en {days} días, objetivo {tua} UTA)',
    'lots.hatchery.milestone.due': 'Ya corresponde (objetivo {tua} UTA)',
    'lots.hatchery.milestone.target': 'Objetivo {tua} UTA (aún sin temperatura)',
    'lots.hatchery.milestone.noTarget': 'Sin UTA objetivo',
    'lots.hatchery.alive': 'Vivos ahora',
    'lots.hatchery.ofReceived': 'de {received} recibidas',
    'lots.hatchery.survival': 'Supervivencia',
    'lots.hatchery.survivalToHatch': '{pct} % a eclosión',
    'lots.hatchery.survivalToFirstFeeding': '{pct} % a primera alimentación',
    'lots.hatchery.survivalToDate': '{pct} % a la fecha',
    'lots.hatchery.deaths': 'Ovas muertas {eggs} · alevines muertos {alevins}',
    'lots.hatchery.density': 'Densidad en esta unidad',
    'lots.hatchery.perLitre': '{value} por litro',
    'lots.hatchery.perLitreDetail': '{alive} vivos ÷ {litres} L (unidad de {cubic} m³)',
    'lots.hatchery.noVolume': 'Volumen de la unidad sin definir (Editar instalación)',
    'lots.hatchery.flow': 'Caudal',
    'lots.hatchery.flowValue': '{flow} L/min · {perThousand} L/min por 1.000',
    'lots.hatchery.flowDate': 'Lectura del {date}',
    'lots.hatchery.noFlow': 'Sin lectura de caudal: marca "Caudal" en los parámetros de agua de la unidad (Editar instalación) y regístralo en Agua.',
    'lots.hatchery.eggSize': 'Tamaño de ova',
    'lots.hatchery.eggSizeValue': '{diameter} mm · ≈ {mg} mg por ova',
    'lots.hatchery.fryWeight': 'Alevín a primera alimentación ≈ {grams} g (aprox., hasta el primer muestreo)',
    'lots.hatchery.input.temperature': 'Temperatura: {temperature} °C media reciente · lecturas propias en {recorded} de {total} días desde la llegada.',
    'lots.hatchery.input.temperatureBorrowed': 'Temperatura de {units} (misma llegada o punto de medición) en {borrowed} de {total} días: esta unidad no tiene lectura esos días.',
    'lots.hatchery.input.mortality': 'Mortalidad registrada en {recorded} días ({pct} % de los días de esta etapa).',
    'lots.hatchery.input.origin': 'Origen: {supplier} · lote del proveedor {lot} · certificación {certification}',
    'lots.hatchery.input.health': 'Certificado sanitario {certificate} ({date}) · cuarentena: {quarantine}',
    'lots.hatchery.input.disinfection': 'Desinfección a la llegada: {product} {ppm} ppm, {minutes} min ({date})',
    'lots.hatchery.input.noDisinfection': 'Desinfección a la llegada: sin registrar',
    'lots.hatchery.inheritedOrigin': 'El origen de las ovas y la etapa vienen del lote del que se dividió este.',
    'lots.hatchery.yes': 'sí',
    'lots.hatchery.no': 'no',
    'lots.hatchery.edit': 'Editar recepción de ovas',
    'lots.hatchery.applyToSiblings': 'Guardar también en los otros {count} lotes del mismo origen',
    'lots.hatchery.start.question': '¿Este lote llegó como ovas?',
    'lots.hatchery.start.button': 'Registrar recepción de ovas',
    'lots.hatchery.arrival.title': 'Recepción de ovas',
    'lots.hatchery.arrival.origin': 'Origen y trazabilidad',
    'lots.hatchery.arrival.health': 'Estado sanitario',
    'lots.hatchery.arrival.disinfection': 'Desinfección a la llegada',
    'lots.hatchery.arrival.help': 'Guarda los certificados en papel; aquí se registra su número y fecha. Las UTA objetivo vacías usan las de la instalación (Editar instalación).',
    'lots.hatchery.field.arrivalDate': 'Fecha de llegada',
    'lots.hatchery.field.eggsReceived': 'Ovas recibidas',
    'lots.hatchery.field.tuaAtArrival': 'UTA a la llegada (°C·día)',
    'lots.hatchery.field.hatchTargetTua': 'Eclosión a (UTA totales)',
    'lots.hatchery.field.firstFeedingTargetTua': 'Primera alimentación a (UTA totales)',
    'lots.hatchery.field.eggDiameterMm': 'Diámetro de ova (mm)',
    'lots.hatchery.field.eggsPerGram': 'Ovas por gramo',
    'lots.hatchery.field.eggsPerLitre': 'Ovas por litro',
    'lots.hatchery.field.eggVolumeLitres': 'Volumen total de ovas (L)',
    'lots.hatchery.arrival.countHelp': '¿Sin conteo exacto? Ingresa ovas por litro y los litros totales: ovas recibidas = ovas/L × L (estimado).',
    'lots.hatchery.countFromVolume': '(estimado por volumen)',
    'lots.hatchery.field.supplier': 'Proveedor',
    'lots.hatchery.field.supplierLot': 'Lote del proveedor',
    'lots.hatchery.field.supplierCertification': 'Certificación del proveedor (n.º de certificado)',
    'lots.hatchery.field.strain': 'Línea genética / cepa',
    'lots.hatchery.field.healthCertificateNo': 'N.° de certificado sanitario',
    'lots.hatchery.field.healthCertificateDate': 'Fecha del certificado',
    'lots.hatchery.field.quarantine': 'En cuarentena',
    'lots.hatchery.field.disinfectionProduct': 'Producto',
    'lots.hatchery.field.disinfectionPpm': 'Dosis (ppm)',
    'lots.hatchery.field.disinfectionMinutes': 'Tiempo (min)',
    'lots.hatchery.field.disinfectionDate': 'Fecha',
    'lots.hatchery.trait.allFemale': 'Todas hembras',
    'lots.hatchery.trait.triploid': 'Triploides',
    'lots.hatchery.caution.noArrivalDate': 'Sin fecha de llegada: no se pueden acumular UTA.',
    'lots.hatchery.caution.noEggCount': 'Sin número de ovas: registra las ovas recibidas para ver supervivencia y densidad.',
    'lots.hatchery.caution.noTemperature': 'Sin temperatura del agua en esta unidad ni en otra unidad de la misma llegada: regístrala a diario en Agua para acumular UTA.',
    'lots.hatchery.caution.fewTemperatureDays': 'Temperatura registrada en menos del 70 % de los días: los días sin lectura usan la lectura anterior.',
    'lots.hatchery.caution.noMortalityRecords': 'Sin registros de mortalidad en esta etapa (un día en blanco no es cero).',
    'lots.hatchery.caution.lowMortalityCompleteness': 'Pocos días con registro de mortalidad: la supervivencia puede salir alta.',
    'lots.hatchery.caution.noTargets': 'Sin UTA objetivo: defínelas en el lote o en Editar instalación para proyectar eclosión y primera alimentación.',
    'lots.hatchery.error.stageBeforeArrival': 'La fecha no puede ser anterior a la llegada.',
    'lots.hatchery.error.futureDate': 'La fecha no puede ser futura.',
    'lots.hatchery.error.invalidNumber': 'Revisa los números: deben ser positivos (ovas recibidas, un número entero).',
    'lots.hatchery.error.diameter': 'El diámetro de ova no parece correcto (mm, normalmente 3–7).',
    'lots.hatchery.error.targetsOrder': 'Las UTA de primera alimentación deben ser mayores que las de eclosión.',
    'lots.hatchery.error.arrivalDate': 'Indica la fecha de llegada.',
    'lots.hatchery.error.saveFailed': 'No se pudo guardar. Intenta de nuevo.',
    'lots.projection.status.hatcheryStage': 'Ovas o alevines con saco vitelino: sin proyección de crecimiento ni alimento hasta la primera alimentación.',
    'lots.projection.caution.estimatedStartWeight': 'El crecimiento parte del peso de alevín estimado por el tamaño de ova (aprox.) — registra un muestreo para reemplazarlo.',
    'editFarm.hatchery.title': 'Incubación (lotes de ovas)',
    'editFarm.hatchery.hatchTargetTua': 'Eclosión a (UTA totales)',
    'editFarm.hatchery.firstFeedingTargetTua': 'Primera alimentación a (UTA totales)',
    'editFarm.hatchery.fryWeightFactor': 'Peso alevín ÷ peso ova',
    'editFarm.hatchery.help': 'Lo usan los lotes de ovas sin objetivos propios. UTA totales, desde la fecundación como en la hoja del proveedor (cada lote suma sus UTA a la llegada). Usa los valores de tu proveedor de ovas. El factor convierte el peso de la ova en el peso estimado del alevín a primera alimentación (vacío = 1).',
    'editFarm.hatchery.invalid': 'Ingresa números positivos (factor hasta 5).',
    'editFarm.hatchery.mortality.title': 'Mortalidad diaria de referencia (%)',
    'editFarm.hatchery.mortality.green': 'verde hasta',
    'editFarm.hatchery.mortality.red': 'rojo desde',
    'editFarm.hatchery.mortality.eggs': 'Ovas',
    'editFarm.hatchery.mortality.yolkSac': 'Alevines con saco',
    'editFarm.hatchery.mortality.critical': 'Días críticos',
    'editFarm.hatchery.mortality.help': 'Colorea la Mortalidad diaria % en Base de datos para lotes de ovas y alevines con saco (entre los dos valores = amarillo). Días críticos: llegada y reincubación de las ovas (2 días), eclosión (4 días desde la fecha de eclosión), primera alimentación (7 días) y primer traslado después de la eclosión (2 días). Vacío = el valor sugerido que se ve en gris.',
    'editFarm.hatchery.mortality.invalid': 'En cada fila, "rojo desde" debe ser mayor que "verde hasta" (máximo 100 %).',
    'crewMode.mortality.cause.deadEgg': 'Ova muerta (blanca)',
    'crewMode.mortality.cause.notHatched': 'No eclosionó',
    'crewMode.mortality.cause.deformed': 'Deforme',
    'crewMode.mortality.cause.fungus': 'Hongos',
    'crewMode.mortality.countHatchery': '¿Cuántas ovas o alevines muertos?',
    'crewMode.water.parameter.flow': 'Caudal',
    'water.table.flow': 'Caudal (L/min)',
    'reports.dataset.lotHatchery': 'Incubación (ovas y alevines: UTA, supervivencia, densidad, caudal)',
    'reports.column.lifeStage': 'Etapa de vida',
    'reports.column.arrivalDate': 'Fecha de llegada',
    'reports.column.eggsReceived': 'Ovas recibidas',
    'reports.column.tuaAtArrival': 'UTA a la llegada',
    'reports.column.tuaToDate': 'UTA a la fecha',
    'reports.column.temperatureDaysRecorded': 'Días con temperatura',
    'reports.column.hatchTargetTua': 'Eclosión objetivo (UTA)',
    'reports.column.hatchDate': 'Fecha de eclosión',
    'reports.column.expectedHatchDate': 'Eclosión esperada',
    'reports.column.firstFeedingTargetTua': 'Primera alimentación objetivo (UTA)',
    'reports.column.firstFeedingDate': 'Fecha de primera alimentación',
    'reports.column.expectedFirstFeedingDate': 'Primera alimentación esperada',
    'reports.column.eggDeaths': 'Ovas muertas',
    'reports.column.alevinDeaths': 'Alevines muertos',
    'reports.column.aliveNow': 'Vivos ahora',
    'reports.column.survivalToHatchPct': 'Supervivencia a eclosión (%)',
    'reports.column.survivalToFirstFeedingPct': 'Supervivencia a primera alimentación (%)',
    'reports.column.survivalToDatePct': 'Supervivencia a la fecha (%)',
    'reports.column.perLitre': 'Por litro',
    'reports.column.flowLpm': 'Caudal (L/min)',
    'reports.column.flowPerThousandLpm': 'Caudal por 1.000 (L/min)',
    'reports.column.eggDiameterMm': 'Diámetro de ova (mm)',
    'reports.column.eggsPerGram': 'Ovas por gramo',
    'reports.column.eggWeightMg': 'Peso de ova (mg, aprox.)',
    'reports.column.estimatedFryWeightG': 'Peso alevín a primera alimentación (g, aprox.)',
    'reports.column.seedSupplier': 'Proveedor',
    'reports.column.supplierLot': 'Lote del proveedor',
    'reports.column.supplierCertification': 'Certificación del proveedor',
    'reports.column.strain': 'Línea genética',
    'reports.column.stockTraits': 'Características',
    'reports.column.healthCertificateNo': 'Certificado sanitario',
    'reports.column.healthCertificateDate': 'Fecha del certificado',
    'reports.column.quarantine': 'Cuarentena',
    'reports.column.disinfectionProduct': 'Producto de desinfección',
    'reports.column.disinfectionPpm': 'Desinfección (ppm)',
    'reports.column.disinfectionMinutes': 'Desinfección (min)',
    'reports.column.disinfectionDate': 'Fecha de desinfección',
    'lots.history.current.location': 'Ubicacion actual',
    'lots.history.current.latestOrigin': 'Origen del ultimo traslado o movimiento',
    'lots.history.current.latestOriginValue': '{eventType} desde {origin} el {timestamp}',
    'lots.history.current.timeline': 'Cronologia de movimientos (mas recientes primero)',
    'lots.history.current.timelineStep': 'Paso {step}: {entry}',
    'lots.history.current.recentChain': 'Cadena reciente de movimientos y traslados',
    'lots.history.current.recentChainValue': '{eventType} desde {origin} el {timestamp}',
    'lots.history.loading': 'Cargando historial...',
    'lots.history.empty': 'Todavía no se encontraron eventos del ledger para este lote.',
    'lots.history.error.loadFailed': 'No se pudo cargar el historial del lote.',
    'lots.history.eventType.create': 'Creación',
    'lots.history.eventType.update': 'Actualización',
    'lots.history.eventType.split': 'División',
    'lots.history.eventType.merge': 'Unión',
    'lots.history.eventType.move': 'Traslado',
    'lots.history.eventType.transfer': 'Transferencia',
    'lots.history.sourceLots': 'Lotes origen:',
    'lots.history.targetLots': 'Lotes destino:',
    'lots.history.location': 'Ubicación:',
    'lots.history.changes': 'Cambios:',
    'lots.history.notes': 'Notas:',
    'lots.history.field.lotKey': 'Clave de lote',
    'lots.history.field.stage': 'Estado del lote',
    'lots.history.field.facility': 'Instalación',
    'lots.history.field.productionUnit': 'Unidad de producción',
    'lots.history.field.species': 'Especie',
    'lots.history.field.biomassKg': 'Biomasa (kg)',
    'lots.story.button.show': 'Vista previa de historia',
    'lots.story.button.hide': 'Ocultar historia',
    'lots.story.title': 'Vista previa de historia del lote {lot}',
    'lots.story.subtitle': 'Vista previa generada por el servidor para la publicación PRIVATE. Guarda la vista previa actual como un artefacto borrador y luego publica ese borrador de forma privada cuando esté listo.',
    'lots.story.library.title': 'Biblioteca de historias de lote',
    'lots.story.library.subtitle': 'Revisa el artefacto borrador o publicado actual de cada familia de lotes dentro de este tenant.',
    'lots.story.library.refresh': 'Actualizar biblioteca',
    'lots.story.library.refreshing': 'Actualizando biblioteca...',
    'lots.story.library.loading': 'Cargando biblioteca de historias de lote...',
    'lots.story.library.empty': 'Todavía no se han creado artefactos internos de historia de lote.',
    'lots.story.library.openPreview': 'Abrir vista previa en vivo',
    'lots.story.library.item.version': 'Versión {version}',
    'lots.story.library.switcher.title': 'Selector de artefactos',
    'lots.story.library.switcher.subtitle': 'Mantén visible el artefacto interno actual del tenant y cambia de registro solo cuando necesites otra historia fuente.',
    'lots.story.library.switcher.open': 'Cambiar artefacto',
    'lots.story.library.switcher.close': 'Cerrar selector',
    'lots.story.library.switcher.field': 'Elegir otro artefacto',
    'lots.story.library.switcher.help': 'Seleccionar otro artefacto cambia el panel de detalle de inmediato sin reabrir toda la biblioteca lateral.',
    'lots.story.library.detail.empty': 'Selecciona un artefacto de historia de lote para revisar los detalles de su versión actual.',
    'lots.story.library.detail.version': 'Versión actual {version}',
    'lots.story.library.detail.currentVersionStatus': 'Estado de la versión actual',
    'lots.story.library.detail.visibility': 'Visibilidad',
    'lots.story.library.detail.publishedAt': 'Publicado el',
    'lots.story.library.detail.readiness': 'Preparación para publicar',
    'lots.story.library.detail.artifactContextTitle': 'Contexto del artefacto',
    'lots.story.library.detail.artifactContextSubtitle': 'Las comprobaciones de publicación privada quedan aquí cuando necesites revisar el contexto del lado origen.',
    'lots.story.library.detail.editorialNotesTitle': 'Notas editoriales',
    'lots.story.library.detail.editorialNotesSubtitle': 'Ábrelo solo cuando necesites el resumen guardado y las notas internas del contexto original de publicación.',
    'lots.story.library.detail.groupSetupTitle': '1. Elegir grupo objetivo',
    'lots.story.library.detail.groupSetupSubtitle': 'Selecciona el grupo objetivo y guardalo antes de iniciar el flujo de revision del propietario.',
    'lots.story.library.detail.groupPromotionTitle': '2. Revisar y promover',
    'lots.story.library.detail.groupPromotionSubtitle': 'Registra la revision del propietario, la aprobacion, el release gate y la promocion final para el grupo guardado.',
    'lots.story.library.detail.groupDeliveryTitle': '3. Verificar entrega al receptor',
    'lots.story.library.detail.groupDeliverySubtitle': 'Despues de la promocion, verifica el snapshot de entrega del lado receptor para el grupo guardado.',
    'lots.story.library.detail.attribution': 'Atribución de actor',
    'lots.story.library.detail.attributionSubtitle': 'Abre esto cuando necesites la evidencia almacenada del actor y del tenant para eventos de borrador, publicación o revocación.',
    'lots.story.library.detail.draftedBy': 'Borrador guardado por',
    'lots.story.library.detail.publishedBy': 'Publicado por',
    'lots.story.library.detail.revokedBy': 'Revocado por',
    'lots.story.library.detail.presentationIdentity': 'Identidad: {value}',
    'lots.story.library.detail.tenantKey': 'Tenant: {value}',
    'lots.story.library.detail.tenantMemberId': 'ID de miembro: {value}',
    'lots.story.library.detail.userId': 'ID de usuario: {value}',
    'lots.story.library.detail.tenantMembershipId': 'ID de membresia: {value}',
    'lots.story.library.detail.actorId': 'Actor: {value}',
    'lots.story.library.detail.tokenId': 'Token: {value}',
    'lots.story.library.detail.recordedAt': 'Registrado: {value}',
    'lots.story.library.detail.historySubtitle': 'Abre las versiones guardadas anteriores solo cuando necesites comparar o recuperar contexto.',
    'lots.story.library.history.title': 'Historial de versiones',
    'lots.story.library.history.subtitle': 'Revisa cómo este artefacto pasó por estados de borrador, publicación, revocación y reemplazo.',
    'lots.story.library.history.current': 'Versión actual',
    'lots.story.library.history.currentDraft': 'Borrador actual',
    'lots.story.library.history.currentPublished': 'Publicado actual',
    'lots.story.library.history.createdAt': 'Creado el',
    'lots.story.library.history.openSnapshot': 'Abrir versión guardada',
    'lots.story.library.history.snapshotOpen': 'Versión guardada abierta',
    'lots.story.library.compare.title': 'Diferencia de versiones',
    'lots.story.library.compare.subtitle': 'Comparando la versión {left} con la versión {right}.',
    'lots.story.library.compare.currentColumn': 'Base v{version}',
    'lots.story.library.compare.comparedColumn': 'Comparada v{version}',
    'lots.story.library.compare.withCurrent': 'Comparar con la base',
    'lots.story.library.compare.comparing': 'Versión comparada',
    'lots.story.library.compare.setBase': 'Definir base',
    'lots.story.library.compare.baseSelected': 'Base seleccionada',
    'lots.story.library.compare.clear': 'Limpiar comparación',
    'lots.story.library.compare.empty': 'No hay diferencias visibles en los campos que este review rastrea actualmente.',
    'lots.story.library.compare.snapshotTitle': 'Inspección de la versión guardada',
    'lots.story.library.compare.snapshotSubtitle': 'Revisa lado a lado las proyecciones guardadas de las dos versiones seleccionadas.',
    'lots.story.library.compare.snapshotBase': 'Versión guardada base v{version}',
    'lots.story.library.compare.snapshotTarget': 'Versión guardada comparada v{version}',
    'lots.story.library.status.draft': 'Borrador',
    'lots.story.library.status.published': 'Publicado',
    'lots.story.library.status.revoked': 'Revocado',
    'lots.story.library.status.archived': 'Archivado',
    'lots.story.library.versionStatus.draft': 'Borrador',
    'lots.story.library.versionStatus.published': 'Publicado',
    'lots.story.library.versionStatus.superseded': 'Reemplazado',
    'lots.story.library.versionStatus.revoked': 'Revocado',
    'lots.story.library.visibility.private': 'Privado',
    'lots.story.library.visibility.group': 'Grupo',
    'lots.story.library.error.loadFailed': 'No se pudo cargar la biblioteca de historias de lote.',
    'lots.story.library.error.detailFailed': 'No se pudo cargar el artefacto de historia de lote seleccionado.',
    'lots.story.draft.title': 'Artefacto borrador',
    'lots.story.draft.subtitle': 'Guarda esta vista previa como un artefacto borrador interno del tenant con metadatos editoriales.',
    'lots.story.draft.readonly': 'Tu rol actual puede previsualizar historias de lote, pero no puede guardar artefactos borrador.',
    'lots.story.draft.field.title': 'Título del borrador',
    'lots.story.draft.field.summary': 'Resumen',
    'lots.story.draft.field.notes': 'Notas del publicador',
    'lots.story.draft.placeholder.title': 'Ejemplo: Historia del lote de tilapia para revisión interna',
    'lots.story.draft.placeholder.summary': 'Resumen interno breve para revisores',
    'lots.story.draft.placeholder.notes': 'Notas, advertencias e interpretación para este borrador',
    'lots.story.draft.defaultTitle': 'Historia del lote {lot}',
    'lots.story.draft.saveButton': 'Guardar borrador',
    'lots.story.draft.saving': 'Guardando borrador...',
    'lots.story.draft.saved': 'Borrador guardado',
    'lots.story.draft.savedVersion': 'La versión {version} ahora es el borrador actual.',
    'lots.story.draft.savedFamily': 'Familia de lotes: {lot}',
    'lots.story.draft.savedArtifact': 'ID interno del artefacto: {artifactId}',
    'lots.story.draft.error.noPreview': 'Carga primero una vista previa de historia antes de guardar un borrador.',
    'lots.story.draft.error.titleRequired': 'Ingresa un título de borrador antes de guardar.',
    'lots.story.draft.error.saveFailed': 'No se pudo guardar el borrador de historia del lote.',
    'lots.story.preflight.title': 'Contexto de escritura privada',
    'lots.story.preflight.subtitle': 'La publicación PRIVATE sigue quedándose dentro de este tenant. Esta verificación previa resuelve el perfil actual, el rol del tenant y el contexto de grupo antes de ejecutar guardar borrador o publicar.',
    'lots.story.preflight.loading': 'Comprobando el contexto de escritura privada...',
    'lots.story.preflight.identity': 'Identidad de presentación',
    'lots.story.preflight.tenantRole': 'Rol resuelto del tenant',
    'lots.story.preflight.activeGroups': 'Grupos activos',
    'lots.story.preflight.partnerOrganizations': 'Organizaciones asociadas',
    'lots.story.preflight.none': 'Ninguna',
    'lots.story.preflight.status.allowed': 'Escritura privada permitida',
    'lots.story.preflight.status.denied': 'La escritura privada no está permitida para esta membresía del tenant.',
    'lots.story.preflight.error.loadFailed': 'No se pudo cargar el contexto de escritura privada.',
    'lots.story.preflight.error.denied': 'Las acciones privadas de borrador y publicación requieren una membresía contributor, editor o admin en el tenant actual.',
    'lots.story.groupPreflight.title': 'Verificación previa de lectura GROUP',
    'lots.story.groupPreflight.subtitle': 'Esto todavía no comparte nada. Resuelve la visibilidad actual del artefacto y el contexto elegible de grupos activos para que la vista detalle explique si la lectura GROUP podría ser posible después.',
    'lots.story.groupPreflight.loading': 'Comprobando la verificación previa de lectura GROUP...',
    'lots.story.groupPreflight.targetGroup': 'Grupo objetivo',
    'lots.story.groupPreflight.identity': 'Identidad de presentación',
    'lots.story.groupPreflight.tenantRole': 'Rol resuelto del tenant',
    'lots.story.groupPreflight.visibility': 'Visibilidad actual del artefacto',
    'lots.story.groupPreflight.eligibleGroups': 'Grupos activos elegibles',
    'lots.story.groupPreflight.partnerOrganizations': 'Organizaciones asociadas',
    'lots.story.groupPreflight.blockingReasons': 'Motivos de bloqueo',
    'lots.story.groupPreflight.noEligibleGroups': 'No hay grupos activos elegibles',
    'lots.story.groupPreflight.none': 'Ninguna',
    'lots.story.groupPreflight.status.allowed': 'La lectura GROUP sería permitida para el contexto de actor actual.',
    'lots.story.groupPreflight.status.denied': 'La lectura GROUP todavía no está permitida para el artefacto actual y el contexto de actor.',
    'lots.story.groupPreflight.reason.artifactNotPublished': 'La versión actual del artefacto todavía no está publicada.',
    'lots.story.groupPreflight.reason.artifactNotGroupVisible': 'La visibilidad actual del artefacto sigue siendo privada.',
    'lots.story.groupPreflight.reason.noActiveGroupContext': 'No hay contexto activo de grupo elegible para el actor actual.',
    'lots.story.groupPreflight.reason.noTargetGroupSelected': 'Selecciona un grupo objetivo antes de evaluar honestamente la lectura GROUP.',
    'lots.story.groupPreflight.reason.targetGroupNotEligible': 'El grupo seleccionado no es elegible para el contexto de actor actual.',
    'lots.story.groupPreflight.reason.targetGroupNotSaved': 'La visibilidad GROUP actual solo aplica al grupo objetivo guardado.',
    'lots.story.groupPreflight.error.loadFailed': 'No se pudo cargar la verificación previa de lectura GROUP.',
    'lots.story.groupDelivery.title': 'Snapshot de entrega GROUP',
    'lots.story.groupDelivery.subtitle': 'Esto carga el snapshot publicado actual a través del limite de entrega para receptores solo para el grupo objetivo guardado.',
    'lots.story.groupDelivery.loading': 'Cargando snapshot de entrega GROUP...',
    'lots.story.groupDelivery.selectedGroup': 'Grupo seleccionado actual',
    'lots.story.groupDelivery.savedGroup': 'Grupo guardado para entrega',
    'lots.story.groupDelivery.savedMatch': 'Coincide con el grupo guardado para entrega',
    'lots.story.groupDelivery.identity': 'Identidad de presentacion',
    'lots.story.groupDelivery.tenantRole': 'Rol resuelto del tenant',
    'lots.story.groupDelivery.grantedGroup': 'Grupo concedido para entrega',
    'lots.story.groupDelivery.grantedGroupRole': 'Rol concedido en el grupo',
    'lots.story.groupDelivery.partnerOrganizations': 'Organizaciones asociadas',
    'lots.story.groupDelivery.blockingReasons': 'Motivos de bloqueo para entrega',
    'lots.story.groupDelivery.snapshotTitle': 'Titulo entregado',
    'lots.story.groupDelivery.summary': 'Resumen entregado',
    'lots.story.groupDelivery.notes': 'Notas entregadas',
    'lots.story.groupDelivery.publishedAt': 'Publicado para entrega el',
    'lots.story.groupDelivery.publishedBy': 'Publicado para entrega por',
    'lots.story.groupDelivery.status.allowed': 'El snapshot de entrega GROUP del lado receptor ya esta cargado para el grupo objetivo guardado.',
    'lots.story.groupDelivery.status.denied': 'El snapshot de entrega GROUP no esta disponible para el grupo seleccionado actual.',
    'lots.story.groupDelivery.reason.noTargetGroupSelected': 'Selecciona el grupo objetivo guardado antes de cargar el snapshot de entrega para receptores.',
    'lots.story.groupDelivery.reason.targetGroupNotSaved': 'Vuelve al grupo objetivo guardado para cargar honestamente el snapshot de entrega para receptores.',
    'lots.story.groupDelivery.reason.groupReadNotAllowed': 'La verificacion previa de lectura GROUP actual no esta permitida para el grupo objetivo guardado.',
    'lots.story.groupDelivery.error.loadFailed': 'No se pudo cargar el snapshot de entrega GROUP.',
    'lots.story.groupDelivery.receipt.title': 'Último recibo del receptor',
    'lots.story.groupDelivery.receipt.loading': 'Comprobando el ultimo recibo de vista externa...',
    'lots.story.groupDelivery.receipt.empty': 'Todavia no hay un recibo de entrega del lado receptor para el snapshot promovido actual.',
    'lots.story.groupDelivery.receipt.viewedBy': 'Ultima apertura por',
    'lots.story.groupDelivery.receipt.viewedAt': 'Ultima apertura en',
    'lots.story.groupDelivery.receipt.grantedGroupRole': 'Rol del grupo al abrir',
    'lots.story.groupDelivery.receipt.historyTitle': 'Aperturas anteriores del receptor',
    'lots.story.groupDelivery.receipt.loadMore': 'Cargar aperturas anteriores del receptor',
    'lots.story.groupDelivery.receipt.loadingMore': 'Cargando aperturas anteriores del receptor...',
    'lots.story.groupDelivery.receipt.error.loadFailed': 'No se pudo cargar el ultimo recibo del receptor.',
    'lots.story.groupShareShell.title': 'Shell de comparticion GROUP',
    'lots.story.groupShareShell.subtitle': 'Guarda ahora un grupo objetivo seleccionado, pero mantén deshabilitada la comparticion GROUP real en este slice.',
    'lots.story.groupShareShell.selectedTarget': 'Grupo objetivo seleccionado',
    'lots.story.groupShareShell.savedTarget': 'Grupo objetivo guardado',
    'lots.story.groupShareShell.notSaved': 'Todavia no guardado',
    'lots.story.groupShareShell.saveButton': 'Guardar grupo objetivo',
    'lots.story.groupShareShell.saving': 'Guardando grupo objetivo...',
    'lots.story.groupShareShell.saved': 'El grupo objetivo quedo guardado para la futura revision de comparticion GROUP.',
    'lots.story.groupShareShell.error.saveFailed': 'No se pudo guardar el grupo objetivo.',
    'lots.story.groupShareReview.title': 'Verificacion previa de revision de comparticion GROUP',
    'lots.story.groupShareReview.subtitle': 'Esto comprueba si el grupo seleccionado actual ya esta listo para la futura revision GROUP del tenant propietario, sin exponer todavia el artefacto.',
    'lots.story.groupShareReview.loading': 'Comprobando la preparacion para la revision de comparticion GROUP...',
    'lots.story.groupShareReview.selectedGroup': 'Grupo objetivo seleccionado',
    'lots.story.groupShareReview.savedGroup': 'Grupo objetivo guardado',
    'lots.story.groupShareReview.savedMatch': 'Coincide con la intencion guardada',
    'lots.story.groupShareReview.savedMatch.yes': 'Si',
    'lots.story.groupShareReview.savedMatch.no': 'No',
    'lots.story.groupShareReview.identity': 'Identidad de presentacion',
    'lots.story.groupShareReview.tenantRole': 'Rol resuelto del tenant',
    'lots.story.groupShareReview.visibility': 'Visibilidad actual del artefacto',
    'lots.story.groupShareReview.readiness': 'Preparacion publicada',
    'lots.story.groupShareReview.eligibleGroups': 'Grupos activos elegibles',
    'lots.story.groupShareReview.partnerOrganizations': 'Organizaciones asociadas',
    'lots.story.groupShareReview.blockingReasons': 'Motivos de bloqueo',
    'lots.story.groupShareReview.status.allowed': 'Este artefacto ya esta listo para la futura revision de comparticion GROUP.',
    'lots.story.groupShareReview.status.denied': 'La revision de comparticion GROUP todavia no esta lista para el grupo seleccionado actual.',
    'lots.story.groupShareReview.reviewButton': 'Registrar revision del tenant propietario',
    'lots.story.groupShareReview.reviewing': 'Registrando revision...',
    'lots.story.groupShareReview.reviewedButton': 'Revision registrada',
    'lots.story.groupShareReview.reviewRecorded': 'La revision del tenant propietario quedo registrada para el grupo objetivo guardado actual.',
    'lots.story.groupShareReview.reviewedAt': 'Revision registrada en',
    'lots.story.groupShareReview.reviewedBy': 'Revision registrada por',
    'lots.story.groupShareReview.approvalReadiness': 'Preparacion para aprobacion',
    'lots.story.groupShareReview.approvalBlockingReasons': 'Motivos de bloqueo para aprobacion',
    'lots.story.groupShareReview.approvalStatus.allowed': 'Este artefacto ya esta listo para una aprobacion GROUP del tenant propietario.',
    'lots.story.groupShareReview.approvalStatus.denied': 'La aprobacion de comparticion GROUP todavia no esta lista para el grupo seleccionado actual.',
    'lots.story.groupShareReview.approvalButton': 'Registrar aprobacion del tenant propietario',
    'lots.story.groupShareReview.approving': 'Registrando aprobacion...',
    'lots.story.groupShareReview.approvedButton': 'Aprobacion registrada',
    'lots.story.groupShareReview.approvalRecorded': 'La aprobacion del tenant propietario quedo registrada para el grupo objetivo guardado actual.',
    'lots.story.groupShareReview.approvedAt': 'Aprobacion registrada en',
    'lots.story.groupShareReview.approvedBy': 'Aprobacion registrada por',
    'lots.story.groupShareReview.releaseGateReadiness': 'Preparacion para release gate',
    'lots.story.groupShareReview.releaseGateBlockingReasons': 'Motivos de bloqueo para release gate',
    'lots.story.groupShareReview.releaseGateStatus.allowed': 'Este artefacto ya esta listo para un release gate GROUP del tenant propietario.',
    'lots.story.groupShareReview.releaseGateStatus.denied': 'El release gate GROUP todavia no esta listo para el grupo seleccionado actual.',
    'lots.story.groupShareReview.releaseGateButton': 'Registrar release gate GROUP',
    'lots.story.groupShareReview.releaseGating': 'Registrando release gate...',
    'lots.story.groupShareReview.releaseGatedButton': 'Release gate registrado',
    'lots.story.groupShareReview.releaseGateRecorded': 'El release gate GROUP quedo registrado para el grupo objetivo guardado actual.',
    'lots.story.groupShareReview.releaseGatedAt': 'Release gate registrado en',
    'lots.story.groupShareReview.releaseGatedBy': 'Release gate registrado por',
    'lots.story.groupShareReview.promotionReadiness': 'Preparacion para promover a GROUP',
    'lots.story.groupShareReview.promotionBlockingReasons': 'Motivos de bloqueo para promover a GROUP',
    'lots.story.groupShareReview.promotionStatus.allowed': 'Este artefacto ya esta listo para promoverse a GROUP para el grupo objetivo guardado.',
    'lots.story.groupShareReview.promotionStatus.denied': 'Promover a GROUP todavia no esta listo para el grupo seleccionado actual.',
    'lots.story.groupShareReview.promotionStatus.promoted': 'Este artefacto ya fue promovido a GROUP para el grupo objetivo guardado.',
    'lots.story.groupShareReview.promoteButton': 'Promover a GROUP',
    'lots.story.groupShareReview.promoting': 'Promoviendo a GROUP...',
    'lots.story.groupShareReview.promotedButton': 'Promovido a GROUP',
    'lots.story.groupShareReview.promoted': 'El artefacto fue promovido a GROUP para el grupo objetivo guardado actual.',
    'lots.story.groupShareReview.promotedAt': 'Promovido en',
    'lots.story.groupShareReview.promotedBy': 'Promovido por',
    'lots.story.groupShareReview.reason.artifactNotPublished': 'Publica este artefacto en privado antes de iniciar honestamente la futura revision GROUP.',
    'lots.story.groupShareReview.reason.artifactReadinessBlocked': 'La preparacion publicada actual esta bloqueada, asi que la futura revision GROUP debe seguir cerrada.',
    'lots.story.groupShareReview.reason.noActiveGroupContext': 'No hay contexto activo de grupo elegible para el actor actual.',
    'lots.story.groupShareReview.reason.noTargetGroupSelected': 'Selecciona un grupo objetivo antes de evaluar honestamente la revision de comparticion GROUP.',
    'lots.story.groupShareReview.reason.targetGroupNotEligible': 'El grupo seleccionado no es elegible para el contexto de actor actual.',
    'lots.story.groupShareReview.reason.targetGroupNotSaved': 'Guarda el grupo objetivo seleccionado antes de solicitar honestamente la futura revision GROUP.',
    'lots.story.groupShareReview.approvalReason.reviewNotRecorded': 'Registra primero la revision del tenant propietario antes de registrar honestamente la futura aprobacion GROUP.',
    'lots.story.groupShareReview.releaseGateReason.approvalNotRecorded': 'Registra primero la aprobacion del tenant propietario antes de registrar honestamente el futuro release gate GROUP.',
    'lots.story.groupShareReview.promotionReason.releaseGateNotRecorded': 'Registra primero el release gate GROUP del tenant propietario antes de promover honestamente este artefacto a GROUP.',
    'lots.story.groupShareReview.promotionReason.alreadyGroupVisible': 'Este artefacto ya fue promovido a GROUP para el grupo objetivo guardado.',
    'lots.story.groupShareReview.error.loadFailed': 'No se pudo cargar la verificacion previa de revision de comparticion GROUP.',
    'lots.story.groupShareReview.error.recordFailed': 'No se pudo registrar la revision del tenant propietario.',
    'lots.story.groupShareReview.error.approvalRecordFailed': 'No se pudo registrar la aprobacion del tenant propietario.',
    'lots.story.groupShareReview.error.releaseGateRecordFailed': 'No se pudo registrar el release gate GROUP.',
    'lots.story.groupShareReview.error.promoteFailed': 'No se pudo promover el artefacto a GROUP.',
    'lots.story.snapshot.title': 'Versión guardada histórica {version}',
    'lots.story.snapshot.readonly': 'Esta vista previa muestra la versión guardada exacta registrada en este punto del historial de versiones. Guardar borrador y publicar en privado permanecen deshabilitados aquí; usa Abrir vista previa en vivo para trabajar desde la proyección actual del servidor.',
    'lots.story.publish.button': 'Publicar en privado',
    'lots.story.publish.publishing': 'Publicando...',
    'lots.story.publish.published': 'Publicado en privado',
    'lots.story.publish.publishedVersion': 'La versión {version} ahora es el artefacto privado publicado actual.',
    'lots.story.publish.error.noDraft': 'Guarda un borrador antes de publicarlo en privado.',
    'lots.story.publish.error.failed': 'No se pudo publicar el borrador actual de historia del lote.',
    'lots.story.revoke.button': 'Revocar publicación privada',
    'lots.story.revoke.revoking': 'Revocando...',
    'lots.story.revoke.revoked': 'Publicación privada revocada',
    'lots.story.revoke.revokedVersion': 'La versión {version} ya no es visible como el artefacto privado publicado actual.',
    'lots.story.revoke.error.noPublished': 'Selecciona un artefacto privado publicado actual antes de revocarlo.',
    'lots.story.revoke.error.failed': 'No se pudo revocar el artefacto privado publicado actual.',
    'lots.story.loading': 'Cargando vista previa de historia del lote...',
    'lots.story.empty': 'Todavía no hay una vista previa de historia disponible para esta familia de lotes.',
    'lots.story.error.loadFailed': 'No se pudo cargar la vista previa de historia del lote.',
    'lots.story.readiness.ready': 'Listo',
    'lots.story.readiness.warning': 'Advertencia',
    'lots.story.readiness.blocked': 'Bloqueado',
    'lots.story.readinessCue.title': 'Señal de preparación: {value}',
    'lots.story.readinessCue.strong': 'Fuerte',
    'lots.story.readinessCue.caution': 'Precaución',
    'lots.story.readinessCue.weak': 'Débil',
    'lots.story.readinessCue.reason.fully-ready': 'Todas las señales de preparación están limpias.',
    'lots.story.readinessCue.reason.has-blocking-readiness-reasons': 'Una o más verificaciones de preparación están bloqueando.',
    'lots.story.readinessCue.reason.pending-lineage-sync': 'La sincronización de linaje sigue pendiente.',
    'lots.story.readinessCue.reason.ambiguous-legacy-matches': 'Hay coincidencias históricas ambiguas por resolver.',
    'lots.story.readinessCue.reason.source-data-stale': 'Los datos de origen están desactualizados.',
    'lots.story.readinessCue.reason.has-warning-readiness-reasons': 'Una o más verificaciones de preparación son advertencias.',
    'lots.story.readinessCue.reason.unresolved-evidence': 'Algunas categorías de evidencia no están resueltas.',
    'lots.story.readinessCue.reason.source-freshness-unknown': 'La vigencia de la fuente es desconocida.',
    'lots.story.reason.warning': 'Advertencia',
    'lots.story.reason.block': 'Bloqueado',
    'lots.story.reasons.title': 'Chequeos de preparación para publicar',
    'lots.story.pendingSync.title': 'La sincronización de linaje sigue pendiente',
    'lots.story.pendingSync.message': 'Un movimiento, traslado, división o fusión de esta familia de lotes sigue en cola local. Deja que termine esa sincronización y luego actualiza esta vista previa antes de guardar o publicar.',
    'lots.story.crossFarmTrust.title': 'La confianza entre granjas sigue bloqueada',
    'lots.story.crossFarmTrust.message': 'Esta familia de lotes abarca varias granjas, pero el historial de traslados registrado todavía no explica a los lotes activos actuales. Revisa y reconcilia el linaje de traslado antes de guardar o publicar.',
    'lots.story.processingSiteRegistry.title': 'El sitio de procesamiento no está registrado',
    'lots.story.processingSiteRegistry.message': 'Esta familia de lotes apunta a un sitio de procesamiento que no está registrado para su granja actual. Registra ese sitio de procesamiento antes de guardar o publicar.',
    'lots.story.summary.generatedAt': 'Generado',
    'lots.story.summary.lineageRoot': 'ID de la familia de lotes',
    'lots.story.summary.lineageRootTechnicalHelp': 'ID interno de trazabilidad',
    'lots.story.summary.lineageRootTechnicalTitle': 'Identificador interno de esta familia de lotes. Uselo para comparar la misma familia entre exportaciones, tickets de soporte u otros tenants. El ID de familia se mantiene a traves de los eventos de division, fusion, movimiento y transferencia.',
    'lots.story.summary.sourceTenant': 'Tenant de origen',
    'lots.story.summary.thisTenant': 'Este tenant',
    'lots.story.summary.origin': 'Origen de la familia',
    'lots.story.summary.currentSite': 'Sitio actual',
    'lots.story.summary.noCurrentSite': 'El sitio actual no está resuelto',
    'lots.story.summary.species': 'Especie',
    'lots.story.summary.currentStage': 'Estado actual',
    'lots.story.summary.activeDescendantsList': 'Lotes relacionados activos',
    'lots.story.summary.activeDescendantsEmpty': 'Actualmente no hay lotes relacionados activos proyectados.',
    'lots.story.summary.activeDescendantsUnknownLocation': 'Ubicacion desconocida',
    'lots.story.summary.activeDescendantsByLocationCount': '{count} lotes activos',
    'lots.story.summary.activeDescendantsByLocationLotKeys': 'Lotes: {lotKeys}',
    'lots.story.lineageGraph.title': 'Grafo de linaje (division y fusion)',
    'lots.story.lineageGraph.empty': 'No hay relaciones de division o fusion disponibles para esta ventana de vista previa.',
    'lots.story.lineageGraph.childCount': '{count} enlaces hijo',
    'lots.story.lineageGraph.children': 'Hijos: {children}',
    'lots.story.metrics.title': 'Métricas de la vista previa',
    'lots.story.metrics.timelineEvents': 'Eventos de la línea de tiempo',
    'lots.story.metrics.feedLogs': 'Registros de alimento',
    'lots.story.metrics.waterLogs': 'Registros de agua',
    'lots.story.metrics.productionRecords': 'Registros de producción',
    'lots.story.metrics.currentBiomassKg': 'Biomasa actual (kg)',
    'lots.story.metrics.totalFeedKg': 'Alimento total: {value} kg',
    'lots.story.metrics.totalMortality': 'Mortalidad diaria total: {value}',
    'lots.story.metrics.disposition': 'Estado de los lotes relacionados',
    'lots.story.metrics.dispositionValue': '{active} activos, {inactive} inactivos, {harvested} cosechados, {other} otros',
    'lots.story.timeline.title': 'Vista previa de la línea de tiempo',
    'lots.story.timeline.empty': 'No hay eventos de ciclo de vida disponibles para esta ventana de vista previa.',
    'lots.story.timeline.filteredEmpty': 'Ningun evento de la linea de tiempo coincide con el filtro actual.',
    'lots.story.timeline.filter.label': 'Filtro de linea de tiempo',
    'lots.story.timeline.filter.all': 'Todos los eventos',
    'lots.story.timeline.filter.notesOnly': 'Solo notas',
    'lots.story.timeline.filter.relationshipOnly': 'Solo divisiones y fusiones',
    'lots.story.timeline.audit.totalEvents': 'Eventos totales',
    'lots.story.timeline.audit.notedEvents': 'Eventos con notas',
    'lots.story.timeline.audit.latestEventAt': 'Evento mas reciente',
    'lots.story.timeline.audit.latestNotedEventAt': 'Evento con nota mas reciente',
    'lots.story.timeline.audit.recentNotes': 'Notas recientes del operador',
    'lots.story.timeline.eventTypeBreakdown': 'Desglose por tipo de evento',
    'lots.story.timeline.eventTypeCount': '{eventType}: {count}',
    'lots.story.location.from': 'Desde:',
    'lots.story.location.to': 'Hacia:',

    'lots.table.lot': 'Lote',
    'lots.table.facility': 'Instalación',
    'lots.table.productionUnit': 'Unidad de producción',
    'lots.table.status': 'Estado del lote',
    'lots.table.species': 'Especie',
    'lots.table.stockingDate': 'Fecha de siembra',
    'lots.table.harvestDate': 'Fecha de cosecha',
    'lots.table.biomassKg': 'Biomasa (kg)',
    'lots.table.lineage': 'Linaje',
    'lots.table.actions': 'Acciones',
    'lots.table.sectionTitle': 'Lista de lotes',
    'lots.table.loading': 'Cargando lotes...',
    'lots.table.scope.allFacilities': 'Lotes: {count} · Instalaciones: {facilities} · Unidades de producción: {units}.',
    'lots.table.scope.facility': 'Lotes: {count} · Unidades de producción en esta instalación: {units}.',
    'lots.table.scope.productionUnit': 'Lotes en esta unidad de producción: {count}.',
    'lots.table.scope.processingSite': 'Lotes en este sitio de procesamiento: {count}.',
    'lots.table.empty.allFacilities': 'Aún no se encontraron lotes. Créalo con «Nuevo lote».',
    'lots.table.empty.facility': 'Aún no se encontraron lotes en esta instalación. Créalo con «Nuevo lote».',
    'lots.table.empty.productionUnit': 'Aún no se encontraron lotes en esta unidad de producción. Créalo con «Nuevo lote».',
    'lots.table.empty.processingSite': 'Aún no se encontraron lotes en este sitio de procesamiento. Transfiere uno aquí o selecciona otro sitio.',

    'lots.form.createTitle': 'Crear lote',
    'lots.form.editTitle': 'Editar lote',
    'lots.form.moveTitle': 'Trasladar lote',
    'lots.form.transferTitle': 'Trasladar lote',
    'lots.form.lotKeyLabel': 'Clave de lote',
    'lots.form.lotKeyPlaceholder': 'Ejemplo: LOT-123',
    'lots.form.facilityLabel': 'Instalación',
    'lots.form.facilityPlaceholder': 'Selecciona instalación',
    'lots.form.productionUnitLabel': 'Unidad de producción',
    'lots.form.productionUnitPlaceholder': 'Selecciona unidad',
    'lots.form.productionUnitOptionalPlaceholder': 'Sin unidad seleccionada',
    'lots.form.productionUnitOptionalHelp': 'Opcional para transferencias con destino de granja. Déjalo vacío para mantener el snapshot solo a nivel de granja.',
    'lots.form.processingSiteLabel': 'Sitio de procesamiento',
    'lots.form.processingSitePlaceholder': 'Selecciona sitio de procesamiento',
    'lots.form.processingSiteHelp': 'Aquí solo aparecen los sitios de procesamiento registrados para la granja seleccionada.',
    'lots.form.notice.selectUnit': 'Esta vista puede seguir mostrando toda la granja, pero cada lote todavía pertenece a una sola unidad de producción. Elige la unidad destino antes de guardar.',
    'lots.form.notice.move': 'Guardar registrará un movimiento hacia la ubicación seleccionada.',
    'lots.form.notice.transfer': 'Guardar registrará una transferencia hacia la granja y unidad de producción seleccionadas.',
    'lots.form.notice.transferFacility': 'Guardar registrará la instalación seleccionada como destino. La unidad de producción es opcional y solo se usa cuando quieres contexto adicional en el snapshot.',
    'lots.form.notice.transferProcessingSite': 'Guardar registrará una transferencia hacia la granja y el sitio de procesamiento registrado seleccionados.',
    'lots.form.location.current': 'Ubicación actual',
    'lots.form.location.target': 'Ubicación destino',
    'lots.form.location.pendingUnit': 'Selecciona unidad de producción',
    'lots.form.location.pendingFacilityAndUnit': 'Selecciona instalación y unidad de producción',
    'lots.form.location.pendingProcessingSite': 'Selecciona sitio de procesamiento',
    'lots.form.location.pendingFacilityAndProcessingSite': 'Selecciona instalación y sitio de procesamiento',
    'lots.form.location.facilityWithContext': '{facility} (destino de instalación; unidad de contexto: {unit})',
    'lots.form.location.facilityWithProcessingSite': '{facility} / {site}',
    'lots.form.transfer.guidance.selectFacility': 'Primero elige la instalación destino para continuar con esta transferencia.',
    'lots.form.transfer.guidance.selectUnit': 'Elige la unidad de producción destino en {facility} para completar esta transferencia.',
    'lots.form.transfer.guidance.selectSite': 'Elige el sitio de procesamiento registrado en {facility} para habilitar esta transferencia.',
    'lots.form.transfer.guidance.sameLocation': 'Esto todavía coincide con la ubicación actual del lote. Elige otro destino para mantener esto como una transferencia.',
    'lots.form.transfer.guidance.moveInstead': 'Destino dentro de {facility}: se registra como traslado entre unidades, con la fecha del traslado.',
    'lots.form.transfer.guidance.processingSiteSameFacility': 'Este sitio de procesamiento sigue dentro de {facility}. Por ahora las transferencias hacia sitios de procesamiento solo se admiten entre instalaciones distintas.',
    'lots.form.transfer.guidance.ready': 'El destino de la transferencia está listo: {facility} / {unit}.',
    'lots.form.transfer.guidance.readyFacility': 'El destino de la transferencia está listo: {facility} como instalación destino. La unidad de producción es opcional y quedará vacía a menos que elijas una.',
    'lots.form.transfer.guidance.readyProcessingSite': 'El destino de la transferencia está listo: {facility} / {site}.',
    'lots.form.transferDestinationTypeLabel': 'Modo de destino de la transferencia',
    'lots.form.transferDestinationType.productionUnit': 'Ubicación en unidad de producción',
    'lots.form.transferDestinationType.farm': 'Destino de granja',
    'lots.form.transferDestinationType.farmHelp': 'Usa esta opción cuando el lote deba llegar primero a la granja. La unidad de producción es opcional y solo se conserva cuando quieres contexto adicional en el snapshot.',
    'lots.form.transferDestinationType.processingSite': 'Destino en sitio de procesamiento',
    'lots.form.transferDestinationType.processingSiteHelp': 'Usa esta opción cuando el lote deba transferirse directamente a un sitio de procesamiento registrado en la granja destino.',
    'lots.form.processingPlantWriteGuard': 'Los contextos de planta de procesamiento actualmente solo admiten transferencia y revisión de lectura. Crear, editar y eliminar siguen siendo exclusivos de granja hasta que exista un flujo dedicado para planta.',
    'lots.form.processingPlantIntakeNote': 'Para la recepción en planta en MVP 2.0, crea o mantén el lote aguas arriba y usa Transfer para recibirlo en este sitio de procesamiento. La creación directa de lotes en planta queda para después del MVP.',
    'lots.form.destinationSearchLabel': 'Selector rápido de destino',
    'lots.form.destinationSearchPlaceholder': 'Busca granja, unidad de producción o sitio de procesamiento',
    'lots.form.destinationSearchSuggested': 'Destinos sugeridos',
    'lots.form.destinationSearchMatches': 'Destinos coincidentes',
    'lots.form.destinationSearchEmpty': 'No hay destinos que coincidan con esta búsqueda.',
    'lots.form.destinationContextUnit': 'Unidad de contexto: {unit}',
    'lots.form.stageLabel': 'Estado del lote',
    'lots.form.speciesLabel': 'Especie',
    'lots.form.optionalPlaceholder': 'Opcional',
    'lots.form.stockingDateLabel': 'Fecha de siembra',
    'lots.form.harvestDateLabel': 'Fecha de cosecha',
    'lots.form.biomassKgLabel': 'Biomasa (kg)',

    'lots.stage.active': 'Activo',
    'lots.stage.inactive': 'Inactivo',
    'lots.stage.harvested': 'Cosechado',
    'lots.stage.planned': 'Planificado',
    'lots.stage.dormant': 'Dormante',

    'lots.confirm.delete': '¿Eliminar lote "{lotKey}"?',
    'lots.confirm.deleteCta': 'Confirmar eliminar',
    'lots.error.unableToLoad': 'No se pudieron cargar los lotes. Intenta de nuevo más tarde.',
    'lots.error.readonlyCannotDelete': 'Acceso de solo lectura: este token no puede eliminar lotes.',
    'lots.error.couldNotDelete': 'No se pudo eliminar el lote.',
    'lots.error.lotNotFoundRefresh': 'Este lote no se encontró en el servidor. Actualiza los lotes para refrescar la lista.',
    'lots.error.readonlyCannotCreateOrEdit': 'Acceso de solo lectura: este token no puede crear ni editar lotes.',
    'lots.error.lotKeyRequired': 'Se requiere la clave de lote.',
    'lots.error.selectFacility': 'Selecciona una instalación.',
    'lots.error.selectProductionUnit': 'Selecciona una unidad de producción.',
    'lots.error.selectProcessingSite': 'Selecciona un sitio de procesamiento.',
    'lots.error.transferSameLocation': 'Elige un destino diferente antes de registrar esta transferencia.',
    'lots.error.transferProcessingSiteSameFacility': 'Elige un sitio de procesamiento en una instalación distinta antes de registrar esta transferencia.',
    'lots.error.biomassMustBeNumber': 'Biomasa (kg) debe ser un número.',
    'lots.error.unableToSave': 'No se pudo guardar.',

    'lots.status.splitSuccess': 'Se dividió el lote {source} en {targets}.',
    'lots.status.mergeSuccess': 'Se fusionaron {sources} en {target}.',
    'lots.status.deleted': 'Se eliminó el lote {lot}.',
    'lots.status.deletedLocal': 'Se eliminó el lote {lot} en este dispositivo. La sincronización con el servidor sigue pendiente.',
    'lots.status.deletedOffline': 'Se eliminó el lote {lot} en este dispositivo. Se sincronizará cuando vuelva la conexión.',
    'lots.status.deletedSynced': 'Se eliminó el lote {lot} y el cambio quedó sincronizado.',
    'lots.status.updated': 'Se actualizó el lote {lot}.',
    'lots.status.updatedLocal': 'Se guardaron cambios del lote {lot} en este dispositivo. La sincronización con el servidor sigue pendiente.',
    'lots.status.updatedOffline': 'Se guardaron cambios del lote {lot} en este dispositivo. Se sincronizarán cuando vuelva la conexión.',
    'lots.status.updatedSynced': 'Se actualizó el lote {lot} y el cambio quedó sincronizado.',
    'lots.status.created': 'Se creó el lote {lot}.',
    'lots.status.createdLocal': 'Se creó el lote {lot} en este dispositivo. La sincronización con el servidor sigue pendiente.',
    'lots.status.createdOffline': 'Se creó el lote {lot} en este dispositivo. Se sincronizará cuando vuelva la conexión.',
    'lots.status.createdSynced': 'Se creó el lote {lot} y el cambio quedó sincronizado.',
    'lots.status.refreshing': 'Actualizando lotes...',
    'lots.status.refreshed': 'Lotes actualizados desde el servidor.',
    'lots.status.refreshFailed': 'No se pudieron actualizar los lotes en este momento.',

    'lots.saving': 'Guardando…',
    'lots.button.refreshLots': 'Actualizar lotes',
    'lots.button.refreshLotsTooltip': 'Actualizar la lista de lotes desde el servidor para ver cambios hechos en otros dispositivos.',
    'lots.button.saveChanges': 'Guardar cambios',
    'lots.button.create': 'Crear lote',
    'lots.story.draft.currentArtifactStatus': 'Estado actual del artefacto',
    'lots.story.draft.revokePublishedHint': 'Este lote ya tiene un artefacto publicado. Puedes revocarlo desde aquí sin abrir el panel de detalle de la biblioteca.',
    'lots.button.move': 'Registrar traslado',
    'lots.button.transfer': 'Trasladar lote',
    'lots.newLot.button': 'Nuevo lote',
    'lots.newLot.hint': 'Crea un lote de peces o de ovas (registro de llegada de ovas).',
    'lots.newLot.title': 'Nuevo lote',
    'lots.newLot.question': '¿Peces u ovas?',
    'lots.newLot.fish': 'Peces',
    'lots.newLot.fishHelp': 'Alevines, juveniles o peces más grandes sembrados en una unidad.',
    'lots.newLot.eggs': 'Ovas',
    'lots.newLot.eggsHelp': 'Ovas embrionadas que llegan a la sala de incubación: registra la llegada (cantidad, UTA, origen, certificado sanitario, desinfección).',
    'lots.newLot.change': 'Cambiar',
    'lots.list.filterLabel': 'Estado del lote',
    'lots.list.filter.all': 'Todos',
    'lots.list.searchPlaceholder': 'Buscar lote, especie o unidad',
    'lots.list.emptyFilter': 'Ningún lote coincide con este estado o búsqueda.',
    'lots.list.showAll': 'Ver todos los lotes',
    'lots.actions.menu': 'Acciones',
    'lots.actions.harvest': 'Cosechar',
    'lots.actions.split': 'Dividir lote',
    'lots.actions.merge': 'Unir con otros lotes',
    'lots.detail.title': 'Lote {lot}',
    'lots.detail.tabsLabel': 'Secciones del lote',
    'lots.detail.tab.summary': 'Resumen',
    'lots.detail.tab.hatchery': 'Incubación',
    'lots.detail.tab.projection': 'Proyección',
    'lots.detail.tab.history': 'Historial',
    'lots.detail.tab.costs': 'Costos',
    'lots.detail.tab.traceability': 'Trazabilidad',
    'lots.detail.kind': 'Lote de',
    'lots.detail.openHatchery': 'Ver incubación (UTA, eclosión, supervivencia) →',
    'lots.detail.openProjection': 'Ver proyección (fecha de cosecha, biomasa, alimento) →',
    'lots.detail.lineageRoot': 'Lote de origen (raíz del linaje)',
    'lots.detail.parents': 'Vino de (lotes padre)',
    'lots.detail.children': 'Pasó a (lotes hijo)',
    'lots.detail.traceabilityHint': 'Cada creación, edición, movimiento, transferencia, división y unión de este lote, con fecha y notas, está en Historial.',
    'lots.detail.openHistory': 'Abrir Historial',

    // Lot costs (T3-B-03c) — sección de entrada manual en la pantalla de Lotes.
    'lots.costs.title': 'Costos',
    'lots.costs.subtitle': 'Registra costos de Genética, Salud y Mano de obra por lote. Los costos de alimento se derivan automáticamente de los eventos de alimento con un costo unitario configurado en Inventario.',
    'lots.costs.lotSelect': 'Lote',
    'lots.costs.noLotsInScope': 'No hay lotes en el filtro de instalación actual.',
    'lots.costs.addButton': 'Agregar costo',
    'lots.costs.empty': 'Aún no hay costos registrados para este lote.',
    'lots.costs.loading': 'Cargando costos…',
    'lots.costs.loadError': 'No se pudieron cargar los costos.',
    'lots.costs.saveError': 'No se pudo guardar este costo.',
    'lots.costs.saved': 'Costo guardado.',
    'lots.costs.deleted': 'Costo eliminado.',
    'lots.costs.deleteError': 'No se pudo eliminar este costo.',
    'lots.costs.deleteButton': 'Eliminar',
    'lots.costs.deleteHint': 'Eliminar este costo',
    'lots.costs.confirmDelete': 'Confirmar eliminación',
    'lots.costs.autoDerivedNote': 'auto-derivado de eventos de alimento',
    'lots.costs.totalLabel': 'Total para este lote:',
    'lots.costs.form.category': 'Categoría',
    'lots.costs.form.categoryOption.G': 'Genética (stock inicial)',
    'lots.costs.form.categoryOption.N': 'Nutrición (alimento)',
    'lots.costs.form.categoryOption.H': 'Salud',
    'lots.costs.form.categoryOption.L': 'Mano de obra',
    'lots.costs.form.amount': 'Monto',
    'lots.costs.form.currency': 'Moneda',
    'lots.costs.form.date': 'Fecha',
    'lots.costs.form.nature': 'Naturaleza',
    'lots.costs.form.natureOption.fixed': 'Fijo',
    'lots.costs.form.natureOption.variable': 'Variable',
    'lots.costs.form.classification': 'Clasificación',
    'lots.costs.form.classificationOption.direct': 'Directo (Costo de ventas)',
    'lots.costs.form.classificationOption.indirect': 'Indirecto (Gastos operativos)',
    'lots.costs.form.notes': 'Notas (opcional)',
    'lots.costs.form.save': 'Guardar costo',
    'lots.costs.form.saving': 'Guardando…',
    'lots.costs.form.cancel': 'Cancelar',
    'lots.costs.alertAmountRequired': 'El monto es obligatorio.',
    'lots.costs.alertAmountInvalid': 'El monto debe ser un número (0 o mayor).',
    'lots.costs.alertCurrencyInvalid': 'La moneda debe ser un código ISO de 3 letras.',
    'lots.costs.alertDateInvalid': 'La fecha es obligatoria.',
    'lots.costs.form.currencyMismatch': 'Este lote ya tiene eventos en {existingCurrencies}; ¿este debe ser en {draftCurrency}?',
    'lots.costs.form.currencyMismatchDismiss': 'Descartar',

  // Warehouse
  'warehouse.title': 'Inventario',
  'warehouse.subtitle': 'Registra existencias y deriva el consumo desde los eventos de Alimento cuando esté disponible.',
  'warehouse.contextFacility': 'Instalación',
  'warehouse.contextProductionUnit': 'Unidad de producción',
  'warehouse.contextProductionUnitOptional': 'Unidad de producción (opcional)',
  'warehouse.allUnits': 'Todas las unidades',
  'warehouse.selectFacility': 'Selecciona una instalación',
  'warehouse.selectFacilityFirst': 'Primero selecciona una instalación',
  'warehouse.loadingFacilities': 'Cargando granjas…',
  'warehouse.derivationWindowPrefix': 'Ventana de tasa diaria: últimos',
  'warehouse.derivationWindowSuffix': 'días de eventos de Alimento',
  'warehouse.derivationWindowFormula': 'Prom/día se deriva del consumo del tipo vinculado en esa ventana. Est. existencias resta el consumo desde la fecha de recepción registrada del ítem (cap {capDays} días).',
  'warehouse.usageErrorUnable': 'No se pudo derivar el consumo desde los registros de Alimento (los datos offline pueden no estar disponibles).',
  'warehouse.alertSelectFacilityFirst': 'Primero selecciona una instalación',
  'warehouse.alertItemNameRequired': 'El nombre del ítem es obligatorio',
  'warehouse.alertOnHandInvalid': 'Las existencias deben ser un número válido (0 o mayor)',
  'warehouse.alertReorderInvalid': 'El punto de reposición debe ser un número válido (0 o mayor)',
  'warehouse.alertUnitCostInvalid': 'El costo unitario debe ser un número válido (0 o mayor)',
  'warehouse.alertCurrencyInvalid': 'La moneda debe ser un código ISO de 3 letras (por ejemplo USD)',
  'inventory.form.unitCost': 'Costo unitario',
  'inventory.form.unitCostHelp': 'Por unidad; se usa para auto-costear eventos de alimento',
  'inventory.form.unitCostHelpChemical': 'Por unidad; se usa para el costo de los tratamientos (va al lote como Salud).',
  'inventory.form.unitCostHelpOther': 'Por unidad; costo de referencia del ítem.',
  'inventory.form.currency': 'Moneda',
  'warehouse.alertEditItemNotFound': 'No se encontró el ítem que estás editando',
  'warehouse.alertSaveFailed': 'No se pudo guardar el ítem de inventario en este momento.',
  'warehouse.alertDeleteFailed': 'No se pudo eliminar el ítem de inventario en este momento.',
    'warehouse.alertItemSavedLocal': 'El ítem de inventario se guardó en este dispositivo. La sincronización con el servidor sigue pendiente.',
    'warehouse.alertItemSavedOffline': 'El ítem de inventario se guardó en este dispositivo. Se sincronizará cuando vuelva la conexión.',
    'warehouse.alertItemSavedSynced': 'El ítem de inventario quedó guardado y sincronizado.',
    'warehouse.alertItemDeletedLocal': 'El ítem de inventario se eliminó en este dispositivo. La sincronización con el servidor sigue pendiente.',
    'warehouse.alertItemDeletedOffline': 'El ítem de inventario se eliminó en este dispositivo. Se sincronizará cuando vuelva la conexión.',
    'warehouse.alertItemDeletedSynced': 'El ítem de inventario quedó eliminado y sincronizado.',
  'warehouse.alertViewerCannotCreateTask': 'Tu rol no puede crear tareas.',
  'warehouse.alertReorderTaskAlreadyExists': 'Ya existe una tarea de reposición para este ítem.',
  'warehouse.alertTaskCreated': 'Tarea creada.',
  'warehouse.alertTaskCreateFailed': 'No se pudo crear la tarea en este momento.',
  'warehouse.sync.pending': 'Los cambios de inventario están en cola y pendientes de sincronización.',
  'warehouse.sync.offline': 'Los cambios de inventario están en cola local porque este dispositivo está sin conexión.',
  'warehouse.sync.blocked': '{count} cambio(s) de inventario están bloqueados.',
  'warehouse.sync.blockedWithReason': '{count} cambio(s) de inventario están bloqueados: {reason}',
  'warehouse.sync.retryAction': 'Reintentar sincronización',
  'warehouse.sync.retrying': 'Reintentando sincronización...',
  'warehouse.sync.refreshAction': 'Actualizar inventario',
  'warehouse.sync.retrySynced': 'Los cambios de inventario quedaron totalmente sincronizados.',
  'warehouse.sync.retryPending': 'Los cambios de inventario siguen en cola para sincronizarse.',
  'warehouse.sync.retryOffline': 'Los cambios de inventario se guardaron localmente y se sincronizarán cuando vuelva la conexión.',
  'warehouse.sync.retryResolvedMissing': 'La sincronización se completó tras omitir {count} cambio(s) de inventario faltantes.',
  'warehouse.sync.lastResult': 'Último resultado de sincronización: {result}',
  'warehouse.sync.lastAttempted': 'Último intento: {time}',
  'warehouse.sync.retryFailed': 'No se pudo reintentar la sincronización de inventario en este momento.',
  'warehouse.sync.refreshFailed': 'No se pudo actualizar el estado de sincronización de inventario en este momento.',
  'warehouse.confirmDelete': '¿Eliminar este ítem de la lista de inventario?',
  'warehouse.emptySelectFacility': 'Selecciona una instalación para ver sus ítems de inventario.',
  'warehouse.emptyNoItems': 'Aún no hay ítems para esta granja.',
  'warehouse.emptyNoItemsInTab': 'Aún no hay ítems en esta categoría.',
  'warehouse.button.receive': 'Recibir',
  'warehouse.receive.title': 'Recibir: {item}',
  'warehouse.receive.date': 'Fecha de ingreso',
  'warehouse.receive.quantity': 'Cantidad',
  'warehouse.receive.supplier': 'Proveedor',
  'warehouse.receive.lotNumber': 'N.º de lote',
  'warehouse.receive.lotNumberHelp': 'El lote del alimento (saco o guía). Se guarda en cada alimentación con este alimento (trazabilidad).',
  'warehouse.receive.stockHelp': 'La cantidad se suma al stock. El ingreso queda en el historial de abajo.',
  'warehouse.receive.save': 'Guardar ingreso',
  'warehouse.receive.summaryTitle': 'Ingreso al almacén de: {farm}',
  'warehouse.receive.summarySupplier': 'proveedor {supplier}',
  'warehouse.receive.summaryLot': 'lote {lot}',
  'warehouse.receive.confirm': 'Confirmar ingreso',
  'warehouse.receive.back': 'Volver',
  'warehouse.receive.history': 'Ingresos',
  'warehouse.receive.latest': 'Último ingreso {date}: {quantity} {unit}',
  'warehouse.receive.lotShort': 'lote {lot}',
  'warehouse.receive.error.date': 'Elige la fecha de ingreso.',
  'warehouse.receive.error.quantity': 'Ingresa una cantidad mayor que 0.',
  'warehouse.mix.prepare': 'Preparar mezcla',
  'warehouse.mix.title': 'Preparar mezcla',
  'warehouse.mix.editTitle': 'Editar mezcla',
  'warehouse.mix.help': 'Una mezcla es una receta de 2 o más alimentos (p. ej., una transición de dieta). Ahora no se mueve stock: cuando el equipo da la mezcla, cada alimento se registra y se descuenta según su porcentaje.',
  'warehouse.mix.name': 'Nombre de la mezcla',
  'warehouse.mix.namePlaceholder': 'p. ej., Transición 80/20',
  'warehouse.mix.feed': 'Alimento {n}',
  'warehouse.mix.chooseFeed': 'Elige un alimento',
  'warehouse.mix.addFeed': '+ Agregar alimento',
  'warehouse.mix.removeFeed': 'Quitar alimento',
  'warehouse.mix.total': 'Total: {total} %',
  'warehouse.mix.stockHelp': 'El stock de cada alimento se descuenta solo cuando se da la mezcla.',
  'warehouse.mix.save': 'Guardar mezcla',
  'warehouse.mix.badge': 'Mezcla:',
  'warehouse.mix.missingFeed': '(alimento eliminado)',
  'warehouse.mix.invalidHint': 'Receta no válida: no se ofrece en Crew Mode. Edítala.',
  'warehouse.mix.needTwoFeeds': 'Primero agrega al menos 2 alimentos al inventario.',
  'warehouse.mix.error.tooFew': 'Elige al menos 2 alimentos.',
  'warehouse.mix.error.duplicate': 'Cada alimento puede aparecer una sola vez.',
  'warehouse.mix.error.percent': 'Cada porcentaje debe ser mayor que 0 y menor que 100.',
  'warehouse.mix.error.sum': 'Los porcentajes deben sumar 100 %.',
  'warehouse.mix.error.unknownFeed': 'Elige un alimento en cada fila.',
  'warehouse.mix.error.nameTaken': 'Otro ítem ya usa este nombre.',
  'warehouse.table.item': 'Ítem',
  'warehouse.table.category': 'Categoría',
  'warehouse.table.onHand': 'Existencias',
  'warehouse.table.unitCost': 'Costo unitario',
  'warehouse.table.estimatedOnHand': 'Est. existencias',
  'warehouse.table.avgPerDay': 'Prom/día',
  'warehouse.table.avgPerDayTooltip': 'Prom/día = kg totales registrados para el tipo vinculado en los últimos {days} días ÷ {days}.',
  'warehouse.table.daysCover': 'Días cobertura',
  'warehouse.table.reorder': 'Reposición',
  'warehouse.table.actions': 'Acciones',
  'warehouse.linkedFeedTypeLabel': 'Tipo de alimento vinculado:',
  'warehouse.linkedFeedTypeUsageInWindow': '{totalKg} kg registrados en últimos {days}d',
  'warehouse.linkedFeedTypeNoUsageInWindow': 'sin consumo registrado en últimos {days}d',
  'warehouse.form.addTitle': 'Agregar ítem',
  'warehouse.form.editTitle': 'Editar ítem',
  'warehouse.field.name': 'Nombre',
  'warehouse.field.category': 'Categoría',
  'warehouse.field.unit': 'Unidad',
  'warehouse.field.onHand': 'Existencias',
  'warehouse.field.reorderPoint': 'Punto de reposición (opcional)',
  'warehouse.help.reorderPoint': 'Cantidad mínima: cuando las existencias lleguen a este número, es momento de reordenar.',
  'warehouse.reorderNow': 'Reordenar ahora',
  'warehouse.reorderNowTooltip': 'Existencias al nivel (o por debajo) del punto de reposición.',
  'warehouse.estimatedOnHandLabel': 'Est. existencias:',
  'warehouse.estimatedOnHandTooltip': 'Calculada desde {anchorDate} (fecha de recepción registrada) menos el consumo de eventos de Alimento desde esa fecha.',
  'warehouse.estimatedOnHandTooltipCapped': 'La fecha de recepción registrada es anterior a {capDays} días; la estimación solo resta el consumo desde {anchorDate} (límite de la ventana de consulta), por lo que puede sobrestimar las existencias reales.',
  'warehouse.field.feedTypeKey': 'Clave de tipo de alimento (opcional)',
  'warehouse.field.notes': 'Notas (opcional)',
  'warehouse.placeholder.itemName': 'Ej.: Alimento 45% proteína',
  'warehouse.placeholder.feedTypeKey': "Coincide con el 'feedType' del registro de Alimento (por defecto usa el Nombre)",
  'warehouse.help.feedTypeKey': 'Se usa para auto-derivar el consumo diario promedio en ítems de alimento.',
  'warehouse.help.feedTypeKeySuggestions': 'Sugerencias basadas en tipos vistos en los últimos {days} días.',
  'warehouse.button.createTask': 'Crear tarea',
  'warehouse.button.creatingTask': 'Creando…',
  'warehouse.button.edit': 'Editar',
  'warehouse.button.delete': 'Eliminar',
  'warehouse.button.cancel': 'Cancelar',
  'warehouse.button.saveChanges': 'Guardar cambios',
  'warehouse.button.addItem': 'Agregar ítem',
  'warehouse.section.inventory': 'Inventario',
  'warehouse.category.feed': 'Alimento',
  'warehouse.category.chemical': 'Químico',
  'warehouse.category.equipment': 'Equipo',
  'warehouse.category.other': 'Otro',

  'warehouse.taskCreateViewerBlockedTooltip': 'Los viewers no pueden crear tareas.',
  'warehouse.taskTitleReorder': 'Reordenar: {item}',
  'warehouse.taskDescriptionReorder': 'Reordenar {item}.\n\nExistencias: {onHand} {unit}\nPunto de reposición: {reorderPoint}{estimatedOnHand}\n\nNota: Las existencias estimadas se calculan a partir de la fecha de recepción registrada del ítem menos el consumo de eventos de Alimento desde esa fecha (cap {capDays} días).',
  // Pre-validation polish (#58/#60): keys that had no Spanish value fell back to English
  'app.title': 'Sunday app',
  'app.builtWith': 'Hecho con Vite + React',
  'sidebar.heading': 'Sunday app',
  'tasks.create.loggingFor': 'Registrando para',
  'tasks.create.changeContext': 'Cambiar contexto',
  'feed.aria.panels': 'Paneles',
  'feed.panel.log': 'Registrar',
  'feed.panel.analyze': 'Analizar',
  'home.selector.productionUnit.all': 'Todas las unidades',
  'lots.story.readiness.sourceFreshness.fresh': 'Actualizada',
  'lots.story.readiness.sourceFreshness.stale': 'Desactualizada',
  'lots.story.readiness.sourceFreshness.unknown': 'Desconocida',
  'lots.story.readinessMetadata.title': 'Metadatos de preparación',
  'lots.story.readinessMetadata.status': 'Estado de preparación',
  'lots.story.readinessMetadata.sourceFreshness': 'Actualidad de la fuente',
  'lots.story.readinessMetadata.pendingLineageSync': 'Sincronización de linaje pendiente',
  'lots.story.readinessMetadata.unresolvedEvidence': 'Categorías de evidencia sin resolver',
  'lots.story.readinessMetadata.ambiguousLegacyMatches': 'Coincidencias heredadas ambiguas',
  'lots.story.evidence.title': 'Resumen de evidencia',
  'lots.story.evidence.feedRefs': 'Referencias de alimento',
  'lots.story.evidence.waterRefs': 'Referencias de agua',
  'lots.story.evidence.productionRefs': 'Referencias de producción',
  'lots.story.evidence.reportSnapshotRefs': 'Referencias de reportes',
  'lots.story.evidence.dashboardSnapshotRefs': 'Referencias de panel',
  'lots.story.evidence.sourceLotRefs': 'Referencias de lotes de origen',
  'lots.story.evidence.sourceEventRefs': 'Referencias de eventos de origen',
  'lots.story.evidence.sourceFeedRecordRefs': 'Referencias de registros de alimento de origen',
  'lots.story.evidence.sourceWaterRecordRefs': 'Referencias de registros de agua de origen',
  'lots.story.evidence.sourceProductionRecordRefs': 'Referencias de registros de producción de origen',
  'lots.story.value.yes': 'Sí',
  'lots.story.value.no': 'No',
  'lots.sync.retrySynced': 'La sincronización de lotes está al día.',
  'lots.sync.retryOffline': 'Los cambios de lotes quedan solo en este dispositivo mientras esté sin conexión.',
  'lots.sync.retryPending': 'Los cambios de lotes siguen pendientes de sincronizar.',
  'lots.sync.blocked': '{count} cambio(s) de lotes requieren atención antes de sincronizar.',
  'lots.sync.blockedWithReason': '{count} cambio(s) de lotes requieren atención: {reason}',
  'lots.sync.retryResolvedMissing': 'El reintento omitió {count} cambio(s) de lotes faltantes y siguió sincronizando el resto.',
  'lots.sync.retryAction': 'Reintentar sincronización',
  'lots.sync.retrying': 'Reintentando sincronización...',
  'lots.sync.refreshAction': 'Actualizar lotes',
  'lots.sync.refreshing': 'Actualizando lotes...',
  'lots.sync.retryFailed': 'Falló el reintento de sincronización de lotes.',
  'lots.sync.refreshComplete': 'Lotes actualizados.',
  'lots.sync.refreshFailed': 'No se pudieron actualizar los lotes ahora.',
  'lots.sync.lastResult': 'Último resultado de sincronización: {result}',
  'lots.sync.lastAttempted': 'Último intento: {time}',
  'warehouse.alertReceivedOnRequired': 'La fecha de recepción es obligatoria',
  'warehouse.alertExpiresBeforeReceived': 'La fecha de vencimiento no puede ser anterior a la de recepción',
  'warehouse.field.receivedOn': 'Recibido el',
  'warehouse.field.expiresOn': 'Vence el',
  'warehouse.field.expiresOnOptional': 'Vence el (opcional)',
  'warehouse.help.expiresOn': 'Úsalo para fechas de vencimiento o de consumo preferente. Déjalo en blanco si no aplica.',
  'app.downloadLogs': 'Descargar registros',
  'app.newVersion.banner': 'Hay una nueva versión de la app — toca aquí para actualizar. Los registros guardados no se pierden.',
  'app.downloadDiagnostics': 'Descargar diagnóstico (soporte)',
  'app.downloadDiagnostics.hint': 'Archivo técnico para soporte; no contiene los datos de la granja.',
  'common.species': 'Especie',
  'common.selectPlaceholder': 'Selecciona {label}',
  'species.trout.label': 'Trucha arcoíris',
  'species.tilapia.label': 'Tilapia del Nilo',
  'species.salmon.label': 'Salmón del Atlántico',
  'species.shrimp.label': 'Camarón blanco del Pacífico',
  'species.trout.description': 'Preset de agua fría para salmónidos; incluye FCR y seguimiento de longitud.',
  'species.tilapia.description': 'Preset de agua cálida con controles de proteína del alimento y temperatura.',
  'species.salmon.description': 'Preset de jaulas marinas con registro de salinidad.',
  'species.shrimp.description': 'Preset de crustáceos (terminología PL) con énfasis en salinidad y temperatura.',
  'water.tempStatus.noData': 'Sin datos',
  'water.tempStatus.tooCold': 'Muy fría',
  'water.tempStatus.tooWarm': 'Muy cálida',
  'water.tempStatus.optimalRange': 'Rango óptimo',
  'water.tempStatus.optimalForSfr': 'Óptima para SFR',
  'mortalityManagement.species.trout.description': 'Usa la curva de mortalidad de trucha arcoíris.',
  'mortalityManagement.species.salmon.description': 'Usa la curva de mortalidad de salmón del Atlántico.',
  'mortalityManagement.species.tilapia.description': 'Usa la curva de mortalidad de tilapia.',
  'mortalityManagement.species.shrimp.description': 'Usa la curva de mortalidad de camarón blanco del Pacífico.',
  'activity.facility.saved': 'Instalación guardada',
  'activity.facility.updated': 'Instalación actualizada',
  'activity.facility.deleted': 'Instalación eliminada',
  'activity.productionUnit.saved': 'Unidad de producción guardada',
  'activity.productionUnit.updated': 'Unidad de producción actualizada',
  'activity.productionUnit.deleted': 'Unidad de producción eliminada',
  'activity.task.saved': 'Tarea guardada',
  'activity.task.updated': 'Tarea actualizada',
  'activity.task.deleted': 'Tarea eliminada',
  'activity.mortalityMatrix.saved': 'Matriz de mortalidad guardada',
  'activity.mortalityMatrix.updated': 'Matriz de mortalidad actualizada',
  'activity.mortalityMatrix.deleted': 'Matriz de mortalidad eliminada',
  'activity.sfrMatrix.saved': 'Matriz SFR guardada',
  'activity.sfrMatrix.updated': 'Matriz SFR actualizada',
  'activity.sfrMatrix.deleted': 'Matriz SFR eliminada',
  'activity.lot.saved': 'Lote guardado',
  'activity.lot.updated': 'Lote actualizado',
  'activity.lot.deleted': 'Lote eliminado',
  'activity.text.waterLogsUpdated': 'Registros de agua actualizados',
  'activity.text.waterLogDeleted': 'Registro de agua eliminado',
  'activity.text.productionRecordUpdated': 'Registro de producción actualizado',
  'activity.text.productionRecordsUpdated': 'Registros de producción actualizados',
  'activity.text.productionRecordDeleted': 'Registro de producción eliminado',
  'activity.text.productionTableMigrated': 'Tabla de producción migrada',
  'activity.text.taskCreated': 'Tarea creada',
  'activity.text.taskDeleted': 'Tarea eliminada',
  'activity.text.syncQueued': 'En cola para sincronizar',
  'activity.text.queuedRows': '{count} fila(s) en cola para sincronizar',
  'activity.text.migratedRows': '{count} fila(s) migradas del almacenamiento anterior a la base offline',
  // Pre-validation PR 2 (#58/#67)
  'reports.dataset.tasks': 'Tareas',
  'reports.dataset.inventory': 'Inventario',
  'reports.dataset.feed': 'Alimento',
  'reports.dataset.feedEvents': 'Eventos de alimento (real)',
  'reports.dataset.feedDailyTotals': 'Totales diarios de alimento (derivado)',
  'reports.dataset.productionDatatable': 'Tabla de producción',
  'reports.dataset.water': 'Agua',
  'reports.dataset.lots': 'Lotes',
  'reports.dataset.lotCostPerKg': 'Costo por kg (por lote)',
  'reports.dataset.weightSampleIndividual': 'Muestras individuales de peso/longitud (CV, K de Fulton)',
  'reports.dataset.lotGrowthPerformance': 'Crecimiento por lote (SGR, FCR planificado, SFR — semanal)',
  'reports.dataset.mortalityRecording': 'Registro de mortalidad (días registrados / sin registro — semanal)',
  'reports.dataset.mortalityByCause': 'Mortalidad por causa (semanal, por lote)',
  'reports.column.cause': 'Causa',
  'reports.column.causeCode': 'Código de causa',
  'reports.column.deaths': 'Muertos',
  'reports.column.weekDeaths': 'Muertos en la semana (todas las causas)',
  'reports.column.causeSharePct': '% de los muertos de la semana',
  'mortality.cause.none': 'Sin causa',
  'biomass.row.mortalityCauses': 'Causas: {causes}',
  'reports.column.daysInPeriod': 'Días del periodo',
  'reports.column.daysRecorded': 'Días con registro',
  'reports.column.daysNoMortality': 'Días sin mortalidad',
  'reports.column.daysNotChecked': 'Días no revisados',
  'reports.column.daysWithoutRecord': 'Días sin registro',
  'reports.dataset.lotProjection': 'Proyección de lotes (fecha de cosecha, biomasa, alimento hasta cosecha)',
  'reports.column.projectionStatus': 'Estado de la proyección',
  'reports.column.lastSamplingDate': 'Último muestreo',
  'reports.column.lastSamplingWeightG': 'Peso del último muestreo (g)',
  'reports.column.estimatedWeightTodayG': 'Peso estimado hoy (g)',
  'reports.column.weightIn30DaysG': 'Peso en 30 días (g)',
  'reports.column.targetWeightG': 'Peso objetivo (g)',
  'reports.column.daysToHarvest': 'Días a cosecha',
  'reports.column.biomassNowKg': 'Biomasa actual (kg)',
  'reports.column.stockAtHarvest': 'Stock a la cosecha',
  'reports.column.biomassAtHarvestKg': 'Biomasa a la cosecha (kg)',
  'reports.column.feedToHarvestKg': 'Alimento hasta cosecha (kg)',
  'reports.column.projectedFcr': 'FCR proyectado',
  'reports.column.tgc': 'TGC',
  'reports.column.tgcSource': 'Origen del TGC',
  'reports.column.meanTemperatureC': 'Temperatura media (°C)',
  'reports.column.mortalityRatePctPerDay': 'Mortalidad (%/día, días registrados)',
  'reports.column.mortalityDaysRecorded': 'Días con registro de mortalidad',
  'reports.column.mortalityWindowDays': 'Días del periodo de mortalidad',
  'reports.column.mortalityCompletenessPct': 'Completitud de mortalidad (%)',
  'reports.column.lowConfidence': 'Baja confianza',
  'reports.column.mixName': 'Mezcla',
  'reports.column.feedLotNumber': 'Lote de alimento',
  'reports.column.feedingResponse': 'Respuesta a la alimentación',
  'reports.column.biomassKg': 'Biomasa (kg)',
  'reports.column.biomassKgDerived': 'Biomasa (kg)',
  'reports.column.category': 'Categoría',
  'reports.column.completed': 'Completada',
  'reports.column.convertedCostPerKgMajor': 'Costo por kg convertido',
  'reports.column.convertedCurrency': 'Moneda convertida',
  'reports.column.convertedTotalCostsCents': 'Costos totales convertidos (centavos)',
  'reports.column.convertedTotalCostsMajor': 'Costos totales convertidos',
  'reports.column.costEventCount': 'N.º de eventos de costo',
  'reports.column.costG': 'Costos — Genética (G)',
  'reports.column.costH': 'Costos — Sanidad (H)',
  'reports.column.costL': 'Costos — Mano de obra (L)',
  'reports.column.costN': 'Costos — Nutrición/alimento (N)',
  'reports.column.costOther': 'Costos — Otros (I/M/A/F/R)',
  'reports.column.costPerKgMajor': 'Costo por kg',
  'reports.column.createdAt': 'Creado',
  'reports.column.currency': 'Moneda',
  'reports.column.currencyBreakdown': 'Desglose por moneda (MIXTA)',
  'reports.column.dailyMortality': 'Mortalidad diaria',
  'reports.column.date': 'Fecha',
  'reports.column.description': 'Descripción',
  'reports.column.dissolvedOxygen': 'Oxígeno disuelto',
  'reports.column.dissolvedOxygenSaturation': 'Saturación de OD',
  'reports.column.dueAt': 'Vence',
  'reports.column.eventCount': 'N.º de eventos',
  'reports.column.expectedFcrMax': 'FCR esperado máx.',
  'reports.column.expectedFcrMin': 'FCR esperado mín.',
  'reports.column.expectedFcrRangeLabel': 'Rango de FCR esperado',
  'reports.column.expiresOn': 'Vence el',
  'reports.column.farmId': 'ID de instalación',
  'reports.column.farmName': 'Instalación',
  'reports.column.fcr': 'FCR',
  'reports.column.fcrPlanned': 'FCR (planificado)',
  'reports.column.feedConversionRatio': 'Alimento ÷ kg cosechados',
  'reports.column.feedConversionRatioInFlight': 'Alimento a la fecha ÷ biomasa actual',
  'reports.column.feedConversionRatioInFlightBand': 'Banda de alimento ÷ biomasa actual',
  'reports.column.economicFcr': 'eFCR (alimento ÷ producción neta)',
  'reports.column.biologicalFcr': 'bFCR (alimento ÷ producción neta + peces muertos)',
  'reports.column.startBiomassKg': 'Biomasa al inicio (kg)',
  'reports.column.netProductionKg': 'Producción neta (kg)',
  'reports.column.deadBiomassKg': 'Biomasa de peces muertos (kg)',
  'reports.columnHelp.economicFcr': 'FCR económico: kg de alimento por cada kg producido. Producción neta = kg cosechados + biomasa al final − biomasa al inicio. Los peces muertos o perdidos cuentan como pérdida, por eso el eFCR sube con la mortalidad. Es el FCR que se usa para comparar ciclos y costos.',
  'reports.columnHelp.biologicalFcr': 'FCR biológico: lo que los peces convirtieron de verdad. Suma a la producción neta el peso que tenían los peces que murieron (muertos × peso promedio de ese día). Siempre es igual o menor que el eFCR; la diferencia muestra cuánto alimento se fue en mortalidad.',
  'reports.columnHelp.startBiomassKg': 'Si el reporte tiene fecha de inicio: la biomasa al cierre del día anterior. Si no, o si el lote empezó después: primer conteo × peso promedio de ese día.',
  'reports.columnHelp.netProductionKg': 'kg cosechados + biomasa al final − biomasa al inicio.',
  'reports.columnHelp.deadBiomassKg': 'Muertos del período × peso promedio del día en que murieron. Vacío si hubo muertes y el lote no tiene ningún muestreo.',
  'reports.columnHelp.feedConversionRatio': 'Alimento ÷ kg cosechados, sin restar la biomasa sembrada. Para un lote sembrado como juveniles queda más bajo que el eFCR.',
  'reports.columnHelp.feedConversionRatioInFlight': 'Alimento a la fecha ÷ biomasa actual, sin restar la biomasa sembrada. Indicador rápido; para comparar usa el eFCR.',
  'reports.column.feedEventCount': 'N.º de eventos de alimento',
  'reports.column.feedKg': 'Alimento (kg)',
  'reports.column.feedProteinPct': 'Proteína del alimento (%)',
  'reports.column.feedType': 'Tipo de alimento',
  'reports.column.feedTypes': 'Tipos de alimento',
  'reports.column.fishStock': 'Stock (solo conteos)',
  'reports.column.fishStockDerived': 'Stock',
  'reports.column.fxAsOf': 'Tipo de cambio al',
  'reports.column.fxConversionReason': 'Motivo de conversión',
  'reports.column.fxConversionStatus': 'Estado de conversión',
  'reports.column.fxRateAsOf': 'Fecha del tipo de cambio',
  'reports.column.fxRateSnapshotId': 'ID de instantánea del tipo de cambio',
  'reports.column.fxRateSourceId': 'ID de fuente del tipo de cambio',
  'reports.column.fxRateSourceVersion': 'Versión de fuente del tipo de cambio',
  'reports.column.fxRateValue': 'Tipo de cambio',
  'reports.column.fxRoundingPolicyVersion': 'Versión de política de redondeo',
  'reports.column.harvestDate': 'Fecha de cosecha',
  'reports.column.harvestEventCount': 'N.º de eventos de cosecha',
  'reports.column.health': 'Sanidad',
  'reports.column.healthDetail': 'Detalle de sanidad',
  'reports.column.id': 'ID',
  'reports.column.lastRecordedAt': 'Último registro',
  'reports.column.lengthReadingCount': 'Lecturas con longitud',
  'reports.column.lot': 'Lote',
  'reports.column.lotId': 'ID de lote',
  'reports.column.lotKey': 'Lote',
  'reports.column.lotOrigin': 'Lote (origen)',
  'reports.column.lotUnit': 'Lote · Unidad',
  'reports.column.manualDissolvedOxygen': 'OD manual',
  'reports.column.manualDissolvedOxygenSaturation': 'Saturación de OD manual',
  'reports.column.meanLengthMm': 'Longitud media (mm)',
  'reports.column.meanWeightGrams': 'Peso medio (g)',
  'reports.column.mortalityRatePct': 'Tasa de mortalidad (%)',
  'reports.column.name': 'Nombre',
  'reports.column.notes': 'Notas',
  'reports.column.onHand': 'Existencias',
  'reports.column.ph': 'pH',
  'reports.column.productionUnitId': 'ID de unidad de producción',
  'reports.column.productionUnitName': 'Unidad de producción',
  'reports.column.readingCount': 'Lecturas individuales',
  'reports.column.receivedOn': 'Recibido el',
  'reports.column.recordedAt': 'Registrado',
  'reports.column.reorderPoint': 'Punto de reposición',
  'reports.column.salinity': 'Salinidad',
  'reports.column.salinityPpt': 'Salinidad (ppt)',
  'reports.column.sfrPercent': 'SFR (%)',
  'reports.dataset.mortalityEvents': 'Registros de mortalidad (uno por registro)',
  'reports.dataset.deletedLots': 'Lotes eliminados (auditoría)',
  'reports.column.recordedAtLocal': 'Fecha y hora',
  'reports.column.recordKind': 'Registro',
  'reports.column.recordedBy': 'Registrado por',
  'reports.column.captureSourceLabel': 'Registrado en',
  'reports.column.lateEntry': 'Registrado tarde',
  'reports.column.createdAtLocal': 'Creado',
  'reports.column.deletedAtLocal': 'Eliminado el',
  'reports.column.deletedBy': 'Eliminado por',
  'reports.column.restored': 'Restaurado',
  'reports.column.restoredAtLocal': 'Restaurado el',
  'reports.column.restoredBy': 'Restaurado por',
  'reports.column.countRecords': 'Conteos',
  'reports.column.mortalityRecords': 'Registros de mortalidad',
  'reports.column.weightSamples': 'Muestreos de peso',
  'reports.column.feedRecords': 'Registros de alimento',
  'reports.column.waterRecords': 'Lecturas de agua',
  'reports.column.firstRecordLocal': 'Primer registro',
  'reports.column.lastRecordLocal': 'Último registro',
  'reports.columnHelp.deletedBy': 'Se guarda desde esta versión; las eliminaciones anteriores quedan en blanco.',
  'reports.mortalityEvents.kind.deaths': 'Muertes',
  'reports.mortalityEvents.kind.noMortality': 'Sin mortalidad',
  'reports.mortalityEvents.kind.notChecked': 'No revisado',
  'reports.mortalityEvents.source.phone': 'Teléfono',
  'reports.mortalityEvents.source.web': 'Web',
  'reports.mortalityEvents.lateEntry.yes': 'Sí',
  'reports.deletedLots.restored.yes': 'Sí',
  'reports.deletedLots.restored.no': 'No',
  'reports.stockView.title': 'Stock',
  'reports.stockView.recorded': 'Como se registró',
  'reports.stockView.reconciled': 'Reconciliado con conteos exactos',
  'reports.stockView.intro': 'Corrige en el reporte el stock de los días anteriores a un conteo exacto. Lo registrado no cambia.',
  'reports.stockView.howTo': '¿Cómo funciona? Ver ejemplo',
  'reports.stockView.example': 'El lote debía tener 10 000 peces y el conteo dio 9 600. Faltan 400 que nadie registró. Si el conteo anterior fue hace 20 días, Sunday quita 20 peces más cada día, hasta llegar a 400 el día del conteo.',
  'reports.stockView.useFor': 'Úsalo para: ver biomasa, FCR y % de mortalidad más reales en esas semanas.',
  'reports.stockView.noChange': 'No cambia: el SGR, que usa el peso promedio, ni ningún registro.',
  'reports.stockView.needs': 'Hace falta: un conteo exacto que difiera de lo esperado. El reparto llega hasta el conteo exacto anterior o el inicio del lote; en Lotes → Historial se puede elegir otra fecha.',
  'reports.stockView.none': 'Este reporte no tiene conteos con diferencia. Reconciliado se ve igual que Como se registró.',
  'reports.stockView.summary': 'Stock reconciliado · {counts} conteo(s) · {fish} peces repartidos',
  'reports.stockView.columnSuffix': '(reconciliado)',
  'reports.column.countDifference': 'Diferencia de conteo',
  'reports.column.countDifferencePct': 'Diferencia de conteo (%)',
  'reports.column.countDifferenceFrom': 'Diferencia repartida desde',
  'reports.columnHelp.countDifference': 'En el día de un conteo exacto: peces contados − peces esperados. Negativo = faltan peces que ninguna mortalidad, cosecha o traslado registrado explica.',
  'reports.columnHelp.countDifferenceFrom': 'Día desde el que «Stock reconciliado» reparte la diferencia: el conteo exacto anterior o el inicio del lote.',
  'reports.column.sgrClassicPercent': 'SGR clásico (100·ln, %/día)',
  'reports.column.sgrDays': 'Días entre muestreos',
  'reports.columnHelp.sgrPercent': 'Cuánto creció el peso promedio por día, en %. Ejemplo: de 2,5 g a 3,0 g en 7 días = 2,64 % por día. Se calcula con el peso promedio de este muestreo y del siguiente del lote, y los días reales entre ellos: SGR = 100 × (e^g − 1), g = (ln P2 − ln P1) ÷ días. Un conteo o la mortalidad no cambian el SGR.',
  'reports.columnHelp.sgrClassicPercent': 'El SGR como lo calculan muchas tablas de alimento y artículos: 100 × (ln P2 − ln P1) ÷ días. Sirve para comparar con ellas; queda un poco por debajo del SGR (2,60 frente a 2,64 en el ejemplo de 2,5 g a 3,0 g en 7 días).',
  'reports.columnHelp.sgrDays': 'Días entre el muestreo de esta semana y el siguiente muestreo del lote.',
  'reports.columnHelp.meanWeightGrams': 'Peso promedio del último muestreo de la semana.',
  'reports.column.sgrPercent': 'SGR (%/día)',
  'reports.column.sharePctG': '% — Genética',
  'reports.column.sharePctH': '% — Sanidad',
  'reports.column.sharePctL': '% — Mano de obra',
  'reports.column.sharePctN': '% — Nutrición/alimento',
  'reports.column.sharePctOther': '% — Otros',
  'reports.column.sourceKey': 'Clave de origen',
  'reports.column.harvestCount': 'Cosechado (peces)',
  'reports.column.avgLengthMm': 'Longitud media (mm)',
  'reports.column.mort': 'Tratamiento',
  'reports.column.meanFultonK': 'K de Fulton media',
  'reports.column.upVol': 'Notas',
  'reports.columnHelp.fishStockDerived': 'El conteo exacto el día que lo hay; los demás días, el calculado con la mortalidad, cosechas y traslados registrados.',
  'reports.columnGroup.produccion': 'Producción',
  'reports.columnGroup.alimento': 'Alimento',
  'reports.columnGroup.agua': 'Agua',
  'reports.columnGroup.costos': 'Costos',
  'reports.columnGroup.registros': 'Registros',
  'reports.columnPicker.available': 'Disponibles',
  'reports.columnPicker.chosen': 'En el reporte (arrastra o usa ↑ ↓)',
  'reports.columnPicker.search': 'Buscar columna…',
  'reports.columnPicker.emptyChosen': 'Marca columnas en la lista de la izquierda.',
  'reports.columnPicker.noMatch': 'Ninguna columna coincide.',
  'reports.columnPicker.moveUp': 'Subir {label}',
  'reports.columnPicker.moveDown': 'Bajar {label}',
  'reports.columnPicker.remove': 'Quitar {label}',
  'reports.columnPicker.legend': '# número · abc texto · 📅 fecha · 🕐 fecha y hora · 🧮 calculado',
  'reports.columnKind.number': 'Número',
  'reports.columnKind.text': 'Texto',
  'reports.columnKind.date': 'Fecha',
  'reports.columnKind.datetime': 'Fecha y hora',
  'reports.columnKind.calculated': 'Calculado',
  'reports.pager.showing': 'Mostrando {from}–{to} de {total}',
  'reports.pager.rows': 'Filas',
  'reports.pager.previous': 'Anterior',
  'reports.pager.next': 'Siguiente',
  'reports.value.species.trout': 'Trucha',
  'reports.value.species.tilapia': 'Tilapia',
  'reports.value.species.shrimp': 'Camarón',
  'reports.value.species.salmon': 'Salmón',
  'reports.value.band.below-range': 'Bajo el rango',
  'reports.value.band.in-range': 'En rango',
  'reports.value.band.above-range': 'Sobre el rango',
  'reports.value.band.unavailable': 'Sin datos',
  'reports.value.yesNo.yes': 'Sí',
  'reports.value.yesNo.no': 'No',
  'reports.value.yesNo.true': 'Sí',
  'reports.value.yesNo.false': 'No',
  'reports.value.stage.Active': 'Activo',
  'reports.value.stage.Inactive': 'Inactivo',
  'reports.value.stage.Harvested': 'Cosechado',
  'reports.value.stage.Planned': 'Planificado',
  'reports.value.stage.Dormant': 'En reposo',
  'reports.value.tgcSource.observed': 'Observado',
  'reports.value.tgcSource.office': 'Oficina',
  'reports.value.projectionStatus.ok': 'Lista',
  'reports.value.projectionStatus.noSampling': 'Sin muestreo',
  'reports.value.projectionStatus.noGrowthRate': 'Sin tasa de crecimiento',
  'reports.value.projectionStatus.noTemperature': 'Sin temperatura',
  'reports.value.projectionStatus.noStock': 'Sin stock',
  'reports.value.projectionStatus.hatcheryStage': 'En incubación',
  'lots.countDifferences.title': 'Diferencias de conteo',
  'lots.countDifferences.subtitle': 'Stock reconciliado reparte cada diferencia en los días anteriores al conteo. Lo registrado no cambia.',
  'lots.countDifferences.row': 'Conteo {date} · Diferencia {fish} peces',
  'lots.countDifferences.from': 'Se reparte desde',
  'lots.countDifferences.fromDefault': 'Por defecto: {date}',
  'lots.countDifferences.save': 'Guardar fecha',
  'lots.countDifferences.useDefault': 'Volver al valor por defecto',
  'lots.countDifferences.saved': 'Fecha guardada.',
  'lots.countDifferences.outOfRange': 'Elige una fecha entre {min} y {max}.',
  'lots.countDifferences.saveFailed': 'No se pudo guardar: {error}',
  'reports.column.species': 'Especie',
  'reports.column.speciesKey': 'Especie',
  'reports.column.stage': 'Etapa',
  'reports.column.stockingDate': 'Fecha de siembra',
  'reports.column.tags': 'Etiquetas',
  'reports.column.temperature': 'Temperatura',
  'reports.column.temperatureC': 'Temperatura (°C)',
  'reports.column.title': 'Título',
  'reports.column.totalCostsMajor': 'Costos totales',
  'reports.column.totalFeedKg': 'Alimento total (kg)',
  'reports.column.totalHarvestCount': 'Cosecha total (peces)',
  'reports.column.totalHarvestKg': 'Cosecha total (kg)',
  'reports.column.harvestKg': 'Cosechado (kg)',
  'reports.column.unit': 'Unidad',
  'reports.column.updatedAt': 'Actualizado',
  'reports.column.usageFeedType': 'Tipo de alimento de uso',
  'reports.column.week': 'Semana',
  'reports.column.weekDisplay': 'Semana (texto)',
  'reports.column.weight': 'Peso (g)',
  'reports.column.weightCvPercent': 'CV de peso (%)',
  'reports.help.filterHint': 'El filtro decide qué filas entran al reporte: instalaciones, unidades de producción, lotes y fechas. No cambia cómo se agrupan; eso es el desglose, que se elige en cada widget del Panel.',
  'dashboardNew.help.breakdownTitle': '¿Cómo agrupar? (desglose)',
  'dashboardNew.help.breakdownHint': 'El desglose decide cómo se reparten las filas del reporte: Filas (p. ej. fecha por semana) y Columnas (p. ej. una línea por Lote · Unidad). No quita filas; para limitar los datos, edita el filtro del reporte en Reportes.',
  'dashboardNew.help.reportFilter': 'Los datos (filtro) vienen de este reporte; se edita en Reportes.',
  'dashboardNew.help.rowField': 'Cada valor distinto es una fila de la tabla y un punto del gráfico (p. ej. Fecha agrupada por semana).',
  'dashboardNew.help.columnField': 'Separa cada fila por este campo; con una línea por columna, cada valor es una serie del gráfico. Para lotes usa "Lote · Unidad".',
  'dashboardNew.widgets.filterPrefix': 'Filtro',
  'dashboardNew.widgets.breakdownPrefix': 'Desglose',
  'dashboardNew.widgets.scopeAll': 'todos los datos',
  'dashboardNew.widgets.scopeFacilities': '{count} instalación(es)',
  'dashboardNew.widgets.scopeUnits': '{count} unidad(es)',
  'dashboardNew.widgets.scopeLots': '{count} lote(s)',
  'dashboardNew.widgets.scopeFrom': 'desde {date}',
  'dashboardNew.widgets.scopeTo': 'hasta {date}',
  'dashboardNew.widgets.mergedLotsWarning': '"{lot}" agrupa {count} lotes distintos ({units}). Para verlos por separado usa "Lote · Unidad".',
  'density.noVolume': 'La unidad no tiene volumen de agua: configúralo en Editar instalación → Unidades.',
  'density.overLimitTitle': 'Supera el límite de densidad para este peso y tipo de unidad (Configuración → Capacidad de carga).',
  'density.limitLabel': 'límite {limit}',
  'costs.facilityWide.option': 'Costos generales (sin lote)',
  'costs.facilityWide.totalLabel': 'Costos generales de la instalación (no asignados a lotes)',
  'costs.facilityWide.empty': 'Aún no hay costos generales (luz, sueldos, alquiler…).',
  'density.unitType.floatingCage': 'Jaula flotante',
  'density.unitType.circularTank': 'Tanque circular',
  'density.unitType.raceway': 'Raceway',
  'density.unitType.pond': 'Estanque',
  'density.unitType.incubator': 'Incubadora',
  'editFarm.productionUnits.type': 'Tipo',
  'editFarm.productionUnits.typeNone': '— sin tipo —',
  'editFarm.productionUnits.typeOther': 'Otro: {type}',
  'editFarm.density.title': 'Límites de densidad (kg/m³)',
  'editFarm.density.weightBand': 'Peso promedio',
  'editFarm.density.upTo': 'hasta',
  'editFarm.density.moreThan': 'más de {weight} g',
  'editFarm.density.allWeights': 'cualquier peso',
  'editFarm.density.addBand': '+ Agregar banda de peso',
  'editFarm.density.removeBand': 'Quitar',
  'editFarm.density.invalid': 'Usa números positivos; el peso de cada banda debe ser mayor que el de la banda anterior.',
  'editFarm.density.help': 'La densidad máxima de la granja por peso promedio y tipo de unidad. Vacío = sin límite. Alimento (toda la instalación) y Biomasa muestran la densidad en rojo cuando lo supera. Los lotes en ovas o saco vitelino no se controlan.',
  'editFarm.details.currency.label': 'Moneda',
  'editFarm.details.currency.none': '— sin definir (USD) —',
  'editFarm.details.currency.PEN': 'PEN — Sol peruano',
  'editFarm.details.currency.USD': 'USD — Dólar estadounidense',
  'editFarm.details.currency.help': 'Moneda por defecto para costos nuevos y precios de Inventario. Los registros ya guardados mantienen su moneda.',
  'feed.view.ariaLabel': 'Vista de alimento',
  'feed.view.farm': 'Toda la instalación',
  'feed.view.unit': 'Por unidad',
  'feed.farmTable.intro': 'Una fila por unidad: la ración recomendada (SFR × biomasa) junto al plan de la unidad y lo dado ayer. El personal da el plan ("Dado según plan").',
  'feed.farmTable.loading': 'Cargando la instalación…',
  'feed.farmTable.col.unit': 'Unidad',
  'feed.farmTable.col.lot': 'Lote',
  'feed.farmTable.col.fish': 'Peces / ovas',
  'feed.farmTable.col.weight': 'Peso prom. (g)',
  'feed.farmTable.col.biomass': 'Biomasa (kg)',
  'feed.farmTable.col.temperature': 'T° (°C)',
  'feed.farmTable.measuredIn': '({unit})',
  'feed.farmTable.col.sfr': 'SFR %',
  'feed.farmTable.col.recommended': 'Recomendado kg/día',
  'feed.farmTable.col.plan': 'Plan kg/día',
  'feed.farmTable.col.fedYesterday': 'Dado ayer (kg)',
  'feed.farmTable.col.fedToday': 'Dado hoy (kg)',
  'feed.farmTable.eggsDash': '— ovas',
  'feed.farmTable.eggsNoRation': 'Los lotes en ovas o saco vitelino no tienen ración.',
  'feed.farmTable.feedings': '{count} tomas',
  'feed.farmTable.col.density': 'kg/m³',
  'feed.farmTable.col.flowPerKg': 'L/min/kg',
  'feed.farmTable.noLot': 'Sin lote',
  'feed.farmTable.eggs': 'ovas',
  'feed.farmTable.total': 'Total',
  'feed.farmTable.useRecommended': 'Usar recomendado como plan',
  'feed.farmTable.useRecommendedLot': '{lot}: usar recomendado como plan en sus {count} unidades',
  'feed.farmTable.noPlan': 'Sin plan',
  'feed.farmTable.noPlanHelp': 'Primero define el plan de alimento de la unidad (alimento y tomas/día) en Editar instalación → Unidades.',
  'feed.farmTable.planUpdated': 'Plan actualizado: {changes}. El personal lo ve la próxima vez que abra el teléfono con conexión.',
  'feed.farmTable.planChange': '{unit} {kg} kg/día (antes {before})',
  'feed.farmTable.planAlreadyRecommended': 'El plan ya era el recomendado: no hubo cambios.',
  'feed.farmTable.planSaveError': 'No se pudo guardar el plan. Inténtalo de nuevo.',
  'feed.farmTable.help': 'Recomendado = SFR (Matriz SFR, según peso y la última temperatura) × biomasa. Los lotes en ovas o saco vitelino no tienen ración. La densidad se pone roja sobre el límite de la granja (Editar instalación → Cultivo); "—" = la unidad no tiene volumen.',
  'editFarm.plans.copy.button': 'Copiar a otras unidades del lote',
  'editFarm.plans.copy.title': 'Copiar alimento, tomas/día, muestreo y parámetros de agua a:',
  'editFarm.plans.copy.kg': 'Copiar también el mismo kg/día',
  'editFarm.plans.copy.help': 'Sin marcarlo, cada unidad mantiene su kg/día (una unidad sin plan toma el de esta). Para usar la ración recomendada de cada unidad: Alimento → Toda la instalación.',
  'editFarm.plans.copy.run': 'Copiar a {count} unidad(es)',
  'editFarm.plans.copy.done': 'Planes copiados a {count} unidad(es).',
  'editFarm.plans.point.label': 'Agua (T° y O2) medida en',
  'editFarm.plans.point.self': 'Esta unidad',
  'editFarm.plans.point.missing': 'una unidad que ya no existe',
  'editFarm.plans.point.help': 'Elige el estanque donde se mide el agua de esta unidad. Si hoy no tiene su propia lectura, Sunday usa la de ese estanque para avisar si se puede alimentar, calcular la ración y el oxígeno disponible, y sumar las UTA.',
  'editFarm.plans.copyRules.button': 'Copiar solo reglas y punto de medición…',
  'editFarm.plans.copyRules.title': 'Copiar "Cuándo no alimentar" ({rules}) y "Oxígeno (cálculo)" a:',
  'editFarm.plans.copyRules.all': 'Todas',
  'editFarm.plans.copyRules.none': 'Ninguna',
  'editFarm.plans.copyRules.point': 'Estas unidades usan el agua medida en {unit}',
  'editFarm.plans.copyRules.help': 'No cambia alimento, tomas, modo de registro, muestreo ni parámetros de agua.',
  'editFarm.plans.copyRules.done': 'Reglas copiadas a {count} unidad(es).',
  'lots.hatchery.costPerThousand': 'Costo por 1.000 alevines',
  'lots.hatchery.costPerThousandDetail': 'Costos de esta unidad {total} ÷ alevines vivos × 1.000 (sin costos generales de la instalación)',
  'lots.hatchery.costPerThousandNone': 'Aún no hay costos en este lote (Costos o la pestaña Costos del lote)',
  'lots.costs.group.option': '{lot} · todo el lote ({count} unidades)',
  'lots.costs.group.unitOption': '{lot} · solo {unit}',
  'lots.costs.group.formTitle': 'Costo para todo el lote {lot} ({count} unidades)',
  'lots.costs.group.splitByCount': 'Se reparte según las ovas / peces sembrados en cada unidad:',
  'lots.costs.group.splitEvenly': 'Se reparte en partes iguales (falta el conteo sembrado de alguna unidad):',
  'lots.costs.group.saved': 'Costo guardado y repartido en {count} unidades.',
  'lots.costs.group.splitInto': 'repartido en {count} unidades',
  'lots.costs.group.totalLabel': 'Total del lote ({count} unidades)',
  'lots.costs.group.shareNote': 'Parte de un costo de todo el lote ({total}). Edítalo o elimínalo en «todo el lote».',
  'lots.costs.edit.button': 'Editar',
  'lots.costs.edit.title': 'Editar costo',
  'lots.costs.edit.groupTitle': 'Editar costo de todo el lote ({count} unidades) — el total se vuelve a repartir',
  'lots.costs.edit.categoryLocked': 'La categoría no se puede cambiar; elimina el costo y regístralo de nuevo.',
  'lots.costs.edit.saved': 'Costo actualizado.',
  'lots.stockUnits.registerCostEggs': 'Registrar costo de las ovas →',
  'lots.stockUnits.registerCostFish': 'Registrar costo de la semilla →',
  'lots.hatchery.costPerThousandWholeLot': 'Todo el lote ({count} incubadoras)',
  'lots.hatchery.costPerThousandThisUnit': 'Esta incubadora',
  'reports.facilityCosts.note': 'sumados para la instalación y fechas de este reporte, sin asignar a lotes (no entran en ningún costo por kg).',
  'lots.detail.tab.treatments': 'Tratamientos',
  'lots.actions.treatment': 'Tratamiento…',
  'lots.treatments.method.bath': 'Baño',
  'lots.treatments.method.feed': 'En alimento',
  'lots.treatments.method.injection': 'Inyección',
  'lots.treatments.method.other': 'Otro',
  'lots.treatments.dialogTitle': 'Registrar tratamiento · {lot}',
  'lots.treatments.field.lots': 'Lotes / unidades',
  'lots.treatments.field.appliedAt': 'Fecha y hora',
  'lots.treatments.field.method': 'Tipo',
  'lots.treatments.field.product': 'Producto',
  'lots.treatments.field.productPick': '— elegir de Inventario (Químicos) —',
  'lots.treatments.field.productOption': '{name} · stock {onHand} {unit}',
  'lots.treatments.field.productOther': 'Otro (no está en Inventario)',
  'lots.treatments.field.productName': 'Nombre del producto',
  'lots.treatments.field.noChemicals': 'Aún no hay químicos en Inventario: agrégalos en Inventario → Químicos para descontar stock y costo desde ahí.',
  'lots.treatments.field.dose': 'Dosis / concentración',
  'lots.treatments.field.quantity': 'Cantidad usada por unidad',
  'lots.treatments.field.duration': 'Duración (min)',
  'lots.treatments.field.reason': 'Motivo',
  'lots.treatments.field.prescribedBy': 'Prescrito / autorizado por',
  'lots.treatments.field.withdrawalDays': 'Retiro (días)',
  'lots.treatments.field.notes': 'Notas',
  'lots.treatments.reason.fungus': 'Hongos',
  'lots.treatments.reason.parasites': 'Parásitos',
  'lots.treatments.reason.bacteria': 'Bacterias',
  'lots.treatments.reason.prevention': 'Prevención',
  'lots.treatments.totalQuantity': 'Total del stock: {total} {unit} ({count} unidades)',
  'lots.treatments.costPreview': 'Costo por unidad (Salud): {cost}',
  'lots.treatments.help': 'Se guarda en línea (oficina). La cantidad sale de Inventario y su costo va al lote como Salud.',
  'lots.treatments.error.lots': 'Marca al menos un lote.',
  'lots.treatments.error.date': 'Ingresa la fecha y hora.',
  'lots.treatments.error.product': 'Elige o escribe el producto.',
  'lots.treatments.error.number': 'Cantidad y duración deben ser números positivos.',
  'lots.treatments.error.reason': 'Escribe el motivo.',
  'lots.treatments.error.withdrawal': 'El retiro debe ser en días enteros (0 o más).',
  'lots.treatments.error.stock': 'No hay stock suficiente: quedan {onHand} {unit}.',
  'lots.treatments.error.partial': 'Guardado en {saved} de {total} lotes; revisa la lista y registra el resto de nuevo.',
  'lots.treatments.error.offline': 'Sin conexión: los tratamientos se guardan en línea. Inténtalo con señal.',
  'lots.treatments.error.save': 'No se pudo guardar el tratamiento. Inténtalo de nuevo.',
  'lots.treatments.loadError': 'No se pudieron cargar los tratamientos (necesitan conexión).',
  'lots.treatments.title': 'Tratamientos',
  'lots.treatments.add': 'Registrar tratamiento',
  'lots.treatments.empty': 'Sin tratamientos registrados.',
  'lots.treatments.deletedList': 'Eliminados ({count})',
  'lots.treatments.deleteReason': 'Motivo de la eliminación (queda en el registro)',
  'lots.treatments.row.dose': 'Dosis {dose}',
  'lots.treatments.row.quantity': '{quantity} {unit} usados',
  'lots.treatments.row.duration': '{minutes} min',
  'lots.treatments.row.reason': 'Motivo: {reason}',
  'lots.treatments.row.prescribedBy': 'por {name}',
  'lots.treatments.row.withdrawal': 'Retiro {days} d — hasta {until}',
  'lots.treatments.row.noWithdrawal': 'Sin periodo de retiro',
  'lots.treatments.row.deleted': 'Eliminado: {reason}',
  'lots.treatments.withdrawalRunning': 'Periodo de retiro vigente hasta {until}: no cosechar.',
  'lots.treatments.withdrawalWarning': 'Dentro del periodo de retiro de {product} hasta {until}. Cosechar ahora incumple el periodo de retiro.',
  'density.unitType.fibreglassTank': 'Tanque de fibra de vidrio',
  'lots.unitOccupied.warning': 'Esta unidad ya tiene el lote {lots}. La granja trabaja con un lote por unidad: muévelo o cósechalo antes, salvo que sea parte de una división o unión.',
  'lots.unitOccupied.short': 'ya tiene el lote {lots}',
  'lots.hatchery.field.vonBayerCount': 'Ovas en 30,5 cm (regla Von Bayer)',
  'lots.hatchery.arrival.vonBayerDiameter': 'Diámetro de la ova según Von Bayer: {mm} mm (304,8 mm ÷ ovas).',
  'lots.stockUnits.kind': '¿Peces u ovas?',
  'lots.stockUnits.kindFish': '🐟 Peces',
  'lots.stockUnits.kindEggs': '🥚 Ovas',
  'lots.stockUnits.totalEggs': 'Ovas que llegaron',
  'lots.stockUnits.eggArrival': 'Recepción de ovas (la misma para todas las incubadoras)',
  'lots.stockUnits.eggArrivalLater': 'Si aún no tienes todos los datos, puedes completarlos después en Lote → Incubación.',
  'lots.stockUnits.incubators': 'Incubadoras y ovas por incubadora',
  'lots.stockUnits.eggsPerUnit': 'Ovas',
  'lots.stockUnits.averageWeightHint': 'Valor para todas las unidades; el peso propio de una unidad (junto a su conteo) tiene prioridad.',
  'lots.stockUnits.weightPerUnit': 'Peso (g), opcional',
  'lots.stockUnits.weightPerUnitFor': 'Peso de llegada (g) para {unit}',
  'lots.stockUnits.error.eggCountsNeeded': 'Indica las ovas de cada incubadora (serán el stock de cada lote).',
  'crewMode.feed.givePlanDetail': '1 de {feedings} tomas · {kgDay} kg/día',
  'feed.farmTable.today': 'hoy',
  'feed.farmTable.daysAgo': 'hace {days} d',
  'feed.farmTable.staleTitle': 'Este dato tiene {days} días: registra un nuevo muestreo o lectura de agua.',
  'feed.farmTable.eggCount': '{count} ovas',
  'createMember.title': 'Nuevo miembro',
  'createMember.lead': 'Elige qué tipo de miembro es; solo se muestran los datos que necesita.',
  'createMember.kindQuestion': '¿Qué tipo de miembro?',
  'createMember.kind.operator': 'Operador (solo PIN)',
  'createMember.kind.operatorHelp': 'Registra en Crew Mode desde un celular del equipo con un PIN de 4 dígitos. Sin correo ni contraseña.',
  'createMember.kind.person': 'Persona con acceso web',
  'createMember.kind.personHelp': 'Oficina o supervisor: entra a la web con correo o usuario y contraseña.',
  'createMember.kind.device': 'Celular del equipo (cuenta de dispositivo)',
  'createMember.kind.deviceHelp': 'Una por cada celular compartido. El celular inicia sesión una vez; luego cada operador solo ingresa su PIN.',
  'createMember.field.name': 'Nombre completo',
  'createMember.field.deviceName': 'Nombre del celular',
  'createMember.devicePlaceholderName': 'Celular equipo 1',
  'createMember.field.pin': 'PIN (4 dígitos, opcional ahora)',
  'createMember.field.email': 'Correo',
  'createMember.field.emailPlaceholder': 'persona@ejemplo.com',
  'createMember.field.deviceEmailPlaceholder': 'un correo que controles, p. ej. tu+celular1@…',
  'createMember.field.username': 'Usuario',
  'createMember.field.password': 'Contraseña temporal',
  'createMember.field.passwordPlaceholder': 'Al menos {min} caracteres',
  'createMember.field.role': 'Rol',
  'createMember.role.viewer': 'Lector — ve todo, no cambia nada',
  'createMember.role.contributor': 'Colaborador — registra datos',
  'createMember.role.editor': 'Editor — registra y edita la configuración',
  'createMember.note.operator': 'Al crearlo, el operador aparece en el teclado de PIN de cada celular del equipo la próxima vez que abra con conexión.',
  'createMember.note.device': 'Rol: colaborador (el mínimo que puede guardar registros). Nunca inicies sesión en un celular del equipo con una cuenta de administrador.',
  'createMember.note.person': 'La contraseña es temporal: comparte el usuario por un canal seguro, o envíale un enlace de activación desde Consola del dueño para que elija la suya.',
  'createMember.error.name': 'Escribe un nombre.',
  'createMember.error.email': 'Escribe un correo válido.',
  'createMember.error.usernameLength': 'El usuario debe tener entre 3 y 40 caracteres.',
  'createMember.error.usernameFormat': 'El usuario admite letras, números, punto, guion y guion bajo.',
  'createMember.error.password': 'La contraseña debe tener al menos {min} caracteres.',
  'createMember.error.credentials': 'Para este tipo de miembro se necesitan correo, usuario y contraseña.',
  'createMember.error.generic': 'No se pudo crear el miembro.',
  'createMember.error.emailTaken': 'Ese correo ya lo usa otra cuenta.',
  'createMember.error.usernameTaken': 'Ese usuario ya existe. Elige otro.',
  'createMember.submit': 'Crear miembro',
  'createMember.creating': 'Creando…',
  'createMember.created.title': '{name} creado',
  'createMember.created.operatorWithPin': 'PIN guardado. El operador ya puede registrar en cualquier celular del equipo: abre el ícono de la app, elige su nombre e ingresa el PIN.',
  'createMember.created.operatorNoPin': 'Aún sin PIN: asígnalo en Consola del dueño (PIN en su fila) antes de que registre.',
  'createMember.created.deviceTitle': 'Configura el celular (una sola vez):',
  'createMember.created.deviceStep1': 'En el celular, abre Chrome en app.sunflowsoftware.com/crew.',
  'createMember.created.deviceStep2': 'Inicia sesión con el usuario {username} y esta contraseña; el celular la recuerda.',
  'createMember.created.deviceStep3': 'Menú de Chrome → Agregar a la pantalla principal. Desde ahí cada operador toca el ícono e ingresa su PIN.',
  'createMember.created.deviceStepIphone': 'En iPhone: abre Safari en la misma dirección → Compartir → Agregar a inicio.',
  'createMember.created.personNext': 'Comparte el usuario {username} y la contraseña temporal por un canal seguro, o envía un enlace de activación desde Consola del dueño para que elija la suya. La contraseña no se puede volver a mostrar.',
  'createMember.created.username': 'Usuario: {username}',
  'createMember.created.copyUsername': 'Copiar usuario',
  'createMember.created.another': 'Agregar otro miembro',
  'createMember.created.back': 'Volver a Consola del dueño',
  'createMember.technicalDetails': 'Detalles técnicos',
  'qa.carryingCapacity': 'Capacidad de carga',
  'editFarm.density.movedHint': 'Los límites de densidad y el caudal mínimo ahora son tablas con nombre (una por genética o temporada), y cada lote guarda la tabla que se le asignó:',
  'editFarm.density.openCapacity': 'abrir Capacidad de carga →',
  'capacity.title': 'Capacidad de carga',
  'capacity.subtitle': 'Densidad máxima y caudal mínimo por peso, tipo de unidad y temperatura.',
  'capacity.table': 'Tabla:',
  'capacity.default': 'predeterminada',
  'capacity.defaultBadge': 'Predeterminada de la instalación',
  'capacity.noTables': 'Aún no hay tablas',
  'capacity.newTableOption': '(tabla nueva, sin guardar)',
  'capacity.empty': 'Esta instalación aún no tiene tablas. Usa «Nueva tabla».',
  'capacity.action.new': 'Nueva tabla',
  'capacity.action.duplicate': 'Duplicar',
  'capacity.action.makeDefault': 'Usar como predeterminada',
  'capacity.action.delete': 'Eliminar',
  'capacity.action.deleteConfirm': '¿Eliminar «{name}»? Toca otra vez',
  'capacity.action.applyToLots': 'Aplicar también a esos lotes ({count})',
  'capacity.copyName': '{name} (copia)',
  'capacity.usedBy': 'Usada por: {lots}',
  'capacity.usedByLot': '{lot} ({units}), copia del {date}',
  'capacity.unused': 'Ningún lote activo tiene su propia copia de esta tabla.',
  'capacity.withoutCopy': '{count} lote(s) activo(s) sin tabla propia usan la predeterminada.',
  'capacity.copiesNote': 'Esos lotes siguen con la copia que se les asignó: lo que guardes aquí aplica a lotes nuevos. Para darles los nuevos valores, usa «Aplicar también a esos lotes».',
  'capacity.field.name': 'Nombre de la tabla',
  'capacity.field.namePlaceholder': 'p. ej., OP 2025-10',
  'capacity.density.title': '1 · Densidad máxima (kg/m³)',
  'capacity.density.help': 'Por peso promedio y tipo de unidad. Vacío = sin límite. Ámbar desde el 90 % del límite, rojo al superarlo (Biomasa, Alimento). Las ovas y alevines con saco se controlan con la sección 3.',
  'capacity.flow.title': '2 · Caudal mínimo (L/min por kg)',
  'capacity.flow.help': 'Por peso promedio y temperatura del agua (con agua más cálida se necesita más caudal). Vacío = sin mínimo. Se compara en Agua con el último caudal de la unidad y la temperatura de ese día; ámbar cuando el margen es menor al 10 %, rojo por debajo del mínimo.',
  'capacity.flow.addTemperature': '+ Agregar banda de temperatura',
  'capacity.flow.anyTemperature': 'cualquier temperatura',
  'capacity.flow.moreThan': 'más de {temperature} °C',
  'capacity.flow.upToTemperature': 'hasta (°C)',
  'capacity.flow.weightUpTo': 'hasta {weight} g',
  'capacity.flow.cellLabel': 'Caudal mínimo L/min por kg',
  'capacity.hatchery.title': '3 · Incubación: caudal mínimo por 1.000 ovas / alevines con saco',
  'capacity.hatchery.help': 'Referencia técnica (trucha): 1 L/min por cada 1.000 ovas embrionadas. Se compara en Lote → Incubación y en Agua con el último caudal de la unidad.',
  'capacity.error.name': 'Ponle un nombre a la tabla.',
  'capacity.error.nameTaken': 'Otra tabla ya usa este nombre.',
  'capacity.error.values': 'Usa números positivos (o deja la celda vacía).',
  'capacity.error.weights': 'El peso de cada banda debe ser mayor que el de la banda anterior.',
  'capacity.error.temperatures': 'Cada banda de temperatura necesita un valor mayor que el de la anterior.',
  'capacity.status.saved': '«{name}» guardada.',
  'capacity.status.default': '«{name}» es ahora la predeterminada de la instalación.',
  'capacity.status.deleted': '«{name}» eliminada.',
  'capacity.status.applied': 'Nuevos valores aplicados a {count} lote(s).',
  'capacity.status.saveFailed': 'No se pudo guardar. Revisa la conexión e inténtalo de nuevo.',
  'capacity.picker.label': 'Capacidad de carga',
  'capacity.picker.default': '{name} (predeterminada)',
  'capacity.picker.none': 'Sin tabla',
  'capacity.picker.help': 'Límites de densidad y caudal para la genética de este lote (Configuración → Capacidad de carga). El lote guarda una copia.',
  'capacity.lot.copy': '{name} · copia del {date}',
  'capacity.lot.facilityDefault': '{name} (predeterminada de la instalación, sin copia propia)',
  'capacity.lot.change': 'Cambiar',
  'capacity.lot.changeHelp': 'Aplica a toda la llegada: todas las unidades de este lote y su registro de llegada.',
  'capacity.flow.minimumLabel': 'mínimo {minimum}',
  'capacity.status.overLimit': '▲ sobre el límite',
  'capacity.status.nearLimit': 'cerca del límite',
  'capacity.status.underMinimum': '▼ bajo el mínimo',
  'capacity.status.nearMinimum': 'cerca del mínimo',
  'density.nearLimitTitle': 'Al 90 % o más del límite de densidad para este peso y tipo de unidad (Capacidad de carga).',
  'water.capacity.fish': '{lot}: caudal {flow} L/min ({date}) · {perKg} L/min por kg · mínimo {minimum} a {temperature} °C ({table})',
  'water.capacity.hatchery': '{lot}: caudal {flow} L/min ({date}) · {perThousand} L/min por 1.000 · mínimo {minimum} ({table})',
  'lots.hatchery.flowMinimum': 'Mínimo {minimum} L/min por 1.000 ({table})',
  'lots.hatchery.field.broodstockGroup': 'Grupo de reproductores / origen',
  'lots.hatchery.field.spawningDate': 'Fecha de desove (fertilización)',
  'lots.hatchery.input.broodstockGroup': 'reproductores {group}',
  'lots.hatchery.input.spawningDate': 'desove {date}',
  'reports.column.temperatureDaysBorrowed': 'De ellos, de otra unidad de la misma llegada o del punto de medición',
  'reports.column.broodstockGroup': 'Grupo de reproductores / origen',
  'reports.column.spawningDate': 'Fecha de desove',
  'lots.move.dateLabel': 'Fecha del traslado',
  'lots.move.dateHelp': 'Día y hora en que se movieron los peces (hora de la granja).',
  'lots.move.sameLot.title': '{unit} ya tiene {lot}. Los peces se suman a ese lote.',
  'lots.move.sameLot.fishLabel': 'Peces que pasan',
  'lots.move.sameLot.loadingStock': 'Calculando el stock…',
  'lots.move.sameLot.sourceStock': 'de {count} en {unit} a esa fecha',
  'lots.move.sameLot.sourceStockUnknown': '{unit} no tiene conteo a esa fecha.',
  'lots.move.sameLot.preview': '{source}: {sourceBefore} → {sourceAfter} · {target}: {targetBefore} → {targetAfter}',
  'lots.move.sameLot.targetStockUnknown': '{unit} no tiene conteo a esa fecha: después del traslado registra un Conteo en Biomasa.',
  'lots.move.sameLot.help': 'Se registra un conteo en cada unidad con su stock nuevo. {unit} sigue activo con los peces que quedan.',
  'lots.move.sameLot.closesSource': 'Pasan todos: {unit} queda cerrado (Inactivo) y sus peces siguen en {target}.',
  'lots.move.sameLot.countNote': 'Traslado: {count} peces de {source} a {target}',
  'lots.move.sameLot.done': 'Traslado registrado: {count} peces de {lot} de {source} a {target}.',
  'lots.move.sameLot.doneClosed': 'Traslado registrado: {count} peces de {lot} de {source} a {target}. {source} quedó cerrado.',
  'lots.move.arrival.label': 'Cantidad que llega a {unit}',
  'lots.move.arrival.help': 'Stock del lote en {unit} a esa fecha: {count}. Corrígelo si contaron otra cifra; queda como conteo en la unidad nueva.',
  'lots.move.arrival.helpUnknown': 'El lote no tiene conteo a esa fecha. Escribe cuántos llegan a {unit}, o déjalo vacío y registra un Conteo después.',
  'lots.move.arrival.countNote': 'Llegada por traslado desde {source}',
  'lots.move.arrival.offline': 'Traslado guardado sin conexión: cuando vuelva la señal, registra un Conteo de {lot} en {unit} en Biomasa.',
  'lots.move.error.arrivalInvalid': 'Escribe la cantidad que llega como un número entero, o déjala vacía.',
  'lots.move.checkingDestination': 'Revisando qué lotes hay en la unidad de destino…',
  'lots.move.error.dateRequired': 'Indica el día y la hora del traslado.',
  'lots.move.error.future': 'La fecha del traslado está en el futuro. Usa el día y la hora en que se movieron los peces.',
  'lots.move.error.beforeArrival': 'La fecha del traslado es anterior a la llegada de {lot} a su unidad actual. Usa una fecha posterior.',
  'lots.move.error.recordsAfter': 'Hay registros de {lot} en {unit} después de esa fecha (último: {date}). Usa esa fecha o una posterior.',
  'lots.move.error.fishRequired': 'Escribe cuántos peces pasan (un número entero mayor que 0).',
  'lots.move.error.fishMoreThanSource': 'Son más peces de los que hay en {unit} ({count}).',
  'lots.move.error.nameTaken': 'Esa unidad ya tiene un lote llamado {lot}. Elige otra unidad u otro nombre.',
  'lots.move.error.sameLotInvalid': 'Los peces solo pueden sumarse al mismo lote, activo, en otra unidad de la misma instalación.',
  'lots.move.error.offline': 'Sumar peces a otro lote necesita conexión. Inténtalo cuando haya internet.',
  'lots.move.editUnitLocked': 'Para cambiar de unidad usa',
  'lots.history.facilityLevel': '{facility} (instalación)',
  'lots.history.stageChange': 'Etapa: {from} → {to} ({date})',
  'lots.history.eggArrival': 'Recepción de ovas: {details}',
  'lots.history.eggArrival.eggs': '{eggs} ovas',
  'lots.history.eggArrival.tua': '{tua} UTA a la llegada',
  'lots.history.stageSet': 'Etapa: {to} ({date})',
  'lots.history.capacityTable': 'Tabla de capacidad de carga asignada',
  'lots.history.restored': 'Lote restaurado (había sido eliminado)',
  'lots.deleted.title': 'Lotes eliminados ({count})',
  'lots.deleted.help': 'Un lote eliminado se puede restaurar tal como estaba, en su misma unidad. Sus registros nunca se borraron.',
  'lots.deleted.row': '{lot} · {unit} · eliminado el {date}',
  'lots.deleted.restore': 'Restaurar',
  'lots.deleted.restoring': 'Restaurando…',
  'lots.deleted.restored': '{lot} restaurado en {unit}.',
  'lots.deleted.offline': 'Restaurar un lote necesita conexión.',
  'lots.deleted.error': 'No se pudo restaurar {lot}: {reason}',
  'lots.deleted.empty': 'No hay lotes eliminados en esta instalación.',
  'lots.history.dataUpdated': 'Datos del lote actualizados',
  'lots.history.fishMove': 'Traslado: {count} peces de {source} a {target}',
  // Findings #199: Importar (Hoja diaria).
  'import.page.title': 'Importar registros',
  'import.page.subtitle': 'Carga los registros diarios de lotes anteriores (conteos, muestreos, mortalidad y alimento) desde una hoja CSV.',
  'import.page.waterHint': 'Lecturas de agua:',
  'import.page.waterLink': 'importación de Agua (avanzada, solo administradores)',
  'import.daily.before.title': 'Antes de importar',
  'import.daily.before.step1': 'Crea cada lote en Lotes con su fecha de siembra real (Nuevo lote, Sembrar en varias unidades u Ovas recibidas).',
  'import.daily.before.lotsLink': 'Ir a Lotes',
  'import.daily.before.step2': 'Registra sus traslados en Lotes → Acciones → Trasladar lote, con la Fecha del traslado real, del más antiguo al más reciente.',
  'import.daily.before.step3': 'Descarga la plantilla, llénala (una línea por unidad, lote y día) y cárgala aquí. Revisa la vista previa y guarda.',
  'import.daily.before.noLots': 'La importación nunca crea lotes ni traslados: si un lote no existe en esa unidad y fecha, la línea te dirá qué hacer en Lotes.',
  'import.daily.facility': 'Instalación',
  'import.daily.template.download': 'Descargar plantilla (CSV)',
  'import.daily.template.help': 'Ábrela en Excel, llénala y guárdala como CSV. Fechas como 2026-09-20 o 20/09/2026; decimales con punto o coma. Conteo: peces vivos al final del día, ya sin la mortalidad de ese día.',
  'import.daily.template.fileName': 'plantilla-hoja-diaria.csv',
  'import.daily.template.arrival': 'Llegada',
  'import.daily.template.sample': 'Muestreo de 50 peces',
  'import.daily.column.date': 'Fecha',
  'import.daily.column.unit': 'Unidad',
  'import.daily.column.lot': 'Lote',
  'import.daily.column.count': 'Conteo',
  'import.daily.column.method': 'Método',
  'import.daily.column.weight': 'Peso promedio (g)',
  'import.daily.column.mortality': 'Mortalidad',
  'import.daily.column.feed': 'Alimento (kg)',
  'import.daily.column.notes': 'Notas',
  'import.daily.method.exact': 'exacto',
  'import.daily.kind.count': 'Conteo',
  'import.daily.kind.weight': 'Peso',
  'import.daily.kind.mortality': 'Mortalidad',
  'import.daily.kind.feed': 'Alimento',
  'import.daily.file': 'Archivo CSV',
  'import.daily.fileHelp': 'Elige el archivo de la hoja diaria. Nada se guarda hasta que pulses Guardar.',
  'import.daily.fileLoaded': 'Archivo cargado: {name}',
  'import.daily.loading': 'Revisando los lotes y sus traslados…',
  'import.daily.loadError': 'No se pudieron revisar los lotes de esta instalación: {reason}',
  'import.daily.readOnly': 'Puedes revisar el archivo, pero solo un editor o administrador puede guardar.',
  'import.daily.preview.title': 'Vista previa',
  'import.daily.preview.totals': '{lines} líneas: {counts} conteos, {weights} muestreos, {mortalities} mortalidades, {feeds} alimentaciones · {errors} líneas con errores',
  'import.daily.preview.fixFirst': 'Corrige las líneas con error en tu archivo y vuelve a cargarlo. No se guarda nada mientras haya errores.',
  'import.daily.preview.onlyProblems': 'Mostrar solo líneas con errores o avisos',
  'import.daily.preview.line': 'Línea',
  'import.daily.preview.values': 'Datos',
  'import.daily.preview.status': 'Estado',
  'import.daily.preview.ready': 'Lista',
  'import.daily.save': 'Guardar {count} líneas',
  'import.daily.saving': 'Guardando…',
  'import.daily.saveError': 'No se pudo guardar: {reason}',
  'import.daily.saved.title': 'Importación guardada',
  'import.daily.saved.summary': '{counts} conteos, {weights} muestreos, {mortalities} mortalidades y {feeds} alimentaciones.',
  'import.daily.saved.synced': 'Todo quedó guardado en el servidor.',
  'import.daily.saved.offline': 'Sin conexión: los registros quedaron en este equipo y se enviarán al volver la conexión.',
  'import.daily.saved.blocked': '{count} registros no se pudieron enviar al servidor. Revisa la barra de sincronización.',
  'import.daily.saved.review': 'Revísalos en',
  'import.daily.saved.biomass': 'Biomasa',
  'import.daily.saved.database': 'Base de datos',
  'import.daily.issue.empty': 'El archivo está vacío.',
  'import.daily.issue.missingColumn': 'Falta la columna "{column}". Usa la plantilla.',
  'import.daily.issue.noValueColumns': 'El archivo no tiene ninguna columna de datos (Conteo, Peso promedio (g), Mortalidad o Alimento (kg)). Usa la plantilla.',
  'import.daily.issue.dateMissing': 'Falta la fecha.',
  'import.daily.issue.dateInvalid': 'No se entiende la fecha "{value}". Usa 2026-09-20 o 20/09/2026.',
  'import.daily.issue.dateFuture': 'La fecha {date} es futura.',
  'import.daily.issue.unitMissing': 'Falta la unidad.',
  'import.daily.issue.unitUnknown': 'La unidad "{unit}" no existe en {facility}.',
  'import.daily.issue.lotNameMissing': 'Falta el lote.',
  'import.daily.issue.methodInvalid': 'Método "{value}" no válido: usa exacto o estimación.',
  'import.daily.issue.methodWithoutCount': 'Hay método pero no conteo.',
  'import.daily.issue.countInvalid': 'Conteo "{value}" no válido: debe ser un número entero.',
  'import.daily.issue.weightInvalid': 'Peso "{value}" no válido: gramos por pez, mayor que 0.',
  'import.daily.issue.mortalityInvalid': 'Mortalidad "{value}" no válida: debe ser un número entero.',
  'import.daily.issue.feedInvalid': 'Alimento "{value}" no válido: kilos, por ejemplo 0.7.',
  'import.daily.issue.noValues': 'La línea no tiene ningún dato: llena Conteo, Peso, Mortalidad o Alimento.',
  'import.daily.issue.duplicateLine': 'Repite la unidad, el lote y el día de la línea {line}: junta los datos en una sola línea.',
  'import.daily.issue.lotAmbiguous': 'Hay más de un lote {lot} en {unit} el {date}. Revisa los lotes en Lotes.',
  'import.daily.issue.lotDeleted': 'El lote {lot} de {unit} fue eliminado. Restáuralo en Lotes → Lotes eliminados, o corrige la línea.',
  'import.daily.issue.beforeLotInUnit': 'El {date} el lote {lot} todavía no estaba en {unit} (está desde el {from}). Revisa la fecha, o la Fecha de siembra o del traslado en Lotes.',
  'import.daily.issue.lotLeftUnit': 'El {date} el lote {lot} ya no estaba en {unit} (salió el {to}). Revisa la fecha o la unidad.',
  'import.daily.issue.lotInOtherUnit': 'El lote {lot} nunca estuvo en {unit} (está en {units}). Si llegó a {unit} por un traslado, regístralo primero en Lotes → Trasladar lote con su fecha real.',
  'import.daily.issue.lotMissingSuggestion': 'El lote {lot} no existe en {unit}. ¿Quisiste decir {suggestion}?',
  'import.daily.issue.lotMissing': 'El lote {lot} no existe en {facility}. Créalo primero en Lotes con su fecha de siembra y vuelve a cargar el archivo.',
  'import.daily.issue.alreadyOnScreens': 'Ese día ya hay {kinds} de este lote registrado en la app; se agregará además el de la hoja.',
  'datatable.lot.createInLotsHint': 'Si el lote no existe, créalo en Lotes con su fecha de siembra.',
  'water.lot.createInLotsHint': 'Si el lote no existe, créalo en Lotes con su fecha de siembra.',
  'lots.history.fieldChange': '{field}: {from} → {to}',
  'lots.history.disinfection': 'Desinfección:',
  'lots.history.stockTraits': 'Características del stock',
  'lots.history.yes': 'sí',
  'lots.history.no': 'no',
  // Findings #204: deaths during a move.
  'lots.move.died.label': 'Murieron en el traslado',
  'lots.move.died.help': 'Opcional. Se registran como Mortalidad en {unit} (causa Manipulación), justo antes del traslado. Si el equipo ya las anotó en Mortalidad, no las repitas aquí.',
  'lots.move.died.invalid': 'Escribe un número entero de peces (o déjalo vacío).',
  'lots.move.died.note': 'Mortalidad en traslado de {source} a {target}',
  'lots.move.died.previewDeaths': '{count} muertos en el traslado (mortalidad en {unit})',
  'lots.move.error.fishAndDeathsMoreThanSource': 'Los peces que pasan más los que murieron son más de los que hay en {unit} ({count}).',
  'lots.move.arrival.short': 'Llegan {arrival} de los {expected} que salieron: faltan {missing}.',
  'lots.move.arrival.shortDied': 'Murieron en el traslado: registrar {missing} como mortalidad',
  'lots.move.arrival.shortCount': 'Si no murieron (fue un error del conteo anterior), deja la cifra así: queda como corrección del conteo.',
  // Findings #210 / #211: transfer protocol, stop rules and oxygen
  'crewMode.feed.hold.stopTitle': 'No alimentar ahora',
  'crewMode.feed.hold.tempLow': 'Temperatura {value} °C ({time}) — mínimo {limit} °C',
  'crewMode.feed.hold.tempHigh': 'Temperatura {value} °C ({time}) — máximo {limit} °C',
  'crewMode.feed.hold.doLow': 'O2 entrada {value} mg/L ({time}) — mínimo {limit} mg/L',
  'crewMode.feed.hold.stopHelp': 'Avisa al supervisor. Vuelve a medir antes de la siguiente toma.',
  'crewMode.feed.hold.fastTitle': 'Ayuno hoy',
  'crewMode.feed.hold.fastHelp': 'Traslado el {date}: no dar alimento a este lote hoy.',
  'crewMode.feed.hold.measure': 'Medir agua',
  'crewMode.feed.hold.override': 'Registrar igual (el supervisor autorizó)',
  'crewMode.feed.hold.overrideConfirm': '¿El supervisor autorizó alimentar? El registro guarda el motivo.',
  'crewMode.feed.hold.overrideYes': 'Sí, registrar igual',
  'crewMode.feed.hold.missing': 'Sin lectura de {params} hoy: mide antes de alimentar.',
  'crewMode.feed.hold.missing.temperature': 'temperatura',
  'crewMode.feed.hold.missing.dissolvedOxygen': 'oxígeno',
  'crewMode.feed.hold.missingWithPoint': 'Sin lectura de {params} hoy aquí ni en {unit}: mide antes de alimentar.',
  'crewMode.feed.hold.measuredIn': 'medido en {unit}',
  'crewMode.feed.reduced.title': 'Ración reducida (día {day} de {of})',
  'crewMode.feed.reduced.give': 'Dar {kg} kg hoy (plan normal {plan} kg)',
  'crewMode.feed.reduced.giveNoPlan': 'Dar {kg} kg hoy',
  'crewMode.feed.reduced.noKg': 'Da menos que el plan: la oficina no tenía temperatura para calcularla.',
  'crewMode.feed.reduced.backToNormal': 'Ya comen normal',
  'crewMode.feed.reduced.backToNormalDone': 'Vuelve al plan normal. Se anota con el próximo registro.',
  'editFarm.plans.rulesLabel': 'Cuándo no alimentar',
  'editFarm.plans.rules.temp': 'Temperatura fuera de',
  'editFarm.plans.rules.tempMin': 'Temperatura mínima (°C)',
  'editFarm.plans.rules.tempMax': 'Temperatura máxima (°C)',
  'editFarm.plans.rules.tempTo': 'a',
  'editFarm.plans.rules.do': 'O2 a la entrada menor que',
  'editFarm.plans.rules.help': 'Usa la última lectura de hoy de esta unidad. El equipo ve "No alimentar ahora" y solo registra si el supervisor autoriza. Sin lectura de hoy, el teléfono pide medir antes (no bloquea).',
  'editFarm.plans.rulesSummary.none': 'sin reglas',
  'editFarm.plans.rulesSummary.tempRange': 'T° fuera de {min}–{max} °C',
  'editFarm.plans.rulesSummary.tempBelow': 'T° menor que {min} °C',
  'editFarm.plans.rulesSummary.tempAbove': 'T° mayor que {max} °C',
  'editFarm.plans.rulesSummary.do': 'O2 entrada < {min} mg/L',
  'editFarm.plans.oxygenLabel': 'Oxígeno (cálculo)',
  'editFarm.plans.oxygen.outletMin': 'Mínimo a la salida (mg/L)',
  'editFarm.plans.oxygen.suggested': 'sugerido {value}',
  'editFarm.plans.oxygen.perKg': 'kg O2 por kg de alimento',
  'editFarm.plans.oxygen.help': 'Para "O2 alcanza" en Alimento → Toda la instalación: caudal × 1440 × (O2 entrada − mínimo a la salida) ÷ kg O2 por kg de alimento. Vacío = el sugerido y 0,25. El consumo de oxígeno sube por horas después de cada toma: si no alcanza, divide la ración en más tomas.',
  'editFarm.plans.error.rules': 'Revisa las reglas: temperaturas entre −5 y 40 °C (la mínima menor que la máxima) y O2 entre 0,1 y 20 mg/L.',
  'editFarm.plans.error.oxygen': 'Revisa el oxígeno: mínimo a la salida entre 0,1 y 20 mg/L y kg O2 por kg de alimento entre 0,05 y 1.',
  'editFarm.transferProtocol.title': 'Protocolo de traslado',
  'editFarm.transferProtocol.col.maxWeight': 'Peso hasta (g)',
  'editFarm.transferProtocol.col.fastDays': 'Ayuno antes (días)',
  'editFarm.transferProtocol.col.reducedDays': 'Ración reducida (días)',
  'editFarm.transferProtocol.col.deltaC': 'T° de cálculo −Δ °C',
  'editFarm.transferProtocol.openBand': 'más',
  'editFarm.transferProtocol.addRow': 'Agregar fila',
  'editFarm.transferProtocol.removeRow': 'Quitar',
  'editFarm.transferProtocol.help': 'Una fila por rango de peso (deja "Peso hasta" vacío para los peces más grandes). Lotes → lote → "Programar traslado" lo usa para los días de ayuno; Trasladar lote propone el rango según el último peso del lote y calcula la ración reducida: la ración para los peces que llegan, a la última temperatura del destino menos Δ °C. Debajo de la Matriz SFR se extrapola desde sus dos temperaturas más bajas.',
  'editFarm.transferProtocol.invalid': 'Revisa las filas: peso mayor que 0 (solo una fila sin peso, sin pesos repetidos), días enteros de 0 a 30 y Δ de 0 a 20 °C.',
  'feed.farmTable.col.oxygenCapacity': 'O2 alcanza (kg/día)',
  'feed.farmTable.oxygenHelp': 'Alimento que el agua puede sostener: último caudal × 1440 × (último O2 de entrada − mínimo a la salida) ÷ kg O2 por kg de alimento (Editar instalación → Unidades → plan). "—" = sin lectura de caudal u oxígeno. Rojo = el plan pasa de ese valor.',
  'feed.farmTable.overOxygenTitle': 'El plan pasa de lo que el oxígeno alcanza: bájalo o divídelo en más tomas.',
  'feed.farmTable.stoppedToday': 'hoy',
  'feed.farmTable.stoppedTitle': 'La última lectura de hoy rompe la regla "Cuándo no alimentar" de la unidad: el equipo ve "No alimentar ahora".',
  'feed.farmTable.fastingToday': 'Ayuno hoy (traslado)',
  'feed.farmTable.reducedToday': 'Ración reducida día {day} de {of}: {kg} kg/día',
  'lots.transferPlan.title': 'Traslado',
  'lots.transferPlan.schedule': 'Programar traslado',
  'lots.transferPlan.change': 'Cambiar',
  'lots.transferPlan.clear': 'Quitar',
  'lots.transferPlan.date': 'Fecha del traslado',
  'lots.transferPlan.band': 'Protocolo',
  'lots.transferPlan.proposedBand': 'Fila {band} (según el último peso)',
  'lots.transferPlan.chooseBand': 'Elige una fila',
  'lots.transferPlan.bandOption': 'Fila {band}: {weight} · ayuno {fast} d · reducida {days} d · −{delta} °C',
  'lots.transferPlan.openBand': 'más',
  'lots.transferPlan.planned': 'Traslado programado: {date} · Ayuno: {fasting} · Ración reducida {days} días a T° −{delta} °C',
  'lots.transferPlan.noFasting': 'sin ayuno',
  'lots.transferPlan.help': 'El teléfono muestra "Ayuno hoy" los días de ayuno. El traslado se registra en Trasladar lote.',
  'lots.transferPlan.lastMove': 'Último traslado: {date}.',
  'lots.transferPlan.ration': 'Ración reducida {kg} kg/día por {days} días (T° −{delta} °C).',
  'lots.transferPlan.rationNoKg': 'Ración reducida por {days} días, sin kg (sin temperatura, peso o stock al trasladar).',
  'lots.transferPlan.extrapolated': 'Fuera de tabla (extrapolado).',
  'lots.transferPlan.today': 'Hoy: día {day} de {of}.',
  'lots.transferPlan.fastingRecord': 'Ayuno',
  'lots.transferPlan.fastingKept': '{date}: sin alimento registrado ✓',
  'lots.transferPlan.fastingFed': '{date}: {kg} kg registrados',
  'lots.transferPlan.invalid': 'Elige una fecha desde hoy y una fila del protocolo.',
  'lots.transferPlan.saveFailed': 'No se pudo guardar. Inténtalo de nuevo.',
  'lots.transferProtocol.title': 'Protocolo de traslado',
  'lots.transferProtocol.proposed': '{band} (último peso {weight} g)',
  'lots.transferProtocol.noWeight': 'Elige una fila (el lote no tiene peso)',
  'lots.transferProtocol.none': 'Sin protocolo en este traslado',
  'lots.transferProtocol.band.upTo': 'hasta {max} g',
  'lots.transferProtocol.band.between': '{min}–{max} g',
  'lots.transferProtocol.band.above': 'más de {min} g',
  'lots.transferProtocol.band.all': 'todos los pesos',
  'lots.transferProtocol.fastingPlanned': 'Ayuno programado: {days} (traslado programado para el {date}).',
  'lots.transferProtocol.noFasting': 'Traslado programado para el {date}, sin ayuno.',
  'lots.transferProtocol.noReducedDays': 'Esta fila no tiene días de ración reducida.',
  'lots.transferProtocol.ration': 'Ración reducida por {days} días: {kg} kg/día ({fish} peces × {weight} g a {temperature} − {delta} = {calc} °C).',
  'lots.transferProtocol.rationExtrapolated': 'Ración reducida por {days} días: {kg} kg/día ({fish} peces × {weight} g a {temperature} − {delta} = {calc} °C), fuera de tabla (extrapolado).',
  'lots.transferProtocol.rationMissing': 'Ración reducida por {days} días, sin kg: falta {missing}. El teléfono muestra los días reducidos con el plan normal.',
  'lots.transferProtocol.missing.temperature': 'una temperatura en la unidad de destino',
  'lots.transferProtocol.missing.weight': 'un peso del lote',
  'lots.transferProtocol.missing.stock': 'la cantidad de peces',
  'lots.transferProtocol.fromDay': 'Desde el {date}.',
  'lots.transferProtocol.saveFailed': 'El traslado se guardó, pero no su ración reducida. Avísanos con el lote y la fecha.',
}
